import {
  ACTIONS_CATEGORIES,
  CONFLUENCE,
  DATEV_ACCOUNTING,
  DATEV_HR,
  GOOGLE_DOCS,
  GOOGLE_SHEETS,
  JIRA,
  MICROSOFT_D365,
  MICROSOFT_ONEDRIVE,
  MICROSOFT_SHAREPOINT,
  MICROSOFT_TEAMS,
  OUTLOOK_CALENDAR,
  OUTLOOK_EMAIL,
  PERSONA_TYPE,
  SAP_S4HANA,
  SQL_DATABASE
} from 'src/types/enum';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

const itJson = {
  // General
  [T.empowerGPT]: 'EmpowerGPT',
  [T.knowledgeBaseChat]: 'Chat della base di conoscenza',
  [T.enterprise]: 'Aziendale',
  [T.worldKnowledge]: 'Conoscenza del mondo',
  [T.noKnowledgeAccess]: 'Non hai accesso',
  [T.generalChat]: 'Chat generale',
  [T.languageSwitcher]: 'Seleziona lingua',
  [T.logout]: 'Disconnettersi',
  [T.profile]: 'Profilo',
  [T.uploadImport]: 'Carica / Importa',
  [T.documents]: 'Documenti',
  [T.conversations]: 'Conversazioni fatte',
  [T.valuableInsights]: 'Estrai rapidamente informazioni preziose',
  [T.uploadFiles]: 'Carica i file',
  [T.clearFilters]: 'Reimposta',
  [T.resetFilters]: 'Reimposta filtri',
  [T.resetPassword]: 'Cambia Password',
  [T.userGroups]: 'Gruppi Utente',
  [T.userGroupName]: 'Nome del Gruppo Utente',
  [T.accountType]: 'Tipo di Account',
  [T.email]: 'E-mail',
  [T.expand]: 'Espandi',
  [T.startChat]: 'Inizia Chat',
  [T.addToChat]: 'Aggiungi alla chat',
  [T.addToAssistant]: "Aggiungi all'assistente",
  [T.addToDataset]: 'Aggiungi al set di dati',
  [T.createdWithTime]: 'Creato {{time}} fa',
  [T.modifiedWithTime]: 'Modificato {{time}} fa',
  [T.syncedWithTime]: 'Sincronizzato {{time}} fa',
  [T.rolesAndPermissions]: 'Ruoli e Autorizzazioni',
  [T.selectItemsToDelete]: 'Seleziona gli elementi da eliminare',
  [T.selectItemsToTag]: 'Seleziona gli elementi da contrassegnare',
  [T.selectItemsToMove]: 'Seleziona gli elementi da spostare',
  [T.noPermissionToDelete]: 'Non hai il permesso di eliminare',
  [T.noPermissionToView]: 'Non hai il permesso di visualizzare',
  [T.noPermissionToMoveHere]: 'Non hai il permesso di spostare qui',
  [T.noPermissionToDownload]: 'Non hai il permesso di scaricare',
  [T.tagDisabledForWorkspaceChat]:
    'La funzionalità di tag non è disponibile per le chat dello spazio di lavoro',
  [T.typeToSearch]: 'Digita per cercare',
  [T.disclaimerEgpt]: `L'AI Model può commettere errori, si prega di verificare con le citazioni fornite.`,
  [T.usage]: 'Utilizzo',
  [T.inPlanUsage]: 'Utilizzo nel piano',
  [T.reprocess]: 'Riprocessare',
  [T.invalidFileType]: 'Tipo di file non valido',
  [T.selectItemsToReprocess]: 'Seleziona gli elementi da riprocessare',
  [T.chatGPT]: 'ChatGPT',
  [T.fileProcessing]: 'Elaborazione di File',
  [T.enterpriseKnowledgeChat]: 'Chat di conoscenza aziendale',
  [T.worldKnowledgeChat]: 'Chat di conoscenza del mondo',
  [T.ok]: 'OK',
  [T.goBack]: 'Indietro',
  [T.settings]: 'Impostazioni',
  [T.adminConsole]: 'Console di amministrazione',
  [T.llmsSettingsHeading]:
    'Modelli di intelligenza artificiale disponibili in chat',
  [T.selectModels]: 'Seleziona modelli',
  [T.modelsWarning]: 'Si prega di selezionare almeno un modello.',
  [T.version]: 'Versione',
  [T.configure]: 'Configurare',
  [T.tenantKnowledgeBase]: 'Conoscenza {{tenant}}',
  [T.noInternet]:
    'Nessuna connessione a Internet. Controllare la rete e riprovare.',
  [T.loading]: 'Caricamento',
  [T.addMore]: 'Aggiungi altro',
  [T.usageAndAnalytics]: 'Utilizzo e Analisi',
  [T.analytics]: 'Analisi',
  [T.userAndRoles]: 'Utenti e Ruoli',
  [T.menu]: 'Menù',
  [T.noFileName]: 'Nessun Nome del File',
  [T.inviteTeammates]: 'Invita i tuoi colleghi',
  [T.inviteTeammatesDescription]:
    'Offri ai tuoi colleghi un accesso rapido alle conoscenze fondamentali',
  [T.newestToOldest]: 'Dal più recente al meno recente',
  [T.oldestToNewest]: 'Dal meno recente al più recente',
  [T.aToZ]: 'A–Z',
  [T.zToA]: 'Z–A',
  [T.count]: 'Conteggio',

  //Filters
  [T.search]: 'Ricerca',
  [T.searchUser]: 'Cerca un utente',
  [T.searchTenant]: 'Cerca un tenant',
  [T.searching]: 'Ricerca...',
  [T.accountTypeSelect]: 'Seleziona il Tipo di Account',
  [T.selected]: `Selezionato`,
  [T.noOptions]: 'Nessuna opzione',
  [T.filters]: 'Filtri',
  [T.revokeAccess]: `Revoca dell'accesso`,

  // Documents
  [T.uploadDocs]: 'Carica Documenti',
  [T.tagDocuments]: 'Etichetta Documenti',
  [T.allDocuments]: 'Tutti i documenti',
  [T.docName]: 'Nome del Documento',
  [T.uploadedBy]: 'Caricato da',
  [T.uploadedOn]: 'Caricato il',
  [T.uploadedContent]: 'Contenuto caricato',
  [T.actions]: 'Azioni',
  [T.view]: 'Visualizza',
  [T.sync]: 'Sincronizza',
  [T.share]: 'Condividi',
  [T.shared]: 'Condiviso',
  [T.sharedWith]: 'Condiviso con',
  [T.invite]: 'Invita',
  [T.details]: "Panoramica sull'IA",
  [T.documentType]: 'Tipo di Documento',
  [T.size]: 'Dimensione',
  [T.length]: 'Lunghezza',
  [T.description]: 'Descrizione',
  [T.descriptionOptional]: 'Descrizione (opzionale)',
  [T.rowsPerPage]: 'Righe per pagina',
  [T.noRowsFound]: 'Nessuna riga trovata.',
  [T.uploadTimeAndDateWithUser]: 'Caricato il {{time}} da {{user}}',
  [T.download]: 'Scarica',
  [T.uploadProgress]: 'Caricare i progressi',
  [T.document]: 'Documento',
  [T.docsDropMessage]: 'Rilascia i documenti per iniziare il caricamento.',
  [T.uploadDocFailed]: 'Impossibile caricare i documenti.',
  [T.uploadDocsFailed]: 'Impossibile caricare il documento.',
  [T.uploadMessage]: 'Hai caricato ',
  [T.dropDocsMessage1]: 'Rilascia i documenti per iniziare il caricamento.',
  [T.dropDocsMessage2]: 'Trascina e rilascia i documenti qui.',
  [T.uploadDocsText]: 'Puoi caricare documenti, audio e video.',
  [T.dropDocsRestriction]: 'Non puoi caricare questi tipi di documenti.',
  [T.dropDocsPartialRestriction]:
    'Alcuni tipi di documenti non validi sono stati respinti.',
  [T.failedFetchingDocuments]: 'Recupero dei documenti non riuscito.',
  [T.uploadDocsSuccess]: '{{count}} documento(i) caricato(i) con successo.',
  [T.uploadStatusBoxMessage]: `{{count}} documento/i sono stati caricati con successo. Puoi chiudere la finestra.`,
  [T.uploadDocsWarningMessage]:
    '{{count}} documento(i) caricato(i) con successo e {{failed}} fallito(i). Riprovando...',
  [T.uploadDocSuccess]: '{{count}} documento caricato con successo!',
  [T.documentsUploadSuccess]: 'Documenti caricati con successo!',
  [T.searchDocuments]: 'Cerca Documenti',
  [T.enterTagName]: 'Inserisci il nome del tag',
  [T.folderCreateSuccess]: 'Cartella creata con successo!',
  [T.folderAndUrlSuccess]:
    'Cartella creata con successo! La generazione del link web è in corso.',
  [T.collectionCreateSuccess]: 'Raccolta creata con successo!',
  [T.workspaceCreateSuccess]: 'Spazio di lavoro creato con successo!',
  [T.folderCreateError]: 'Errore nella creazione della risorsa!',
  [T.folderCreateSuccessAccesError]:
    'Cartella creata con successo! Impossibile aggiornare i permessi di accesso.',
  [T.folderUpdateSuccessAccessError]:
    'Cartella aggiornata con successo! Impossibile aggiornare i permessi di accesso.',
  [T.selectTags]: 'Seleziona i Tag',
  [T.docTaggedSuccess]: 'Documenti etichettati con successo!',
  [T.docTaggedError]: "Errore nell'etichettatura dei documenti!",
  [T.docTagsDeleteSuccess]: 'Tag eliminati con successo!',
  [T.docTagsDeleteError]: 'Impossibile eliminare i tag!',
  [T.docTagsUpdatedSuccess]: 'Tag aggiornati con successo!',
  [T.docTagsUpdatedError]: 'Aggiornamento dei tag non riuscito!',
  [T.selectedTags]: 'Tag selezionati',
  [T.tags]: 'Tag',
  [T.selectUploadTags]: 'Seleziona i tag da applicare sui documenti caricati',
  [T.maxDocSize]:
    'La lunghezza del nome del documento "{{ name }}" supera il limite massimo di 200 caratteri.',
  [T.uploaded]: 'Caricato',
  [T.modifiedBy]: 'Modificato da',
  [T.syncedBy]: 'Sincronizzato da',
  [T.syncedOn]: 'Sincronizzato il',
  [T.syncing]: 'Sincronizzazione in corso...',
  [T.syncingInGridView]: `Attendere mentre la cartella viene sincronizzata...`,
  [T.syncingFailed]: 'Tentativo di sincronizzazione non riuscito',
  [T.syncingFileLimitReached]:
    'Limite massimo di sincronizzazione file raggiunto',
  [T.modifiedOn]: 'Modificato il',
  [T.status]: 'Stato',
  [T.documentDeletionFailed]: 'Eliminazione documento non riuscita.',
  [T.attachedFile]: 'File allegati',
  [T.excelOnlySelectionTitle]: 'Puoi selezionare solo file Excel.',
  [T.excelOnlySelectionDescription]:
    "L'analisi dei dati può essere eseguita solo con file Excel. Utilizza esclusivamente file Excel.",
  [T.attachmentsMoreCount]: 'Altri {{count}}',
  [T.clearAllFiles]: 'Rimuovi tutti',
  [T.maxAttachFiles]:
    'È consentito un massimo di 5 allegati, con una dimensione totale che non deve superare i 7 MB.',
  [T.duplicateFileError]: 'File con lo stesso nome già allegati.',
  [T.documentNotEmptyError]:
    'Non è consentito eliminare una cartella non vuota.',
  [T.uploadFolder]: 'Carica Cartella',
  [T.documentDeleteSuccess]: 'Documento eliminato con successo.',
  [T.documentsDeleteSuccess]: 'Documenti eliminati con successo.',
  [T.documentDeleteConfirmation]: 'Sei sicuro di voler eliminare il documento?',
  [T.resourceDeleteConfirmation]: 'Sei sicuro di voler eliminare la risorsa?',
  [T.collectionDeleteSuccess]: 'Collezione eliminata con successo!',
  [T.collectionDeleteConfirmation]:
    'Sei sicuro di voler eliminare la collezione?',
  [T.collectionDeletionFailed]: 'Eliminazione della collezione fallita.',
  [T.workspaceDeletionFailed]: 'Eliminazione dello spazio di lavoro fallita.',
  [T.workspaceDeleteSuccess]: 'Spazio di lavoro eliminato con successo!',
  [T.workspaceDeleteConfirmation]:
    'Sei sicuro di voler eliminare lo spazio di lavoro?',
  [T.multipleDocumentDeleteConfirmation]:
    'Sei sicuro di voler eliminare i documenti selezionati?',
  [T.nestedFolderDelete]:
    'Questa azione eliminerà tutte le cartelle, sottocartelle e file selezionati. Vuoi continuare?',
  [T.multipleFilesReprocessConfirmation]:
    'Sei sicuro/a di voler riprocessare il documento selezionato?',
  [T.genericConfirmation]: 'Sei sicuro?',
  [T.retrialFailed]:
    'Impossibile caricare alcuni documenti, riprova più tardi.',
  [T.deleteDocuments]: 'Elimina Documenti',
  [T.cancelUploadConfirmation]:
    'Sei sicuro di voler annullare il caricamento dei file rimanenti?',
  [T.retryFailedDocuments]: 'Riprova Documenti Non Riusciti',
  [T.processingFailed]: 'Elaborazione Non Riuscita',
  [T.processLastTransaction]: 'Elabora Ultima Transazione',
  [T.processAllTransactions]: 'Elabora Tutte le Transazioni',
  [T.documentDownloadError]: 'Download del documento non riuscito.',
  [T.destinationFolder]: 'Seleziona Cartella di Destinazione',
  [T.move]: 'Sposta',
  [T.moveDuplicateError]: 'File/Cartella già esistente.',
  [T.moveSuccess]: 'File/Cartella spostato con successo.',
  [T.moveFailed]: 'Errore nello spostamento di File/Cartella.',
  [T.reprocessSuccess]:
    'File in coda per il riprocessamento completato con successo.',
  [T.reprocessFailed]: 'Errore durante il riprocessamento dei file.',
  [T.reprocessCountInfo]: 'Riprocessamento di {{count}} file.',
  [T.syncSuccess]: 'Risorsa in coda per la sincronizzazione con successo.',
  [T.syncFailed]: 'Errore durante la sincronizzazione della risorsa.',
  [T.nameCharacterLengthError]: 'Il nome deve contenere da 1 a 200 caratteri.',
  [T.name]: 'Nome',
  [T.resourceSharingSuccessMessage]:
    'Autorizzazioni della risorsa aggiornate con successo',
  [T.resourceSharingErrorMessage]:
    'Errore durante la condivisione della risorsa.',
  [T.userOrUserGroup]: 'Utente o Gruppo Utenti',
  [T.searchForUserOrUserGroup]: 'Cerca Utente o Gruppo Utenti',
  [T.message]: 'Messaggio',
  [T.addMessage]: 'Aggiungi un messaggio',
  [T.sendEmailNotificationToRecipients]:
    'Invia notifica via email ai destinatari',
  [T.advanced]: 'Avanzate',
  [T.keepManuallyAssignedRolesOnSubFoldersFiles]:
    'Mantieni ruoli assegnati manualmente su sottocartelle/file',
  [T.assignRoleToAllSubFoldersFiles]:
    'Assegna ruolo a tutte le sottocartelle/file',
  [T.assignRoleOnFilesOnly]: 'Assegna ruolo solo ai file',
  [T.noUserOrUserGroupHasAccessToResource]:
    'Nessun utente o gruppo utenti ha accesso alla risorsa',
  [T.noMatchingUsersOrUserGroupsFound]:
    'Nessun utente o gruppo utenti corrispondente trovato',
  [T.controllerRoleAssignmentToRegularUserAtWorkspace]:
    'Il ruolo selezionato non può essere assegnato agli utenti regolari negli spazi di lavoro.',
  [T.regularUserAssignmentToWorkspace]:
    'Gli utenti normali non possono essere designati come controller dello spazio di lavoro. Promuovi il tipo di account dalla pagina degli utenti.',
  [T.contollerAssignmentError]:
    'Non autorizzato a invitare utenti come controller negli spazi di lavoro.',
  [T.authorizedToRemoveLowTierAccountTypesOnly]:
    'Autorizzato a rimuovere assegnazioni solo per account di livello inferiore.',
  [T.containsCollection]: 'Contiene: {{count}} collezioni',
  [T.containsItems]: 'Contiene: {{count}} elementi',
  [T.createPermissionDenied]: 'Permesso di creazione non trovato',
  [T.uploadPermissionDenied]: 'Permesso di caricamento non trovato',
  [T.createCollection]: 'Crea una raccolta',
  [T.collectionPlaceholder]:
    "Aggiungete i documenti all'interno di una raccolta per poter chattare con loro",
  [T.createFolder]: 'Crea una cartella',
  [T.folderPlaceholder]:
    'Aggiungi contenuti per costruire il tuo dominio di conoscenza',
  [T.assignViewerSubtitle]: 'Interroga e leggi il contenuto.',
  [T.assignControllerSubtitle]:
    "Interroga, modifica e gestisci l'accesso al contenuto.",
  [T.assignContributorSubtitle]: 'Interroga, leggi e aggiungi al contenuto.',
  [T.assignAssistantViewer]: `Chatta con l'assistente`,
  [T.assignAssignController]: `Chatta e controlla l'assistente`,
  [T.emptyWorkspace]: 'Nessuno Spazio di Lavoro disponibile',
  [T.emptyCollection]: 'Nessuna Collezione disponibile',
  [T.workspaces]: 'Spazi di lavoro',
  [T.browseWorkspaceDescription]:
    'Esplora il tuo spazio di lavoro e scegli i contenuti che vuoi aggiungere.',
  [T.collections]: 'Collezioni',
  [T.url]: 'Url',
  [T.webLink]: 'Web Link',
  [T.limitationUrl]: 'Possono essere aggiunti un massimo di 5 Web links',
  [T.urlLong]: 'Web link è troppo lungo',
  [T.inValidUrl]: 'Deve essere un web link valido',
  [T.restrictionUrl]: 'Web link non consentito (login, captcha, auth ecc)',
  [T.urlRequired]: 'Web link è obbligatorio',
  [T.duplicateUrls]: 'Non possono essere aggiunti Web links duplicati',
  [T.questionnaireWebLinkPlaceholder]: 'Inserisci un web link',
  [T.extensionNotAllowed]: 'File come "{{disallowedExt}}" non sono consentiti',
  [T.folderName]: 'Inserisci il nome della cartella',
  [T.author]: 'Autore',
  [T.importExternalDocs]: `Importazione da un'applicazione esterna`,
  [T.documentDetailsDisclaimer]: `La panoramica del documento generata dall'IA potrebbe contenere errori.`,
  [T.disableImportMessage]: `L'importazione da applicazioni esterne è disabilitata in "{{workspaceName}}"`,
  [T.importNotAllowed]: `L'importo non è consentito nello spazio di lavoro pubblico/privato`,
  [T.workspace]: 'Spazio di lavoro',
  [T.file]: 'File',
  [T.collection]: 'Collezione',
  [T.folder]: 'Cartella',
  [T.folders]: 'Cartelle',
  [T.reasonNotAvailable]: 'Motivo non disponibile',
  [T.languageError]:
    'La lingua non è supportata per lelaborazione. Le lingue tedesco, inglese e italiano sono attualmente supportate per lelaborazione.',
  [T.rateLimitError]:
    'Raggiunto il limite di velocità del modello AI. Si prega di rielaborare il documento in un secondo momento.',
  [T.permissionsError]:
    'Non hai i diritti di accesso completi a questa risorsa.',
  [T.unsupportedFiles]: 'La raccolta contiene file non supportati',
  [T.maxLengthError]:
    'Il limite di contesto dei modelli AI è stato raggiunto durante lelaborazione.',
  [T.noTextFoundError]:
    'Il documento sembra essere danneggiato. Si prega di caricare un documento valido.',

  // Chat
  [T.Chat]: 'Chat',
  [T.chat]: 'chat',
  [T.chats]: 'Chats',
  [T.chatsUntranslated]: 'Chats',
  [T.createNewChat]: 'Nuova Chat ',
  [T.send]: 'Invia',
  [T.queryPlaceholder]: 'Chiedere',
  [T.queryPlaceholderWorldKnowledge]: `Premete '/' per accedere alle richieste utili.`,
  [T.chatGptSlogan]: `Assistere nella scrittura, nella codifica e nella ricerca della conoscenza del mondo.`,
  [T.empowerGptSlogan]:
    'Per risposte alla luce di una base di conoscenza accessibile.',
  [T.empowerGptKnowledgeSwitchSlogan]: 'Cerca in tutti i dati aziendali',
  [T.chatGptKnowledgeSwitchSlogan]:
    'Cerca in tutto Internet o scrivi con dati addestrati LLM',
  [T.chatConfigurations]: 'Configurazione Chat',
  [T.parameterDialogTitle]: 'Parametri',
  [T.parameterDialogSubtitle]:
    'Aggiorna i parametri della chat per cercare i documenti in modo efficiente',
  [T.updateParameters]: 'Aggiorna Parametri',
  [T.cancel]: 'Annulla',
  [T.submit]: 'Invia',
  [T.save]: 'Salva',
  [T.confirm]: 'Conferma',
  [T.parametersUpdateSuccess]: 'Parametri della chat aggiornati con successo!',
  [T.parametersUpdateError]:
    "Errore nell'aggiornamento dei parametri della chat!",
  [T.temperature]: 'Temperatura',
  [T.tokens]: 'Lunghezza massima (token)',
  [T.sequences]: 'Sequenze di stop',
  [T.probabilities]: 'Probabilità migliori',
  [T.frequency]: 'Penalità frequenza',
  [T.presence]: 'Penalità presenza',
  [T.chatRenameSuccess]: 'Chat rinominata con successo!',
  [T.chatRenameFailed]: 'Errore nel rinominare la chat!',
  [T.chatDeleteSuccess]: 'Chat eliminata con successo!',
  [T.chatDeleteFailed]: "Errore nell'eliminare la chat!",
  [T.generatingResponse]: 'Generazione risposta',
  [T.executing]: 'In esecuzione',
  [T.executingPlan]: 'Esecuzione del piano',
  [T.errorGeneratingResponse]:
    'Impossibile generare una risposta! Riprova per favore.',
  [T.messagesLoadingFailed]:
    'Errore nel recupero dei messaggi. Per favore, riprova.',
  [T.responseFailedMessage]:
    'Si è verificato un errore nella generazione di una risposta.',
  [T.responseStreamingFailedMessage]:
    'Si è verificato un errore nella trasmissione della risposta. Per favore, aggiorna la pagina.',
  [T.regenerateResponse]: 'Rigenera Risposta',
  [T.errorAddingReaction]: "Errore nell'aggiungere una reazione.",
  [T.errorUpdatingChatContext]:
    "Errore nell'aggiornare il contesto della chat.",
  [T.chatDeleteConfirmation]: 'Sei sicuro di voler eliminare la chat?',
  [T.samplePrompt1]:
    'Quali verifiche devo effettuare prima di installare la pompa Etaprime L?',
  [T.samplePrompt2]:
    "Qual è l'intervallo ammissibile di viscosità del petrolio greggio per la centrale elettrica L27/38S?",
  [T.samplePrompt4]:
    'Linee guida per la creazione di una tabella pivot in Microsoft Excel.',
  [T.samplePrompt5]:
    'Consigli per la collaborazione e la comunicazione del team remoto.',
  [T.samplePrompt7]:
    'Suggerire strategie di ottimizzazione della catena di approvvigionamento.',
  [T.samplePrompt8]:
    "Best practice per l'identificazione dei rischi aziendali.",
  [T.capabilities1]:
    'Ottieni risposte alle tue domande basate esclusivamente sui documenti caricati.',
  [T.capabilities2]:
    "Ricorda il contesto delle domande precedenti all'interno di una chat.",
  [T.limitations1]:
    'Potrebbe non riuscire a confrontare attributi distribuiti in tutto il database.',
  [T.limitations2]:
    'La conoscenza è limitata allo scopo dei documenti caricati.',
  [T.includeChatHistory]:
    "Clicca per ricollegarti al contesto dell'ultima domanda.",
  [T.excludeChatHisory]: 'Clicca per scollegarti dal contesto della chat',
  [T.stickToDocs]: 'Limita la ricerca ai documenti aperti nel visualizzatore.',
  [T.resourceUnavailable]: 'Risorsa non disponibile',
  [T.referenceDocumentDeleted]: 'Documento di riferimento eliminato',
  [T.modelBeingUsed]: "Questo modello viene utilizzato nell'app",
  [T.disclaimerChatgpt]: `L'AI Model può commettere errori, si prega di verificare le informazioni importanti.`,
  [T.copy]: 'Copia',
  [T.copied]: 'Copiato',
  [T.errorCopyingResponse]: 'Errore durante la copia della risposta',
  [T.stickDocMessage]:
    'Limita la ricerca ai documenti aperti nel visualizzatore. (Nessun documento aperto)',
  [T.contentFilteringErrorMsg]: `La risposta è stata filtrata a causa del prompt che ha attivato il criterio di gestione dei contenuti di Azure. Modificare la richiesta e riprovare`,
  [T.generalErrorMsg]: `L'IA non è riuscita a generare una risposta in tempo. Riprova o semplifica la tua richiesta.`,
  [T.shareChatTitle]: `Condividi questa chat`,
  [T.shareChatText]: `Utenti di EmpowerGPT con il link`,
  [T.shareChatDisclaimer]:
    'Tutti i messaggi aggiunti dopo la condivisione rimarranno privati',
  [T.copyLink]: 'Copiare il link',
  [T.errorCopyingLink]: 'Errore nella copia del link',
  [T.sharedBy]: `Condiviso da: `,
  [T.chatInitiationError]: `Impossibile avviare una richiesta. Si prega di verificare se la configurazione del modello è corretta.`,
  [T.unsupportedLanguage]: `La lingua di input rilevata come {{Lingua rilevata}} non è attualmente supportata dalla chat di Enterprise Knowledge. Si prega di passare a una lingua supportata, che attualmente comprende l'inglese, il tedesco e l'italiano.\nSe si ritiene che il rilevamento non sia corretto, inserire una frase più lunga o riformulare l'input.`,
  [T.chatContextLengthExceed]:
    'Il messaggio inserito supera la lunghezza consentita per il modello di intelligenza artificiale selezionato. Si prega di accorciarlo e riprovare.',
  [T.contentPolicyViolation]:
    "L'immagine che stai cercando di generare è contraria alla nostra politica sui contenuti, riprova.",
  [T.rateLimit]:
    'La vostra organizzazione ha raggiunto il limite di richieste al minuto. Riprovare più tardi.',
  [T.webSearchTooltip]: 'Cerca sul web per rispondere',
  [T.webSearchDescription]: 'Cerca i risultati sul web',
  [T.canvasDescription]: 'Scrivi e collabora',
  [T.searchPlusDescription]:
    'Intelligenza artificiale avanzata per risposte intelligenti',
  [T.searchPlusLimitReached]:
    'Hai raggiunto il limite di query Search+ per il tuo piano.',
  [T.tools]: 'Utensili',
  [T.beta]: 'Beta',

  [T.stickToDoc]: 'Attenersi ai documenti',
  [T.webSearch]: 'Ricerca web',
  [T.imageGeneration]: 'Generazione di immagini',
  [T.imageGenerationDescription]: 'Generare immagini da descrizioni testuali',
  [T.nanoBananaDescription]: 'Veloce e leggero generazione di immagini',
  [T.generatingImage]: "Generazione dell'immagine",
  [T.imageGenerated]: 'Immagine generata con successo',
  [T.generatedImage]: 'Immagine generata',
  [T.failedToLoadImage]: "Impossibile caricare l'immagine",
  [T.imageCopied]: 'Immagine copiata',
  [T.failedToCopyImage]: "Impossibile copiare l'immagine",
  [T.failedToDownloadImage]: "Impossibile scaricare l'immagine",
  [T.clickToZoomIn]: 'Clicca per ingrandire',
  [T.clickToZoomOut]: 'Clicca per ridurre',
  [T.copyImage]: 'Copia',
  [T.downloadImage]: 'Scarica',
  [T.maximizeImage]: 'Massimizzare',
  [T.noAuthorizedFilesForChat]:
    'Spiacente, non ci sono documenti contro la risorsa selezionata disponibili per la chat. Assicurati che non sia vuota e contenga documenti elaborati a cui hai accesso.',
  [T.addFilesDescription]: 'Aggiungi file per risposte mirate',
  [T.selectFile]: 'Seleziona File',
  [T.documentsInFocus]: 'Documenti in primo piano:',
  [T.resourcesInFocus]: 'Risorse in primo piano',
  [T.resourcesInFocusDescription]:
    'Documenti in primo piano dalla knowledge base aziendale.',
  [T.oneResourceInFocus]: '1 risorsa',
  [T.resourcesInFocusCount]: '{{count}} risorse',
  [T.addMoreDocuments]: 'Aggiungi altri documenti',
  [T.advancedSearchButtonText]: 'Passa alla ricerca avanzata',
  [T.showInFolder]: 'Mostra nella cartella',
  [T.findDocumentsText]: 'Digita per trovare documenti nei luoghi di lavoro',
  [T.noResultsFound]: 'Nessun risultato trovato',
  [T.tryAdjustingFilters]:
    'Nessun elemento corrisponde ai filtri selezionati. Prova a modificarli o reimpostarli.',
  [T.inputLimitReachedError]:
    'La frase di ricerca non può essere più lunga di {{inputLimit}} caratteri.',
  [T.startChatOnSelectedFiles]: 'Avvia chat sui file selezionati',
  [T.addSelectedFilesToChat]: 'Aggiungi i file selezionati alla chat',
  [T.addSelectedFilesToAssistant]: "Aggiungi i file selezionati all'assistente",
  [T.addSelectedFilesToMiniExpertDataset]:
    'Aggiungere i file selezionati al set di dati',
  [T.noResultsTitle]: 'Nessun risultato per',
  [T.noResultsDescription]:
    'Prova una frase di ricerca diversa, controlla eventuali errori di battitura o modifica i filtri attivi.',
  [T.advancedSearch]: 'Ricerca avanzata',
  [T.advancedSearchDefaultDescription]:
    'Aggiungi facilmente file e cartelle cercando qualsiasi parola chiave che ricordi del documento.',
  [T.addedFileAndSelectedMoreToAddInSearch]:
    'Hai aggiunto {{addedCount}} file o cartella, contrassegnato come "già aggiunto", e selezionato altri {{newCount}} da aggiungere.',
  [T.addedFilesAndSelectedMoreToAddInSearch]:
    'Hai aggiunto {{addedCount}} file e cartelle, contrassegnati come "già aggiunti", e selezionato altri {{newCount}} da aggiungere.',
  [T.advancedSearchTitle]: 'Ricerca avanzata con IA sulla conoscenza aziendale',
  [T.advancedSearchDescription]:
    'Trova documenti e informazioni pertinenti nei contenuti accessibili in Workspaces.',
  [T.recentUploads]: 'Caricamenti recenti',
  [T.noRecentUploads]: 'Non hai file caricati di recente.',
  [T.uploadRecentFilesPrompt]:
    'Carica file nel tuo spazio di lavoro oppure usa la barra di ricerca e i filtri per trovare file o documenti.',
  [T.readMore]: 'Leggi di più',
  [T.readLess]: 'Leggi di meno',
  [T.foundResults]: '{{count}} risultati trovati',
  [T.filterByConnector]: 'Filtra per connettore',
  [T.allSources]: 'Tutte le fonti',
  [T.assistantDeletedError]: `L'assistente è stato cancellato`,
  [T.fileDeletedOrInaccessibleDesc]:
    'è stato eliminato o non è più accessibile per te.',
  [T.imageAnalysisNotSupported]: `Il modello selezionato non supporta le immagini. Passa a un modello che supporta l'analisi delle immagini`,
  [T.chatResponseTimeoutError]:
    'AI Model ha impiegato troppo tempo per rispondere alla sua richiesta. Si prega di riprovare a breve.',
  [T.chatModelUsageLimitReachedMessage]:
    'Hai raggiunto il limite di utilizzo per i modelli AI nel livello {{modelTier}}. Passa a un altro modello fino a quando il limite di utilizzo per questo livello non si resetta dopo {{availableAt}}.',
  [T.source]: 'Fonte',
  [T.type]: 'Tipo',

  // Speech-to-text err
  [T.microphoneAccessError]:
    'È necessario l’accesso al microfono. Si prega di consentirlo nel browser.',
  [T.noSpeechRecognized]: 'Nessun discorso riconosciuto.',
  [T.creditUsageError]: `Errore nel calcolo dell'utilizzo dei crediti`,
  [T.exemptedTokens]: `Sei esente dal monitoraggio del consumo di token.`,
  [T.maxRecordingTimeExceeded]: `Tempo massimo di registrazione superato.`,
  [T.stopMicError]: `Errore durante l'arresto del microfono.`,
  [T.tooLongSilence]: `Rilevato silenzio prolungato`,
  [T.inputLanguageMsg]: `Comprendere la lingua di input.`,

  [T.default]: 'Predefinito',
  [T.markAsDefault]: 'Imposta come predefinito',
  [T.defaultModelFallback]:
    'Il modello predefinito {{prevModel}} non è più disponibile. {{newModel}} è stato impostato come modello predefinito per le nuove chat.',
  [T.defaultModelAlreadySelected]:
    '{{modelName}} è già il modello predefinito.',
  [T.defaultModelUpdated]: 'Modello predefinito impostato con successo!',
  [T.defaultModelSetError]:
    "Errore nell'aggiornamento del modello predefinito!",
  [T.defaultModelUpdateError]:
    "Errore durante l'aggiornamento del modello predefinito",
  [T.errorGettingModel]: 'Errore durante il recupero dei dettagli del modello',
  [T.errorConfiguringModel]: 'Errore durante la configurazione del modello',
  [T.errorConfiguringChatModel]:
    'Errore durante la configurazione del modello di chat predefinito',
  [T.errorConfiguringModelProperties]:
    'Errore durante la configurazione delle proprietà del modello',

  // Chat Steps
  [T.understandingInput]: `Comprendendo l'input`,
  [T.thinking]: `Pensare`,
  [T.searchingContent]: `Cercando negli spazi di lavoro`,
  [T.searchingEnterpriseKnowledge]:
    'Ricerca di informazioni pertinenti nella conoscenza aziendale',
  [T.listingRelevantDocuments]: 'Elenco dei documenti pertinenti',
  [T.retrievingWebpageContent]: 'Recupero del contenuto della pagina web',
  [T.searchingWeb]: `Cercando sul web`,
  [T.searchingAttachments]: 'Ricerca negli allegati',
  [T.attachedDocuments]: 'documento/i',
  [T.link]: `collegamento`,
  [T.generatingResponseUsingReceivedExcerpts]:
    'Generazione della risposta dagli estratti recuperati',
  [T.excerptsFrom]: `estratti da`,
  [T.contentSearched]: 'Conoscenza aziendale ricercata',
  [T.webSearched]: 'Web ricercato',
  [T.searchedAttachments]: `Cercato all'interno degli allegati`,
  [T.joiningResponseFromPreviousTasks]:
    'Unione della risposta dalle attività precedenti',

  // Chat feedback
  [T.feedbackTitle]: 'Fornisci ulteriori feedback',
  [T.feedback1]: 'La risposta cita il documento sbagliato.',
  [T.feedback2]: 'La risposta esce dal campo dei documenti.',
  [T.feedback3]: 'La risposta è dannosa/insicura.',
  [T.feedback4]: 'La risposta non è utile.',
  [T.submitFeedback]: 'Invia feedback',
  [T.sources]: 'Sorgenti',
  [T.feedbackCommentPlaceholder]:
    'Cosa è andato storto con la risposta? Come può essere migliorata?',
  [T.feedbackValidationError]: 'Si prega di selezionare almeno 1 opzione.',

  // Context window and usage
  [T.contextWindowMenuTitle]: 'Finestra di contesto e utilizzo',
  [T.contextWindow]: 'Finestra di contesto',
  [T.usageThisMonth]: 'Utilizzo questo mese',
  [T.freeSpace]: 'Spazio libero',
  [T.contextWindowSummary]: '{{used}} / {{total}} token su {{model}}',
  [T.tokensWithPercentage]: '{{tokens}} tok · {{percentage}}',
  [T.labelWithCount]: '{{label}} ({{count}})',
  [T.contextWindowTooltipContext]:
    'Contesto: {{percentage}} · {{used}} / {{total}}',
  [T.systemPrompt]: 'Prompt di sistema',
  [T.workspaceFileRetrieval]: "Recupero file dell'area di lavoro",
  [T.memory]: 'Memoria',
  [T.systemTools]: 'Utensili di sistema',
  [T.tokensUsedOfTotal]: '{{used}} / {{total}} token',

  // User/Roles/Permissions
  [T.rolesTitle]: 'Ruoli',
  [T.role]: 'Ruolo',
  [T.permissions]: 'Autorizzazioni',
  [T.users]: 'Utenti',
  [T.contentRole]: 'Ruolo risorsa',
  [T.userRole]: 'Ruolo utente',
  [T.userRoles]: 'Ruoli Utente',
  [T.userRolesDescription]:
    'Set di accessi alle funzionalità riutilizzabili che puoi assegnare a utenti e gruppi di utenti',
  [T.noOfEnabledFeature]: 'N. di autorizzazioni abilitate',
  [T.assignedTo]: 'Assegnato a',
  [T.createUserRole]: 'Crea ruolo utente',
  [T.userRoleNamePlaceholder]: 'es. Autorizzazioni standard',
  [T.userRoleDescriptionPlaceholder]: 'Fornisci una descrizione',
  [T.userRoleCreateRequirementsTooltip]:
    'Nome e almeno un permesso sono richiesti per creare un ruolo utente',
  [T.corePermissions]: 'Autorizzazioni principali.',
  [T.corePermissionsDescription]:
    'Abilita queste per prime — le funzionalità dipendono da esse',
  [T.enabledCountBadge]: '{{enabled}}/{{total}} abilitate',
  [T.editUserRole]: 'Modifica ruolo utente',
  [T.viewUserRole]: 'Visualizza ruolo utente',
  [T.assignedToRoleTitle]: 'Assegnato a "{{name}}"',
  [T.deleteUserRoleConfirmation]:
    'Questa azione eliminerà definitivamente il ruolo utente "{{name}}". Questa azione non può essere annullata.',
  [T.assignedUsersCountLabel]: '{{count}} utente assegnato',
  [T.assignedUserGroupsCountLabel]: '{{count}} gruppo utenti assegnato',
  [T.members]: 'Membri',
  [T.searchUsersOrGroupsPlaceholder]: 'Cerca utenti o gruppi...',
  [T.assignUsersRowTitle]: 'Assegna utenti',
  [T.assignUsersRowDescription]: 'Verrai reindirizzato alla schermata Utenti',
  [T.assignUserGroupsRowTitle]: 'Assegna gruppi di utenti',
  [T.assignUserGroupsRowDescription]:
    'Verrai reindirizzato alla schermata Gruppi utenti',
  [T.expandAll]: 'Espandi tutto',
  [T.collapseAll]: 'Comprimi tutto',
  [T.searchPermissionsPlaceholder]:
    'Cerca sezioni, funzionalità, autorizzazioni',
  [T.discardChanges]: 'Annulla modifiche',
  [T.saveChanges]: 'Salva modifiche',
  [T.needsCapabilityPrefix]: 'Richiede',
  [T.coreCapabilityLabelPrefix]: 'Core',

  // Modello ruolo utente – controlli delle capacità
  [T.localFileUploads]: 'Caricamento file locali',
  [T.attachmentsCapability]: 'Allegati',
  [T.enterpriseKnowledgeCapabilityDescription]:
    'Contenitore di conoscenza aziendale — richiesto ovunque da Chat-EK, Smart Meet, Analista documenti e dalle funzionalità EK — strettamente legato a Workspace.',
  [T.localFileUploadsCapabilityDescription]:
    'Il caricamento di file locali è una funzionalità che consente agli utenti di caricare file direttamente dal proprio dispositivo.',
  [T.attachmentsCapabilityDescription]:
    'Allegati è una funzionalità che consente agli utenti di caricare file in Chat direttamente dal proprio dispositivo.',
  [T.worldKnowledgeCapabilityDescription]:
    'IA conversazionale che utilizza la conoscenza del mondo in tempo reale dal web. Completamente indipendente dagli spazi di lavoro.',

  // Modello ruolo utente – funzionalità/sotto-funzionalità
  [T.integrationsFeature]: 'Integrazioni',
  [T.assistantChatSubFeature]: 'Chat assistente',
  [T.buildAssistantsSubFeature]: 'Crea assistenti',
  [T.manageAssistantsSubFeature]: 'Gestisci assistenti',
  [T.projectChatSubFeature]: 'Chat progetto',
  [T.manageProjectSubFeature]: 'Gestisci progetto',
  [T.manageWorkflowSubFeature]: 'Gestisci workflow',
  [T.sharePointSubFeature]: 'SharePoint',
  [T.oneDriveSubFeature]: 'OneDrive',
  [T.confluenceSubFeature]: 'Confluence',
  [T.googleDriveSubFeature]: 'Google Drive',

  // Modello ruolo utente – autorizzazioni
  [T.enableFeaturePermission]: 'Abilita funzionalità',
  [T.enableSubfeaturePermission]: 'Abilita sotto-funzionalità',
  [T.uploadLocalFilesPermission]: 'Carica file locali',
  [T.modelComparisonPermission]: 'Confronto modelli',
  [T.manageProjectsPermission]: 'Gestisci progetti',
  [T.manageWorkflowsPermission]: 'Gestisci flussi di lavoro',
  [T.runWorkflowsPermission]: 'Esegui flussi di lavoro',
  [T.versionControlPermission]: 'Controllo versione',
  [T.shareWorkflowsPermission]: 'Condividi flussi di lavoro',
  [T.codeExecutionPermission]: 'Esecuzione codice',
  [T.attachmentsPermission]: 'Allegati',
  [T.attachmentsPermissionDescription]:
    'Sfoglia e allega contenuti aziendali esistenti.',
  [T.projectSourcePermission]: 'Origine progetto',
  [T.disableAllPermissions]: 'Disabilita tutto',
  [T.create]: 'Crea',
  [T.update]: 'Aggiorna',
  [T.add]: 'Aggiungi',
  [T.previouslyAdded]: 'Aggiunto in precedenza',
  [T.new]: 'Nuovo',
  [T.edit]: 'Modifica',
  [T.editName]: 'Modifica Nome',
  [T.delete]: 'Elimina',
  [T.tag]: 'Tag',
  [T.upload]: 'Carica',
  [T.createRole]: 'Crea Ruolo',
  [T.updateRole]: 'Aggiorna Ruolo',
  [T.createUser]: 'Crea Utente',
  [T.updateUser]: 'Aggiorna Utente',
  [T.searchRole]: 'Cerca Ruolo Utente',
  [T.availableRole]: 'Ruolo Utente Disponibile',
  [T.assignedRole]: 'Ruolo Utente Assegnato',
  [T.confirmDeleteRole]: 'Sei sicuro di voler eliminare questo ruolo?',
  [T.confirmDeleteUser]: 'Sei sicuro di voler eliminare questo utente?',
  [T.confirmDeleteYourAccount]: 'Sei sicuro di voler eliminare il tuo account?',
  [T.confirmDeleteMultipleUsers]:
    'Sei sicuro di voler eliminare questi utenti?',
  [T.roleDeleteSuccess]: 'Ruolo eliminato con successo!',
  [T.deleteRow]: 'Elimina riga',
  [T.deleteChat]: 'Elimina chat',
  [T.confirmDeleteChat]: 'Sei sicuro di voler eliminare questa chat?',
  [T.yesDeleteIt]: 'Sì, elimina',
  [T.randomError]: 'Si è verificato un errore!',
  [T.errorDeletingRole]: "Errore durante l'eliminazione del ruolo.",
  [T.noRecordFound]: 'Nessun record trovato!',
  [T.roleUpdateSuccess]: 'Ruolo Aggiornato con Successo!',
  [T.roleUpdateError]: "Errore nell'aggiornamento del ruolo!",
  [T.roleCreateSuccess]: 'Ruolo Creato con Successo!',
  [T.roleCreateError]: 'Errore nella creazione del ruolo!',
  [T.userRoleTemplateFetchError]:
    'Errore durante il recupero del modello di ruolo utente!',
  [T.userRolesFetchError]: 'Errore durante il recupero dei ruoli utente!',
  [T.userRoleCreateSuccess]: 'Ruolo utente creato con successo!',
  [T.userRoleCreateError]: 'Errore durante la creazione del ruolo utente!',
  [T.userRoleAssignedCannotDelete]:
    'Questo ruolo è assegnato a uno o più utenti o gruppi. Rimuovi l’assegnazione del ruolo prima di eliminarlo.',
  [T.userRoleAlreadyExists]: 'Esiste già un ruolo utente con questo nome.',
  [T.userInviteSuccess]: 'Invito inviato via email.',
  [T.userInviteError]: "Errore durante l'invio dell'invito.",
  [T.userUpdateSuccess]: 'Utente aggiornato con successo!',
  [T.userUpdateFailed]: "Errore durante l'aggiornamento dell'utente.",
  [T.userDeleteSuccess]: 'Utente eliminato con successo!',
  [T.usersDeleteSuccess]: 'Utenti eliminati con successo!',
  [T.userDeleteError]: "Impossibile eliminare l'utente, per favore riprova!",
  [T.duplicateUserError]: "L'indirizzo email è già in uso",
  [T.duplicateFolderError]: 'File/Cartella già esistente.',
  [T.duplicateCollectionError]: 'La collezione esiste già.',
  [T.duplicateWorkspaceError]: 'Lo spazio di lavoro esiste già.',
  [T.renameSuccess]: 'Rinominato con successo!',
  [T.renameFailed]: 'Errore durante il rinominare!',
  [T.emptySpaceError]: 'Il nome non può essere vuoto!',
  [T.rename]: 'Rinomina',
  [T.enterRoleName]: 'Inserisci il Nome del Ruolo',
  [T.fullName]: 'Nome Completo',
  [T.enterFullName]: 'Inserisci il Nome Completo',
  [T.enterEmailAddress]: "Inserisci l'Indirizzo Email",
  [T.enterRoleDescription]: 'Inserisci la Descrizione del Ruolo',
  [T.roleName]: 'Nome del Ruolo',
  [T.invalidRoleName]: 'Nome del Ruolo non valido',
  [T.userName]: 'Nome Utente',
  [T.enterUserName]: 'Inserisci il Nome Utente',
  [T.moveSelectedRight]: 'Sposta selezionati a destra',
  [T.moveSelectedLeft]: 'Sposta selezionati a sinistra',
  [T.applyTags]: 'Applica Tag',
  [T.language]: 'Lingua',
  [T.dataLibrary]: 'Libreria Dati',
  [T.dataLibraryResourceNotFoundTitle]:
    'Non possiamo mostrarti questo contenuto',
  [T.dataLibraryResourceNotFoundDescription]:
    "Non hai l'autorizzazione per visualizzarlo. Contatta l'amministratore per richiedere l'accesso.",
  [T.dataLibraryBackToWorkspace]: "Torna all'area di lavoro",
  [T.documentsStatus]: 'Stato Documenti Caricati',
  [T.statusFailedText]: 'Stato: Non riuscito',
  [T.statusUploadedText]: 'Stato: Caricato',
  [T.startDate]: 'Data di Inizio',
  [T.endDate]: 'Data di Fine',
  [T.selectStatus]: 'Seleziona Stato',
  [T.pages]: 'pagine',
  [T.addARole]: 'Aggiungi un Ruolo',
  [T.editRole]: 'Modifica Ruolo',
  [T.organizationAdminSubtitle]:
    'Può creare e assegnare spazi di lavoro, invitare amministratori/utenti, aggiungere ruoli personalizzati.',
  [T.organizationOwnerSubtitle]: `Accesso completo a tutti gli spazi di lavoro oltre ai privilegi di amministratore dell'organizzazione.`,
  [T.workspaceAdminSubtitle]:
    'Può gestire interi spazi di lavoro, gruppi di utenti e aggiungere utenti regolari.',
  [T.regularUserSubtitle]:
    'Può chattare su documenti accessibili, caricare e condividere contenuti con altri utenti.',
  [T.licenseLimitReached]: 'Limite di licenza raggiunto',
  [T.licenseExpired]: 'Licenza scaduta!',
  [T.licenseExpiredMessage]: `La tua licenza è scaduta. Contatta l'amministratore per un'estensione o un rinnovo.`,

  // workspace
  [T.workspaceName]: 'Nome Spazio di Lavoro',
  [T.collectionName]: 'Nome Raccolta',
  [T.workspaceColor]: 'Colore dello Spazio di Lavoro',
  [T.workspaceController]: 'Controller dello Spazio di Lavoro',
  [T.createWorkspace]: 'Crea Spazio di Lavoro',
  [T.updateWorkspace]: 'Aggiorna Spazio di Lavoro',
  [T.updateName]: 'Aggiornare il nome',
  [T.newWorkspace]: 'Nuovo spazio di lavoro',
  [T.newCollection]: 'Nuova collezione',
  [T.newFolder]: 'Nuova cartella',
  [T.documentUpdateConfirmation]:
    'Rinomina lo spazio di lavoro e aggiorna il colore di sfondo',
  [T.backgroundColor]: 'Colore di Sfondo',
  [T.updatesOn]: 'Aggiornamenti',
  [T.updatedBy]: 'Aggiornato da',
  [T.workspaceUpdateSuccess]: 'Spazio di Lavoro aggiornato con successo!',
  [T.workspaceUpdateFailed]:
    "Errore nell'aggiornamento dello Spazio di Lavoro!",
  [T.sortBy]: 'Ordina Per',
  [T.sort]: 'Ordina',
  [T.ascending]: 'Crescente',
  [T.descending]: 'Decrescente',
  [T.lastUpdated]: 'Ultimo Aggiornamento',
  [T.ago]: 'fa',
  [T.day]: 'giorno',
  [T.days]: 'giorni',
  [T.hour]: 'ora',
  [T.hours]: 'ore',
  [T.min]: 'minuto',
  [T.mins]: 'minuti',
  [T.sec]: 'secondo',
  [T.secs]: 'secondi',
  [T.workSpaceDocumentsDropError]:
    'Aggiungi una raccolta per caricare i documenti al suo interno.',
  [T.createAWorkspace]: 'Crea uno Spazio di Lavoro',
  [T.newWorkspaceDescription]:
    'Crea una base di conoscenza separata per ogni dipartimento',
  [T.createACollection]: 'Crea una Raccolta',
  [T.publicDisclaimer]:
    'I contenuti in Pubblico sono condivisi con tutti gli utenti.',
  [T.privateDisclaimer]: `Il contenuto dell'area di lavoro personale è accessibile solo all'utente.`,
  [T.moreActions]: 'Altre azioni',

  //no_data_messages
  [T.noDataNameSpaceMessage]:
    'Crea uno spazio di lavoro per iniziare a caricare dati al suo interno.',
  [T.noDataWorkspaceMessage]:
    'Carica una cartella o crea una raccolta per caricare dati al suo interno.',
  [T.noDataCollectionMessage]: 'Carica file/cartelle',
  [T.noDataNoPermissionMessage]:
    "Richiedi all'amministratore l'accesso ai documenti.",
  [T.noData]: 'Nessun Dato',
  [T.noDataExists]: 'Nessun dato disponibile.',
  [T.documentGraphPlaceholder]:
    'Questo grafico mostrerà il livello di coinvolgimento nella chat non appena arriveranno le risposte',
  [T.workSpaceInfoMessage]:
    "I nuovi spazi di lavoro possono essere creati solo dagli amministratori dell'organizzazione.",
  [T.moveDialogInfo]:
    'Il contenuto spostato manterrà le autorizzazioni originali della sorgente.',

  //no_content_msg
  [T.noContentAvailable]: 'Nessun contenuto disponibile.',

  // File statuses
  [T.F_S_UP]: 'In corso',
  [T.F_S_RE]: 'Riprova',
  [T.F_S_PR]: 'Elaborato',
  [T.F_S_US]: 'Non supportato',
  [T.F_S_LLR]: 'Limite di licenza raggiunto',
  [T.F_S_WF]: 'In attesa del file',

  // User Groups
  [T.userGroupDeletedSuccessfully]: 'Gruppo Utenti Eliminato con Successo.',
  [T.userGroupsDeletedSuccessfully]: 'Gruppi Utenti Eliminati con Successo.',
  [T.userGroupCreatedSuccessfully]: 'Gruppo Utenti Creato con Successo.',
  [T.failedToCreateUserGroup]: 'Impossibile Creare il Gruppo Utenti.',
  [T.failedToDeleteUserGroup]: 'Impossibile Eliminare il Gruppo Utenti.',
  [T.failedToDeleteUserGroups]: 'Impossibile Eliminare i Gruppi Utenti.',
  [T.userGroupUpdatedSuccessfully]: 'Gruppo Utenti Aggiornato con Successo.',
  [T.failedToUpdateUserGroup]: 'Impossibile Aggiornare il Gruppo Utenti.',
  [T.addUserGroup]: 'Aggiungi un Gruppo Utenti',
  [T.editUserGroup]: 'Modifica Gruppo Utenti',
  [T.searchUsers]: 'Cerca Utenti',
  [T.createdBy]: 'Creato da',
  [T.userGroupDeleteConfirmationMsg]:
    'Sei sicuro di voler eliminare il/i Gruppo/i Utenti?',

  // Validations
  [T.maxLength]: '{{name}} non può superare {{length}} caratteri',
  [T.required]: '{{name}} è obbligatorio',
  [T.valueCannotBeZero]: '{{name}} non può essere Zero',
  [T.enterPositiveValue]: 'Inserisci un valore positivo',
  [T.tagHelperText]:
    "Premi il tasto 'Invio' per creare un nuovo tag o selezionarne uno dalla lista.",

  [T.maxCompanyLength]:
    '{{company}} non può essere più lungo di {{length}} caratteri',
  [T.maxDepartmentLength]:
    '{{department}} non può essere più lungo di {{length}} caratteri',
  [T.maxJobLength]:
    '{{jobRole}} non può essere più lungo di {{length}} caratteri',
  [T.maxCountryength]:
    '{{country}} non può essere più lungo di {{length}} caratteri',

  // Usage
  [T.processedDocuments]: 'Documenti elaborati',
  [T.overallUsage]: 'Utilizzo complessivo',
  [T.aiUsage]: "Utilizzo dell'IA",
  [T.monthlyUsage]: 'Utilizzo mensile',
  [T.dailyUsage]: 'Utilizzo giornaliero',
  [T.processedDocumentsInfo]:
    'Numero stimato di parole rispetto ai documenti elaborati memorizzati nella spazi di lavoro.',
  [T.tokenUsageInfo]:
    '{{consumed}} {{unit}} di documenti elaborati memorizzati nella spazi di lavoro su un limite totale di {{total}} {{unit}}',
  [T.aiUsageInfo]: "Utilizzo dell'IA per chat e elaborazione documenti",
  [T.creditUsageInfo]:
    '{{consumed}} {{unit}} utilizzati su un limite totale di {{total}} {{unit}}',
  [T.credits]: 'Crediti',
  [T.consumed]: 'Consumato',
  [T.date]: 'data',
  [T.noCreditsUsedThisMonth]: 'Nessun credito utilizzato questo mese',

  // Error Messages
  [T.namespaceError]: 'Si è verificato un errore di spazio dei nomi.',
  [T.resourceNotFoundError]: 'Risorsa non trovata.',
  [T.userNotFoundError]: "L'utente non esiste.",
  [T.noPermissionsAgainstResourceError]: 'Nessun permesso sulla risorsa.',
  [T.insufficientPrivileges]: "Permesso per eseguire l'azione non trovato.",
  [T.invalidCredentialsError]: 'Credenziali non valide!',
  [T.appRoleTemplateNotFoundError]: "Modello di ruolo dell'app non trovato.",
  [T.uploadTypeError]: 'Tipo di caricamento non valido fornito.',
  [T.transactionIdError]: 'Fornito un ID transazione non valido.',
  [T.uploadToRootError]: 'Errore durante il caricamento nella radice.',
  [T.blobWriteError]: 'Errore di scrittura del blob.',
  [T.uploadToFoundError]:
    "Non sei autorizzato a caricare file e cartelle nella cartella 'FOUND'.",
  [T.uploadToFileError]:
    'I file possono essere caricati solo in cartelle valide.',
  [T.fileUploadToWorkspaceError]:
    'I file non possono essere caricati a livello di spazio di lavoro.',
  [T.uploadSessionFileDirectToWorkspaceError]:
    'In uno Spazio di lavoro è possibile caricare direttamente solo cartelle. Inserire i file in una cartella prima di caricarli.',
  [T.uploadSessionInvalidTransition]:
    'Questa modifica di stato della sessione non è consentita.',
  [T.uploadSessionTerminalState]:
    'Questa sessione di caricamento è già terminata e non può essere modificata.',
  [T.uploadSessionStatusNotSupported]:
    'Lo stato di sessione richiesto non è supportato.',
  [T.uploadSessionNotEditable]:
    'Questa sessione di caricamento non può essere modificata.',
  [T.uploadSessionEmptyManifest]:
    'I file selezionati sono già stati caricati. Per caricarne altri, seleziona nuovi file.',
  [T.uploadSessionManifestInvalid]:
    'Il manifest di caricamento non è valido. Riprovare.',
  [T.uploadSessionPathConflict]:
    'È stato rilevato un conflitto di file nel percorso di caricamento. Risolvere i conflitti e riprovare.',
  [T.uploadSessionNotFound]: 'Sessione di caricamento non trovata.',
  [T.uploadSessionPermissionDenied]:
    'Non si dispone delle autorizzazioni per eseguire questa azione sulla sessione di caricamento.',
  [T.uploadSessionInvalidClientHints]:
    'I suggerimenti client forniti non sono validi.',
  [T.uploadSessionInvalidStatusFilter]:
    'Il valore del filtro di stato non è riconosciuto. Utilizzare uno stato valido.',
  [T.uploadSessionInvalidParent]:
    'La cartella di destinazione non esiste. Selezionare una cartella valida.',
  [T.summaryDestinationLabel]: 'Destinazione:',
  [T.summarySourceLabel]: 'Sorgente (questo dispositivo):',
  [T.summaryProgressLabel]: 'Avanzamento:',
  [T.summaryTotalSizeLabel]: 'Dimensione totale:',
  [T.summaryProgressText]:
    '{{uploaded}} di {{total}} file caricati - {{percent}}%',
  [T.noFilesAttachedError]:
    'Seleziona file validi per iniziare il loro caricamento.',
  [T.fileStorageWriteError]: 'Errore di scrittura dello storage file.',
  [T.fileStorageReadError]: 'Errore di lettura dello storage file.',
  [T.requestedResourceNotFile]: 'La risorsa richiesta non è un file.',
  [T.fileStorageDeleteError]: 'Errore di eliminazione dello storage file.',
  [T.publicFolderDeleteError]: 'Impossibile eliminare la cartella pubblica.',
  [T.internalServerError]: 'Qualcosa è andato storto.',
  [T.serverNotReachable]:
    'Server non raggiungibile al momento, riprova più tardi',
  [T.failedToSendVerificationEmail]:
    "Invio dell'email di verifica non riuscito. Riprova.",
  [T.invalidArgsError]: 'Argomenti non validi forniti.',
  [T.folderNotAllowedHere]: 'Non sei autorizzato a creare una cartella qui.',
  [T.filesPermission]: 'I file non sono consentiti qui.',
  [T.rolesInsufficientViewPrivileges]:
    'Non hai il diritto di visualizzare i ruoli.',
  [T.userGroupsInsufficientPrivileges]:
    'Non hai il diritto di visualizzare i gruppi utente.',
  [T.waCreateUserRestriction]:
    "L'amministratore dello spazio di lavoro può creare solo utenti regolari.",
  [T.readOnlyResourceUpdate]:
    'Non sei autorizzato a aggiornare una risorsa in sola lettura.',
  [T.readOnlyResourceDelete]:
    'Non sei autorizzato a eliminare una risorsa in sola lettura.',
  [T.rolesUniqueVoilation]: 'Ruolo con lo stesso nome già esistente.',
  [T.addPermissionsAgainstResourceError]:
    'Impossibile aggiungere permessi sulla risorsa.',
  [T.permissionsUpdatingErrorForRole]:
    'Impossibile aggiornare i permessi per la risorsa.',
  [T.insufficientCreatePrivileges]: 'Non hai i diritti per creare la risorsa.',
  [T.insufficientUpdatePrivileges]:
    'Non hai i diritti per aggiornare la risorsa.',
  [T.insufficientDeletePrivileges]:
    'Non hai i diritti per eliminare la risorsa.',
  [T.insufficientDeleteOneOrMorePrivileges]:
    'Non hai i diritti per eliminare una o più risorse.',
  [T.userGroupUniqueVoilation]:
    'Il gruppo utente con lo stesso nome già esiste.',
  [T.usersUniqueVoilation]: "L'utente esiste già.",
  [T.selfAssignmentOnResourceRestriction]:
    'Non puoi assegnare una risorsa a te stesso.',
  [T.ruAssignmentAsControllerRestriction]:
    'Gli utenti regolari non possono essere assegnati come controller.',
  [T.oaRemovalFromResourceDenied]:
    "All'amministratore dell'organizzazione non è consentito essere rimosso dalla risorsa.",
  [T.insufficientAssignmentPrivileges]:
    "Non hai abbastanza diritti per eseguire l'operazione.",
  [T.peerAccountAssignmentRestriction]:
    'Non ti è consentito rimuovere account dello stesso livello o di livello superiore.',
  [T.unauthorizedFilesError]: 'Non hai il permesso di caricare file/cartelle.',
  [T.messageOnEmptyFolderOrUnavailableFile]:
    'La chat non può essere avviata su risorse vuote o non disponibili.',
  [T.noSharedFilesExist]:
    "Si prega di caricare documenti nella spazi di lavoro o richiedere accesso all'amministratore per iniziare a utilizzare l'interrogazione.",
  [T.itemDetailsNotFoundError]: 'Dettagli per questa risorsa non trovati.',
  [T.operationNotPermitted]: "Permesso per eseguire l'azione non trovato.",
  [T.uniqueResourceNameError]: 'Esiste già una risorsa con lo stesso nome.',
  [T.resourceNameUnchanged]: 'Il nome deve essere diverso da quello attuale.',
  [T.pleaseUpdateAtLeastOneField]: 'Si prega di aggiornare almeno un campo.',
  [T.noResourcesShared]:
    'Sono ammessi solo documenti autorizzati. Si prega di caricare prima un documento.',

  // over limit messages
  [T.chatCreditLimitExceededOA]: `Limite mensile per i crediti AI raggiunto. Per assistenza immediata, contatta l'assistenza clienti all'indirizzo {{supportEmail}}`,
  [T.chatCreditLimitExceeded100Percent]: `Limite mensile per i crediti AI raggiunto.`,
  [T.chatCreditLimitExceeded]: `Limite mensile per i crediti AI raggiunto. Contatta il tuo amministratore.`,
  [T.fileCreditLimitExceededOA]: `
  Elaborazione dei documenti interrotta, limite mensile per i crediti AI raggiunto. Per assistenza immediata, contatta l'assistenza clienti all'indirizzo “support@empowergpt.ai”.`,
  [T.fileCreditLimitExceeded]: `
  Elaborazione dei documenti interrotta, limite mensile per i crediti AI raggiunto. Contatta il tuo amministratore.`,
  [T.fileWordLimitExceededOA]: `Elaborazione del documento interrotta, è stato raggiunto il limite di parole per i documenti elaborati archiviati. Elimina i documenti che non sono più necessari per liberare spazio. Per ulteriore assistenza, contattare l'assistenza clienti all'indirizzo "support@empowergpt.ai".`,
  [T.fileWordLimitExceeded]: `Elaborazione del documento interrotta, è stato raggiunto il limite di parole per i documenti elaborati archiviati. Elimina i documenti che non sono più necessari per liberare spazio.`,

  [T.creditLimitExceeded90Percent]:
    'Oltre il 90% dei crediti AI è stato consumato.',
  [T.wordLimitExceeded90Percent]:
    'È stato raggiunto oltre il 90% del limite di parole allocate rispetto ai documenti elaborati archiviati',
  [T.wordLimitReached100Percent]: `È stato raggiunto il limite di parole allocate per i documenti elaborati archiviati. Elimina i documenti che non sono più necessari per liberare spazio.`,
  [T.furtherAssistanceContactSupport]:
    "Per ulteriore assistenza, contattare il servizio clienti all'indirizzo ",
  [T.fileUploadLimitError]:
    'Hai raggiunto il limite di 100 documenti del piano di prova.',
  // users invitations
  [T.inviteUsers]: 'Invita Utenti',
  [T.emailAddress]: 'Indirizzo Email',
  [T.userGroup]: 'Gruppo Utenti',
  [T.active]: 'Attivo',
  [T.draft]: 'Bozza',
  [T.invited]: 'Invitato',
  [T.invitationExpired]: 'Invito Scaduto',
  [T.inactive]: 'Inattivo',
  [T.resendInvite]: "Invia nuovamente l'invito",
  [T.deActivate]: 'Disattiva',
  [T.active]: 'Attiva',
  [T.inviteSentSuccessfully]: 'Invito inviato con successo!',
  [T.inviteSentFailed]: "Errore nell'invio dell'invito!",
  [T.userActivated]: 'Utente attivato con successo!',
  [T.userDeactivated]: 'Utente disattivato con successo!',
  [T.userActivationFailed]: "Errore nell'attivazione dell'utente!",
  [T.userDeactivationFailed]: "Errore nella disattivazione dell'utente!",
  [T.adUserNotFoundError]: 'Utente non trovato in AD.',
  [T.invalidEmail]: 'Inserisci un indirizzo e-mail valido.',
  [T.userInviteLimitReachedError]: 'Limite di inviti utente raggiunto.',

  // SharePoint
  [T.sharePointAuthError]:
    'Potresti non essere in grado di interagire con SharePoint a causa di un problema di connettività.',
  [T.sharepoint]: 'Importa da SharePoint',
  [T.sharepointModalTitle]: 'Seleziona una Cartella / Libreria',
  [T.sharepointModalSubtitle]:
    "Passare al sito desiderato e selezionare la cartella / libreria di destinazione per l'importazione",
  [T.availableSites]: 'Siti disponibili',
  [T.selectSiteMsg]:
    'Seleziona un sito per visualizzare i contenuti disponibili del sito',
  [T.siteContent]: 'Contenuto del sito',
  [T.showSiteContent]: 'Mostra contenuto del sito',
  [T.select]: 'Selezionare',

  [T.resourceImportedSuccessfully]: 'Risorsa importata con successo.',
  [T.rootSite]: 'Siti principali',
  [T.sharePointSuccessModalTitle]: 'Cartella / Libreria collegata con successo',
  [T.externalImportSuccessModalLine1]:
    'Tutto a posto! La cartella / libreria selezionata insieme ai suoi contenuti sarà accessibile come una Collezione una volta completata la sincronizzazione dei dati.',
  [T.externalImportSuccessModalLine2]:
    'La visibilità della Collezione dipende esclusivamente dalle sue autorizzazioni in SharePoint.',
  [T.noSubSiteAvailable]: 'Nessuna Sotto-sito disponibile.',
  [T.noFolderFileAvailable]: 'Nessuna cartella / file disponibile.',
  [T.openInSharePoint]: 'Apri in SharePoint',
  [T.Navigate]: 'Navigare',
  [T.collectionSharepointPlaceholder]: 'Importa da SharePoint',
  [T.collectionSharepointDescription]:
    'Importa contenuti da Sharepoint a EmpowerGPT',

  // One Drive
  [T.oneDriveMyFiles]: 'I miei file',
  [T.oneDriveShared]: 'Condiviso con voi',
  [T.oneDrive]: 'Importa da OneDrive',
  [T.oneDriveModalTitle]: 'Seleziona una cartella/libreria',
  [T.oneDriveModalSubtitle]:
    "Naviga all'interno di OneDrive e seleziona il contenuto di destinazione per l'importazione",
  [T.content]: 'Contenuto',
  [T.blog]: 'Blog',
  [T.oneDriveSuccessModalTitle]: 'Cartella/Libreria collegata correttamente',
  [T.oneDriveSuccessModalLine1]:
    'Tutto stabilito! La cartella/libreria selezionata insieme ai suoi contenuti saranno accessibili come raccolta una volta completata la sincronizzazione dei dati.',
  [T.oneDriveSuccessModalLine2]:
    'La visibilità della Collezione si basa esclusivamente sulle sue autorizzazioni su One Drive.',
  [T.openInOneDrive]: 'Apri in OneDrive',
  [T.contentImportFromOneDrive]: 'Microsoft OneDrive',
  [T.oneDriveResourceProviderWelcomeTitle]:
    "Passaggi per l'importazione dalla configurazione di OneDrive",
  [T.oneDriveConfigurationSuccessTitle]: 'Importazione da OneDrive Configurata',
  [T.oneDriveConfigurationSuccessDescription1]:
    'I contenuti ora possono essere importati da OneDrive in EmpowerGPT come raccolte.',
  [T.oneDriveConfigurationSuccessDescription2]:
    'La visibilità del contenuto importato sarà basata sulle relative autorizzazioni su OneDrive.',
  [T.collectionOneDrivePlaceholder]: 'Importa da OneDrive',
  [T.collectionOneDriveDescription]:
    'Importa contenuti da OneDrive a EmpowerGPT',

  // Common External Resource provider
  [T.collectionExternalResProvPlaceholder]: 'Importa da SharePoint/OneDrive',
  [T.collectionExternalResProvDescription]:
    'Importa contenuti da Sharepoint o OneDrive a EmpowerGPT',
  [T.externalResourceDisclaimer]:
    "La visibilità del contenuto si basa esclusivamente sulle autorizzazioni alla fonte, tranne che all'interno di 'Pubblico' o 'Area di lavoro personale'.",

  // SSO configuration
  [T.redirectUri]: 'URI di reindirizzamento',
  [T.confirmationStep1]:
    "I passaggi sopra descritti sono stati eseguiti sull'applicazione registrata in Microsoft Entra ID.",
  [T.signInWithMicrosoft]: 'Accedi con Microsoft (SSO)',
  [T.allowInvitingExternalUsers]: "Consenti l'invito a utenti esterni",
  [T.externalDriveIntegration]: `Consentire l'importazione di contenuti da applicazioni esterne`,
  [T.syncFrequency]: 'Frequenza di sincronizzazione (minuti)',
  [T.contentImportFromSharepoint]: 'Microsoft SharePoint',
  [T.letsStart]: 'Iniziamo',
  [T.next]: 'Il prossimo',
  [T.done]: 'Fatto',
  [T.apply]: 'Applica',
  [T.welcomeScreenHeading1]: 'Passaggi per SSO',
  [T.welcomeScreenHeading2]: 'Configurazione',
  [T.registrationStep]: 'Registra "EmpowerGPT" in Microsoft Entra ID',
  [T.azureDetailsStep]:
    "Inserisci i dettagli dell'applicazione registrata su Microsoft Entra ID",
  [T.configurePermissions]:
    "Dai le autorizzazioni richieste contro gli APIs utilizzati all'applicazione registrata in Microsoft Entra ID",
  [T.registrationPoint1]: "In un'altra scheda, accedi a",
  [T.azurePortal]: 'Azure Portal',
  [T.roleAzurePortal]: 'come amministratore.',
  [T.registrationPoint2]:
    'Vai a "Microsoft Entra ID" (Azure Active Directory) > "App registrations" come amministratore.',
  [T.registrationPoint3]: 'Fai clic su "+ New registration".',
  [T.registrationPoint4]:
    'Inserisci "EmpowerGPT" come nome dell\'applicazione e seleziona i tipi di account supportati richiesti. (Consigliato: "Accounts in this organizational directory only").',
  [T.registrationPoint5]:
    'Nella sezione "Redirect URI" sul modulo di registrazione dell\'applicazione, seleziona "Web" come tipo e incolla il seguente URI di reindirizzamento nel campo corrispondente.',
  [T.confirmationStep1]:
    "I passaggi sopra descritti sono stati eseguiti sull'applicazione registrata in Microsoft Entra ID.",
  [T.redirectUriRequired]: 'URI di reindirizzamento è obbligatorio',
  [T.azureDetailsPoint1]:
    'Una volta registrata l\'applicazione, verrai reindirizzato alla pagina "Overview" dell\'applicazione registrata.',
  [T.azureDetailsPoint2]:
    'Copia l\'ID applicazione (client) e l\'ID directory (tenant) dalla pagina "Overview" e inseriscili in ciascuno dei campi sottostanti.',
  [T.azureDetailsPoint3]:
    'Vai a "Certificates and secrets" nella sezione "Manage" sull\'applicazione registrata in Microsoft Entra ID.',
  [T.azureDetailsPoint4]:
    'Seleziona la scheda "Client secrets" e fai clic sul pulsante "New client secret" per creare un nuovo segreto client. Inserisci "EmpowerGPT client secret" nella descrizione, imposta la scadenza a 24 mesi (consigliato) e fai clic su "add".',
  [T.azureDetailsPoint5]:
    'Copia il valore segreto e incollalo nel campo sottostante. I valori segreti del client non possono essere visualizzati. tranne subito dopo la creazione. Assicurati di salvare il valore sicuro quando viene creato prima di lasciare la pagina.',
  [T.clientIdRequired]: 'Client Id è obbligatorio',
  [T.labelClientId]: 'ID applicazione (client): ',
  [T.tenantIdRequired]: 'Tenant Id è obbligatorio',
  [T.labelTenantId]: 'Directory (tenant) Id:',
  [T.secretValueRequired]: 'Il valore segreto è obbligatorio',
  [T.labelSecret]: 'Valore segreto del client:',
  [T.enter]: 'Inserisci...',
  [T.enterNote]: 'Inserisci nota',
  [T.failedToSendEmail]: 'Email non trovata',
  [T.permissionsStep1]:
    'Vai a "API permissions" nella sezione "Manage" sull\'applicazione registrata in Microsoft Entra ID.',
  [T.permissionsStep2]:
    'Fai clic sul pulsante "+ Add a permission" e seleziona "Microsoft Graph" in Microsoft APIs.',
  [T.permissionsStep3]:
    'Seleziona "Application permissions" per dare le seguenti autorizzazioni e conferma facendo clic sul pulsante "add permission" qui sotto.',
  [T.permissionsStep4]: 'User.ReadBasic.All in User.',
  [T.permissionsStep5]: 'Group.Read.All in Group.',
  [T.permissionsStep6]: 'GroupMember.Read.All in GroupMember.',
  [T.permissionsStep7]:
    'Ripeti il passaggio 2 e seleziona "Delegated permissions" per dare l\'autorizzazione "profile". Conferma facendo clic sul pulsante "add permission" qui sotto.',
  [T.permissionsStep8]:
    "I passaggi sopra descritti sono stati eseguiti sull'applicazione registrata in Microsoft Entra ID.",
  [T.adUserSearchQuestion]:
    'Vuoi abilitare la ricerca degli utenti di Active Directory?',
  [T.adUserSearchEnableOption]: 'Sì, abilita la ricerca utenti AD',
  [T.adUserSearchEnableOptionDescription]: 'Aggiunge User.ReadBasic.All',
  [T.adUserSearchDisableOption]: 'No, non abilitare la ricerca utenti AD',
  [T.adUserSearchDisableOptionDescription]: 'Invita le persone tramite email',
  [T.adUserSearchDisclaimer]:
    'Il sistema non sarà in grado di cercare gli utenti di Active Directory. Puoi comunque invitare le persone su EmpowerGPT tramite indirizzo email.',
  [T.successDialogTitle]: 'SSO configurato con successo',
  [T.successDialogDescription]:
    "SS0 è stato configurato con successo contro gli utenti all'interno della directory collegata.",
  [T.clickHere]: 'Clicca qui',
  [T.toLogout]: ' per disconnettersi e testare la configurazione.',

  // Realm and Tenant configuration
  [T.continue]: 'continuare',
  [T.discoverTenant]: 'accesso',
  [T.tenants]: 'Inquilini',
  [T.domain]: 'Dominio',
  [T.subDomain]: 'Sotto-dominio',
  [T.newTenant]: 'Nuovo Tenant',
  [T.tenantCreatedSuccessfully]:
    'Invito email inviato a {{enteredEmail}}, Tenant creato per {{parsedDomain}}',
  [T.emailSendSuccessfully]: 'Invito via e-mail inviato a {{enteredEmail}}',
  [T.tenantDeletedSuccessfully]: 'Linquilino è stato cancellato con successo',
  [T.tenantCreationFailed]: 'Errore nella creazione dellinquilino',
  [T.tenantDeletionFailed]: 'Errore nelleliminazione dellinquilinos',
  [T.tenantUniqueViolation]: 'Linquilino esiste già',
  [T.invalidDomain]: 'Non è un email registrato',
  [T.workEmailRequired]: 'Email di lavoro richiesta.',
  [T.specialCharNotAllowed]: 'Caratteri speciali non consentiti.',
  [T.domainNameRequired]: 'Nome dominio richiesto',
  [T.domainNameLength]: 'Der Domainname darf maximal 20 Zeichen enthalten.',
  [T.domainDisclaimer]:
    'Questo dominio verrà utilizzato per accedere all applicazione.',
  [T.marketingConsentDisclaimer]:
    'Accetto di ricevere aggiornamenti via email sulla guida all’onboarding, sui prodotti, sui servizi e sulle novità di INTECH Automation & Intelligence GmbH.',
  [T.signupDisclaimer]:
    'Nessuna carta di credito • Nessun contatto commerciale • Cancellabile in qualsiasi momento',
  [T.domainName]: 'URL di accesso',
  [T.selfSignupFailed]: 'Registrazione automatica non riuscita',
  [T.selfSignupConfirmation1]: 'Attendere, creazione account in corso',
  [T.needHelpContactUs]: 'Hai bisogno di aiuto? Contattaci a ',
  [T.privacySettings]: 'Impostazioni privacy',
  [T.selfSignupConfirmation2]:
    'È stato inviato un invito allindirizzo {{email}}.',
  [T.selfSignupConfirmation3]:
    'Fare clic sul pulsante “clicca per procedere” nelle-mail ricevuta per configurare laccount. Il link di invito scadrà dopo [7] giorni.',
  [T.back]: 'Indietro',
  [T.confirmDeleteTenant]:
    'È sicuro di voler cancellare l\'inquilino "{{name}}"?',
  [T.reprocessAllFiles]: 'Rielaborare tutti i file',
  [T.reprocessAllFilesConfirmation]:
    'Sei sicuro di voler rielaborare tutti i file per gli inquilini?',
  [T.userDomainName]: 'Nome di dominio dellutente',
  [T.firstSignedUpEmail]: 'Prima e-mail di iscrizione',
  [T.totalUsers]: 'Utenti totali',
  [T.dateLastSignedUsers]: 'Data dellultimo accesso dellutente',
  [T.tenantFileReprocessingFailed]:
    'Impossibile rielaborare i file dell inquilino',
  [T.tenantFileReprocessingTriggered]:
    'La rielaborazione dei file del tenant è stata avviata con successo',
  [T.tenantNoFilesToProcess]:
    'Non è stato trovato alcun file da rielaborare per linquilino.',
  [T.confirmReprocessFilesTenant]:
    'Sei sicuro di voler rielaborare tutti i file per questo tenant?',
  [T.fileIdsToReprocess]:
    'Inserisci gli ID dei file da rielaborare (separati da virgola):',
  [T.onlyReprocessSelectedFiles]: 'Rielaborare solo i file selezionati',
  [T.tenantReprocessFiles]: 'Rielabora file del tenant',
  [T.tenantDelete]: 'Elimina tenant',
  [T.selectTenant]: 'Seleziona un tenant',
  [T.tenantPlanUpdatedSuccess]: 'inquilino piano aggiornato con successo',
  [T.tenantPlanUpdateFail]: 'inquilino aggiornamento del piano non riuscito',

  // Resource Provider config
  [T.resourceProviderWelcomeTitle]:
    "Passaggi per la configurazione dell'importazione da SharePoint",
  [T.resourceProviderTitle1]:
    'Carica il certificato generato nell\'applicazione registrata "EmpowerGPT" su Microsoft Entra ID',
  [T.resourceProviderStep1Instruction1]:
    "Incolla l'URL di base per il sito SharePoint della tua organizzazione di seguito. (L'URL di base per SharePoint Online viene fornito in base all'immissione durante la configurazione dell'abbonamento a Microsoft 365. Ad esempio, se il nome della tua organizzazione è Contoso, il sito principale di SharePoint Online sarà https://contoso.sharepoint.com.).",
  [T.resourceProviderStep1Instruction2]:
    'Fai clic sul pulsante sottostante per scaricare il certificato richiesto.',
  [T.resourceProviderStep1Instruction3]:
    "In un'altra scheda, accedi al portale di Azure come amministratore.",
  [T.resourceProviderStep1Instruction4]:
    'Vai a "Microsoft Entra ID" (Azure Active Directory) > "App registrations" > "All applications" > "EmpowerGPT".',
  [T.resourceProviderStep1Instruction5]:
    'Seleziona l\'applicazione e vai a "Certificates and secrets" nella sezione "Manage".',
  [T.resourceProviderStep1Instruction6]:
    'Seleziona la scheda "Certificates" e fai clic su "Upload certificate". Carica il certificato generato sopra, scaricato sul tuo computer.',
  [T.resourceProviderStep1Instruction7]:
    'Inserisci una descrizione appropriata e clicca sul pulsante "Aggiungi" per aggiungere il certificato.',
  [T.resourceProviderTitle2]:
    "Concedi le autorizzazioni richieste per le API utilizzate all'applicazione registrata in Microsoft Entra ID",
  [T.resourceProviderGraphPermissionsSectionTitle]:
    'Autorizzazioni API di Microsoft Graph',
  [T.resourceProviderSharePointPermissionsSectionTitle]:
    'Autorizzazioni API di SharePoint',
  [T.resourceProviderSitesSelectedAccessDisclaimer]:
    "La concessione di Sites.Selected non fornisce l'accesso da sola. Un amministratore deve assegnare ogni sito richiesto a EmpowerGPT prima che possa importare contenuti da essi. Consulta la <guideLink>guida di Microsoft</guideLink>.",
  [T.resourceProviderStep0Instruction0Start]: `In un'altra scheda, accedere a `,
  [T.resourceProviderStep0Instruction0End]: ` come amministratore`,
  [T.resourceProviderStep2Instruction1]:
    'Accedere a “Microsoft Entra ID” (Azure Active Directory) > “Registrazioni applicazioni” > “Tutte le applicazioni” > “EmpowerGPT” > “Autorizzazioni API”.',
  [T.resourceProviderStep2Instruction2]:
    'Clicca su "+ Add a permission" e seleziona "Microsoft Graph" sotto le Microsoft APIs.',
  [T.resourceProviderStep2Instruction3]:
    'Seleziona "Application permissions" per concedere le seguenti autorizzazioni e conferma cliccando su "add permission" in basso.',
  [T.resourceProviderStep2Instruction5]: 'Sites.Read.All.',
  [T.resourceProviderStep2Instruction5Selected]: 'Sites.Selected.',
  [T.resourceProviderSitesReadAllTitle]:
    "Concedi a EmpowerGPT l'accesso a tutti i siti",
  [T.resourceProviderSitesReadAllDescription]: 'Usa Sites.Read.All',
  [T.resourceProviderSitesSelectedTitle]:
    "Concedi a EmpowerGPT l'accesso solo ai siti selezionati",
  [T.resourceProviderSitesSelectedDescription]: 'Usa Sites.Selected',
  [T.resourceProviderStep2Instruction6]: 'Files.Read.All.',
  [T.resourceProviderStep2Instruction7]:
    'Ripeti il passaggio 2 e seleziona "Delegated permissions" per concedere le seguenti autorizzazioni. Conferma facendo clic sul pulsante "add permission" qui sotto.',
  [T.resourceProviderStep2Instruction7OneDrive]:
    'Seleziona "Delegated permissions" per concedere le seguenti autorizzazioni. Conferma facendo clic sul pulsante "add permission" qui sotto.',
  [T.resourceProviderStep2Instruction8]:
    'Fai clic sul pulsante "+ Add a permission" e seleziona "SharePoint" sotto Microsoft APIs per dare le seguenti "Application permission". Fai clic su "add permission" per confermare.',
  [T.sharepointConfigurationSuccessTitle]:
    'Importazione da SharePoint configurata',
  [T.sharepointConfigurationSuccessDescription1]:
    'Ora è possibile importare contenuti dai siti SharePoint in EmpowerGPT come collezioni.',
  [T.sharepointConfigurationSuccessDescription2]:
    'La visibilità dei contenuti importati sarà basata sulle autorizzazioni in SharePoint.',
  [T.downloadCertificate]: 'Scarica il certificato',
  [T.invalidSharePointUrl]: 'URL di SharePoint non valido fornito.',
  [T.identityProviderEnabledSuccessfully]:
    'Microsoft (SSO) è stato abilitato correttamente.',
  [T.resourceProviderSharePointEnabledSuccessfully]:
    'SharePoint abilitato correttamente.',
  [T.resourceProviderOneDriveEnabledSuccessfully]:
    'OneDrive abilitato correttamente.',
  [T.identityProviderDisabledSuccessfully]:
    'Microsoft (SSO) è stato disabilitato correttamente.',
  [T.resourceProviderSharePointDisabledSuccessfully]:
    'SharePoint disabilitato correttamente.',
  [T.resourceProviderOneDriveDisabledSuccessfully]:
    'OneDrive disabilitato correttamente.',
  [T.identityProviderUpdateFailed]: 'Impossibile aggiornare Microsoft (SSO).',
  [T.resourceProviderUpdateFailed]: 'Impossibile aggiornare SharePoint.',
  [T.identityProviderCreationFailed]: "Errore nell'abilitare Microsoft (SSO).",
  [T.resourceProviderSharePointCreationFailed]:
    "Errore nell'abilitare SharePoint.",
  [T.resourceProviderOneDriveCreationFailed]: "Errore nell'abilitare OneDrive.",
  [T.disabledToolTipMicrosoftSSO]: 'Abilita Microsoft SSO per configurare.',
  [T.requiredCheckbox]: 'Questo campo è obbligatorio',
  [T.adminConsent]:
    'Assicurati che sia stata fornita l\'autorizzazione dell\'amministratore per le autorizzazioni che la richiedono, indicate da un "Yes" nella colonna "Admin consent required" della tabella "Configured permissions".',

  //Internal Analytics
  [T.overview]: 'Panoramica',
  [T.words]: 'parole',
  [T.currentMonth]: 'Questo mese',
  [T.chatAnalyticsHeading]: 'Coinvolgimento delle funzionalità',
  [T.dislikes]: 'Non mi piace',
  [T.AF_DAC]: 'Analisi',
  [T.AF_DAQNC]: 'Questionari',
  [T.AF_DAQC]: 'Domande',
  [T.AF_ASQ]: 'Ricerche',
  [T.messageSuccessRate]: 'Tasso di successo dei messaggi',
  [T.currentMonthTooltip]:
    'Confronta le prestazioni del mese corrente con quelle del mese precedente.',
  [T.lastMonthTooltip]:
    'Confronta le prestazioni del mese scorso con quelle del mese precedente.',
  [T.ytdTooltip]:
    'Confronta le prestazioni dall’inizio dell’anno a oggi con lo stesso periodo dell’anno precedente.',
  [T.lastWeekTooltip]:
    'Confronta le prestazioni degli ultimi 7 giorni con quelle della settimana precedente.',
  [T.lastDayTooltip]:
    'Confronta le prestazioni delle ultime 24 ore con quelle del giorno precedente.',
  [T.conversationVsQueries]: 'Conversazioni vs. Domande poste',
  [T.creditsTooltip]:
    'Mostra solo l’utilizzo dei crediti inclusi nel piano.\n L’utilizzo PAYG appare nella dashboard PAYG.',
  [T.processDocTooltip]:
    'Parole elaborate in tutti i documenti\n nel periodo di tempo selezionato rispetto\n al limite totale.',
  [T.conversationTooltip]:
    'Le chat sono le conversazioni avviate; i messaggi sono le singole domande al loro interno. Un giorno intenso può avere poche chat ma molti messaggi.',
  [T.questions]: 'Domande',
  [T.documentsUploaded]: 'Documenti caricati',
  [T.assistantsCreated]: 'Assistenti creati',
  [T.time]: 'Tempo',
  [T.userOrGroups]: 'Utenti',
  [T.fetchResourceCountError]:
    'Impossibile recuperare i conteggi delle risorse',
  [T.chatEngagement]: 'Coinvolgimento nella chat',
  [T.lastDay]: 'Ultime 24 ore',
  [T.lastWeek]: 'Ultimi 7 giorni',
  [T.lastMonth]: 'Il mese scorso',
  [T.selectDate]: 'Seleziona un intervallo di date',
  [T.allTime]: 'Tutto il tempo',
  [T.thisQuarter]: 'Questo trimestre',
  [T.lastQuarter]: 'Trimestre scorso',
  [T.thisYear]: "Quest'anno",
  [T.lastYear]: 'Anno scorso',
  [T.yearToDate]: 'Dall’inizio dell’anno',
  [T.startDateError]:
    'La data di inizio non può essere successiva alla data di fine.',
  [T.resetToCurrentMonth]: 'Mese corrente',
  [T.aiUsage]: 'Utilizzo dell’IA',
  [T.processedDocuments]: 'Documenti elaborati',
  [T.creditSpent]: 'Crediti utilizzati',
  [T.dateRange]: 'Intervallo di date',
  [T.conversation]: 'Conversazioni',
  [T.queriesAsked]: 'Analisi creata',
  [T.messages]: 'Messaggi',
  [T.documentAnalyst]: 'Analista documentale (Analisi)',
  [T.smartMeetAnalyst]: 'Smart Meet (Numero di riunioni)',
  [T.questionnairesCreated]: 'Analista di dati (Analisi)',
  [T.dataAnalysis]: 'Questionari completati',
  [T.assistantName]: 'Nome assistente',
  [T.topAssistants]: 'Assistenti migliori',
  [T.creditsSpentDetail]: 'Dettagli sui crediti utilizzati',
  [T.creditConsumption]: 'Consumo di crediti',
  [T.user]: 'Utente',
  [T.feature]: 'Funzionalità',
  [T.creditsUsed]: 'Crediti utilizzati',
  [T.modelUsed]: 'Modello utilizzato',
  [T.total]: 'Totale',
  [T.Unsupported]: 'Non supportato',
  [T.Processed]: 'Elaborato',

  // User Favourites
  [T.favourites]: 'Preferiti',
  [T.markFavourite]: 'Segna come preferito',
  [T.unmarkFavourite]: 'Deseleziona come preferito',
  [T.markedFavourite]: 'Contrassegnato come preferito',
  [T.unmarkedFavourite]: 'Non contrassegnato come preferito',
  [T.markFavouriteError]: 'Errore nel contrassegnare come preferito',
  [T.unmarkFavouriteError]: 'Errore durante la demarcazione come preferita',
  [T.favouriteLimitReached]: "Limite dei preferiti dell'utente raggiunto",

  //User Onboarding
  [T.welcomeText]: `Benvenuti a`,
  [T.welcomeText1]: `EmpowerGPT è una piattaforma di intelligenza artificiale creata per le aziende. Chatta in modo sicuro con LLM all'avanguardia che incorporano le vostre conoscenze aziendali e mondiali.`,
  [T.welcomeText2]: `Ampliate la base di conoscenze della vostra azienda caricando o importando dati da applicazioni integrate.`,
  [T.welcomeText3]: 'Inizia la tua prova di EmpowerGPT',
  //Chat
  [T.gotIt]: `Capito`,
  [T.chatBranched]: 'Chat ramificata',
  [T.onNext]: 'Fare clic su Avanti per continuare.',
  [T.chatStep1Title]: 'Chat: Selezionare il dominio di conoscenza richiesto.',
  [T.chatStep1Description]: `Scegliete come volete che EmpowerGPT risponda. Attenetevi alla conoscenza aziendale per ottenere risposte alla luce di documenti aziendali accessibili. Oppure passate alla conoscenza del mondo per ottenere assistenza nella creazione di contenuti, nella codifica, nella ricerca e nell'accesso alla conoscenza del mondo.`,
  [T.chatStep2Title]: 'Chat: Digitare la domanda.',
  [T.chatStep2Description]: `Utilizzate il campo di input sottostante per inserire le vostre domande e premete il pulsante di invio sulla destra. Il confronto con le domande e le risposte precedenti è limitato all'interno di una chat.`,
  [T.chatStep3Title]: 'Chat: Rivedere i fatti.',
  [T.chatStep3Description]: `Le risposte alle chat nella conoscenza aziendale hanno riferimenti citati alla fine. Si raccomanda di convalidare l'autenticità della risposta consultando i riferimenti.`,
  [T.chatQuery]:
    'Scrivi un’email per congratularti con il reparto marketing per aver raggiunto un aumento del 15% delle entrate nel terzo trimestre 2025.',
  [T.today]: 'Oggi',
  [T.thisWeek]: 'Questa settimana',
  [T.thisMonth]: 'Questo mese e i più vecchi',
  [T.chatHistory]: 'Storia della chat',
  [T.noChatHistory]: 'Nessuna storia della chat',
  [T.chatDeleted]: `Non è possibile continuare la conversazione su una chat eliminata`,
  [T.imageGenerationLimitReached]: `Limite di generazione delle immagini raggiunto.`,
  [T.modelCoolDownTooltip]: 'Limite di utilizzo raggiunto. Riprova più tardi.',
  [T.assistantResourceNotFound]: `Impossibile generare una risposta. Sono stati apportati aggiornamenti all'assistente. Aggiornare la pagina per applicare le modifiche.`,

  //Data Library
  [T.documentStep1Title]: 'Caricare: Navigare nella Spazi di lavoro.',
  [T.documentStep1Description]: `Data Library contiene spazi di lavoro che sono stati condivisi con l'utente. Gli spazi di lavoro classificano i documenti all'interno di un'organizzazione.`,
  [T.documentStep2Title]: `Caricare: Selezionare l'area di lavoro richiesta.`,
  [T.documentStep2Description]: `Le azioni disponibili su un'area di lavoro si basano sul ruolo che vi è stato assegnato. "Il mio spazio di lavoro" è uno spazio di lavoro personale, con il quale è possibile aggiungere documenti e chattare.`,
  [T.documentStep3Title]: `Caricare: Creare una raccolta.`,
  [T.documentStep3Description]: `Le raccolte classificano ulteriormente i documenti all'interno di ogni area di lavoro. Create la vostra raccolta all'interno dell'area di lavoro My per caricare i documenti al suo interno.`,
  [T.documentStep4Title]: `Caricare: Selezionare i documenti da caricare`,
  [T.documentStep4Description]: `EmpowerGPT supporta un'ampia varietà di formati di documenti che gli utenti possono aggiungere alla base di conoscenza, tra cui PDF (anche documenti scansionati), documenti Word, diapositive Powerpoint e file Excel.`,
  [T.documentStep5Title]: 'Caricamento: Capire lo stato del documento',
  [T.documentStep5Description]: `Una volta caricati, i documenti vengono messi in coda per l'elaborazione da parte dell'AI. Una volta contrassegnati come “Eseguiti”, gli utenti che hanno accesso a questi documenti possono chattare con loro.`,

  // Projects
  [T.projects]: 'Progetti',
  [T.projectsHeaderText]:
    'Usa i progetti per impostare istruzioni comuni, allegare file e organizzare le chat.',
  [T.projectsMoto]: 'Usa i progetti per combinare e organizzare le chat.',
  [T.newProject]: 'Nuovo Progetto',
  [T.createProjectPlaceholder]: 'Inizia creando un nuovo progetto',
  [T.projectDescription]:
    'I progetti ti aiutano a impostare istruzioni comuni, allegare file e organizzare le chat.',
  [T.createProject]: 'Crea un nuovo progetto',
  [T.updateProject]: 'Aggiorna Progetto',
  [T.createNewProject]: 'Crea Nuovo Progetto',
  [T.createProjectDescription]:
    'Crea un progetto separato per organizzare la conversazione.',
  [T.projectName]: 'Nome del Progetto',
  [T.projectDescriptionPlaceholder]:
    'Aggiungi una descrizione per il tuo progetto',
  [T.removeFromProject]: 'Rimuovi da Progetto',
  [T.addSources]: 'Aggiungi Fonti',
  [T.noSharedProjectsTitle]: 'Nessun progetto condiviso al momento',
  [T.noSharedProjectsDescription]:
    'I progetti condivisi con te appariranno qui.',
  [T.noProjectChatsTitle]: 'Non hai ancora chat',
  [T.noProjectChatsDescription]:
    'Avvia una nuova chat per iniziare la conversazione. Nessuna chat al momento!',
  [T.noProjectSourcesTitle]: 'Non hai ancora fonti',
  [T.noProjectSourcesDescription]:
    "Richiedi l'accesso per visualizzare le fonti del progetto.",
  [T.noExistingProject]: 'Nessun progetto esistente trovato',
  [T.noExistingProjectDescription]:
    'Crea un progetto per organizzare le tue conversazioni.',
  [T.failedFetchingProject]: 'Impossibile recuperare il progetto.',
  [T.failedFetchingProjects]: 'Impossibile recuperare i progetti.',
  [T.failedDeletingProjects]: 'Impossibile eliminare i progetti.',
  [T.deleteProject]: 'Elimina Progetto!',
  [T.projectDeleteConfirmation]:
    'Sei sicuro di voler eliminare questo progetto?',
  [T.projectDeleteSuccess]: 'Progetto eliminato con successo.',
  [T.projectUpdateSuccess]: 'Progetto aggiornato con successo.',
  [T.projectCreationSuccess]: 'Progetto creato con successo.',
  [T.projectShareSuccess]: 'Progetto condiviso con successo.',
  [T.projectForkDisclaimerText]:
    'Questa conversazione è tra EmpowerGPT e {{username}}. Rispondere avvierà un nuovo ramo.',
  [T.projectNameAlreadyExists]: 'Esiste già un progetto con lo stesso nome.',

  // Invite User
  [T.inviteUserStep1Title]: 'Invitare: Aprire il menu',
  [T.inviteUserStep1Description]: `I pulsanti del menu contengono i collegamenti alle pagine necessarie per la configurazione, la gestione dell'applicazione e dell'account.`,
  [T.inviteUserStep2Title]: 'Invito: Andare alla pagina degli utenti',
  [T.inviteUserStep2Description]: `La pagina Utenti contiene l'elenco di tutte le persone attualmente presenti sulla piattaforma empowerGPT. Gli amministratori possono invitare gli utenti da questa pagina.`,
  [T.inviteUserStep3Title]: `Invito: Digitare l'e-mail dell'invitato`,
  [T.inviteUserStep3Description]: `Digitare i messaggi di posta elettronica degli invitati, selezionare il tipo di account e gli eventuali gruppi di utenti prima di inviare l'invito.`,

  // Chat models comments and descriptions
  [T.mistralLargeComment]: 'Alternanza',
  [T.mistralLargeDescription]: `Ospitato su Microsoft Azure nell'UE`,
  [T.llama370BInstructComment]: 'Open Source',
  [T.llama370BInstructDescription]: `Ospitato su Microsoft Azure nell'UE`,
  [T.llama38BInstructComment]: 'Open Source',
  [T.llama38BInstructDescription]: `Ospitato su Microsoft Azure nell'UE`,
  [T.gpt4TurboComment]: 'Preciso',
  [T.gpt4TurboDescription]: `Ospitato su Microsoft Azure nell'UE`,
  [T.gpt432kComment]: 'Il meglio',
  [T.gpt432kDescription]: `Ospitato su Microsoft Azure nell'UE`,
  [T.gpt4oComment]: 'Veloce e preciso',
  [T.gpt4oDescription]: `Ospitato su Microsoft Azure nell'UE`,
  [T.cohereComment]: 'Impresa ottimizzata',
  [T.cohereDescription]: `Ospitato su Microsoft Azure nell'UE`,
  [T.gpt35Turbo16kComment]: 'Veloce',
  [T.gpt35Turbo16kDescription]: `Ospitato su Microsoft Azure nell'UE`,
  [T.deepseekV3Comment]: 'Veloce',
  [T.deepseekV3Description]: `Ospitato su Microsoft Azure nell'UE`,
  [T.accuracy]: 'Precisione',
  [T.speed]: 'Velocità',
  [T.price]: 'prezzo',
  [T.tokenLimit]: 'token Limite',
  [T.imageAnalysis]: 'analisi dell immagine',
  [T.knowledgeCutoff]: 'conoscenza di cutoff',

  // Prompts
  [T.promptTitle1]: 'Accorciare i tempi',
  [T.promptText1]:
    'Riducete il seguente testo a [inserire_parole_contenute] parole, assicurandovi di mantenere tutte le informazioni importanti: [inserire_testo_qui].',
  [T.promptTitle2]: 'Fare più a lungo',
  [T.promptText2]:
    'Espandete il seguente testo fino a [inserire_parole_contenute] parole, assicurandovi che non vengano aggiunti dettagli irrilevanti: [inserire_testo_qui].',
  [T.promptTitle3]: 'Cambiare tono',
  [T.promptText3]:
    'Riscrivete il seguente testo con un tono [specificato_tono], assicurando che il messaggio rimanga chiaro ed efficace: [inserire_testo_qui].',
  [T.promptTitle4]: `Correggere la grammatica e l'ortografia`,
  [T.promptText4]: `Correggete la grammatica e l'ortografia del testo seguente, evidenziando tutte le modifiche e rendendo le parole corrette in grassetto: [inserire_testo_qui].`,
  [T.promptTitle5]: 'Tradurre',
  [T.promptText5]:
    'Tradurre il seguente testo in [lingua_specificata], assicurandosi che tutte le entità nominate, le abbreviazioni e gli acronimi siano accuratamente conservati: [inserire_testo_qui].',
  [T.promptTitle6]: 'Riassumere',
  [T.promptText6]:
    'Riassumete il seguente testo in [numero_di_parole] parole, assicurandovi che tutte le informazioni importanti siano mantenute e che il messaggio complessivo rimanga invariato: [inserire_testo_qui].',
  [T.promptTitle7]: 'Dare un feedback',
  [T.promptText7]:
    'Fornite un feedback sul seguente testo, concentrandovi sulle aree specificate: [tecnica, tono, grammatica, formato]. Assicuratevi che il vostro feedback sia costruttivo e contribuisca a migliorare il testo: [inserire_testo_qui].',
  [T.promptTitle8]: 'Brainstorming di idee',
  [T.promptText8]:
    'Fate un brainstorming di [numero_di_idee] idee creative e pratiche per il seguente compito: [compito+esempi_opzionali].',
  [T.promptTitle9]: `Scrivere un'e-mail`,
  [T.promptText9]: `Scrivete un'e-mail basata sulla trasmissione del seguente messaggio: [messaggio]. Assicuratevi che il tono sia [tono_specificato] e che la lunghezza dell'e-mail sia [lunghezza_specificata].`,
  [T.promptTitle10]: 'Scrivere un post sui social media',
  [T.promptText10]:
    'Scrivete un post sui social media per [piattaforma_specificata] mantenendo un tono [tono_specificato], rivolto a [pubblico_destinatario]. Includere contenuti coinvolgenti e adatti alla piattaforma.',

  // Mini Experts - Doc Analyst
  [T.miniExperts]: 'Apps',
  [T.docAnalyst]: 'Analista Documenti',
  [T.docAnalystDescription]: `Analizzare i documenti aziendali per estrarre rapidamente le informazioni chiave rispetto a un elenco di domande.`,
  [T.docClassifierDescription]:
    'Categorizzare ed etichettare i documenti in base al loro contenuto rispetto a un elenco di etichette.',
  [T.smartMeetDescription]:
    'Riassumete le riunioni per catturare rapidamente i punti chiave rispetto a un formato definito.',
  [T.dataAnalystSummary]:
    'Analizza i file Excel per individuare tendenze, modelli e approfondimenti.',
  [T.analysis]: 'Analisi',
  [T.documentClassification]: 'Classificatore di documenti',
  [T.comingSoon]: 'Prossimamente',
  [T.summaryGenerator]: 'Generatore di riepilogo',
  [T.confirmationDialog]: 'Finestra di dialogo di conferma',
  [T.dataCollections]: 'Raccolte Dati',
  [T.initiate]: 'Inizia',
  [T.newAnalysis]: 'Nuova analisi',
  [T.initiateAnalysis]: 'Inizia Analisi',
  [T.dataset]: 'Set di Dati',
  [T.inProcessFiles]: 'I seguenti file sono in lavorazione.',
  [T.questionnaire]: 'Questionario',
  [T.runAnalysis]: 'Esegui Analisi',
  [T.runAnalysisPlaceholder]: `Per avviare l'analisi, inserire il nome dell'analisi.\nSelezionare il set di dati e il questionario, quindi cliccare su ”`,
  [T.importFromApp]: "Importa dall'App",
  [T.regenerateAnalysis]: 'Rigenera Analisi',
  [T.saveAnalysis]: 'Salva Analisi',
  [T.numberOfFiles]: 'Numero di file',
  [T.numberOfQuestions]: 'Nr. domande',
  [T.clone]: 'Clone',
  [T.filesImportSuccess]: 'File/Cartella importati con successo',
  [T.filesImportFailure]: 'Importazione di file/cartelle non riuscita',
  [T.spSitePermissionDenied]:
    "Questo sito SharePoint non è abilitato per l'importazione. Contatta il tuo amministratore per richiedere l'accesso.",
  [T.import]: 'Importa',
  [T.analysisTitle]: "Titolo dell'Analisi",
  [T.enterAnalysisTitle]: "Inserisci il titolo dell'analisi",
  [T.datasetTitle]: 'Titolo del Dataset',
  [T.analysisDeleteConfirmation]: "Sei sicuro di voler eliminare l'analisi?",
  [T.analysisDeleteSuccess]: 'Analisi eliminata con successo!',
  [T.analysisDeleteFailed]:
    "L'eliminazione dell'analisi non è riuscita. Riprovare più tardi!",
  [T.datasetDeleteConfirmation]: 'Sei sicuro di voler cancellare il dataset?',
  [T.datasetDeleteSuccess]: 'Il dataset è stato cancellato con successo!',
  [T.datasetDeleteFailed]: `L'eliminazione del set di dati non è riuscita. Riprovare più tardi!`,
  [T.questionnaireDeleteConfirmation]:
    'Sei sicuro di voler cancellare il questionario?',
  [T.questionnaireDeleteSuccess]: 'Questionario cancellato con successo!',
  [T.questionnaireDeleteFailed]:
    'Cancellazione del questionario non riuscita. Riprovare più tardi!',
  [T.addQuestionnaire]: 'Nuovo questionario',
  [T.title]: 'Titolo',
  [T.addQuestion]: 'Aggiungi domanda',
  [T.questionnaireTitlePlaceholder]: 'Inserire il titolo del questionario',
  [T.questionnaireQuestionPlaceholder]: 'Inserire la domanda',
  [T.questionnaireCreationSuccess]: 'Questionario creato con successo.',
  [T.questionnaireCreationFailure]:
    'La creazione del questionario non è riuscita.',
  [T.questionnaireUpdateFailure]:
    'Aggiornamento del questionario non riuscito.',
  [T.datasetCorrupted]: 'File sorgente cancellato',
  [T.selectItemsToImport]: 'Seleziona elementi da importare',
  [T.importFilesDisclaimer]: 'Puoi selezionare 10 elementi',
  [T.analysisCancelSuccess]: 'Analisi annullata con successo!',
  [T.questionUpdatedSuccess]: 'Questionario aggiornato con successo',
  [T.maximumDatasetSize]: 'Massimo 10 file consentiti in un set di dati',
  [T.minimumDatasetSize]:
    'Per creare un set di dati è necessario almeno 1 file.',
  [T.questionnaireBlocked]: `Il questionario non può essere modificato a causa dell'associazione.`,
  [T.analysisFailed]: 'Documento Analisi fallita',
  [T.analysisResourceFailure]:
    'Errore! La risorsa o le risorse del dataset non esistono.',
  [T.analysisLimit]: `Limite delle analisi in corso raggiunto! Si prega di attendere poiché è in corso un'altra analisi.`,
  [T.analysisEditingBlocked]: `Modifica dell'analisi bloccata. Attendere il completamento dell'analisi in corso.`,
  [T.closeAnalysisTitle]:
    'Annullamento della risposta/ Esecuzione in background',
  [T.newQuestionnaire]: 'Nuovo questionario',
  [T.cancelAnalysis]: 'Annulla analisi',
  [T.runInBackground]: 'Esegui in background',
  [T.continueAnalysis]: 'Continua lanalisi',
  [T.newDataset]: 'Nuovo set di dati',
  [T.questionnaireDescription]:
    'Creare un elenco di domande per lanalisi dei documenti.',
  [T.analysisDescription]:
    'Analizzare gli insiemi di dati documentali con questionari specifici.',
  [T.skeletonTitle]: 'Siete pronti a eseguire la vostra prima analisi?',
  [T.skeletonDescription]:
    'Creare domande, scegliere insiemi di dati e scoprire intuizioni. Trasformate i vostri dati aziendali in risposte precise e attuabili.',
  [T.analysisPlaceHolderTitle]: 'Non avete fatto alcuna analisi!',
  [T.datasetPlaceHolderTitle]: 'Non avete nessun set di dati disponibile!',
  [T.createDataset]: 'Crea insieme di dati',
  [T.questionnairePlaceHolderTitle]: 'Non hai alcun questionario disponibile!',
  [T.createQuestionnaire]: 'Crea questionario',
  [T.startAnalysis]: 'Avvia analisi',
  [T.uploadFilesText]: 'Puoi caricare documenti, audio e video. (max. 100MB)',
  [T.processingFiles]: 'I file caricati vengono elaborati',
  [T.datasetDescription]: 'Creare set di dati per i documenti da analizzare',
  [T.inProgressAnalysis]: 'Annullamento dellanalisi',
  [T.inProgressAnalysisDescription]: `Le risposte alla domanda rimanente non saranno generate dall'annullamento dell'analisi?`,
  [T.regenerateResponse]: 'Risposta rigenerante',
  [T.updateQuestionnaire]: 'Questionario di aggiornamento',
  [T.updateAssociatedQuestionnaireDescription]:
    'Il questionario con associazione precedente non può essere aggiornato.',
  [T.newQuestionnaireDescription]: 'Salva una nuova copia del questionario.',
  [T.saveNew]: 'Salva nuovo',
  [T.analysisQuestionnaireUpdateLimit]:
    'Il questionario associato ad altre analisi non può essere aggiornato.',
  [T.newAnalysisTooltip]: `Analisi è già in corso`,
  [T.analysisDetail]: `Dettaglio dell'analisi`,
  [T.selectDataset]: 'Selezionare il set di dati',
  [T.selectQuestionnaire]: 'Selezionare il questionario',
  [T.docAnalystDuplicationError]: `Esiste già un articolo con lo stesso titolo.`,
  [T.edited]: 'Modificato',
  [T.generating]: 'Generazione',
  [T.updateQuestionnairePending]: 'Questionario di aggiornamento in attesa',
  [T.updateQuestionnairePendingDescription]:
    'Aggiornare il questionario prima di uscire.',
  [T.dateCreated]: 'Data di creazione',
  [T.clearAll]: 'Cancella tutto',
  [T.questionnaireAssociationMsg]: `Non puoi modificare il questionario a causa della sua associazione con l'analisi.`,
  [T.questionnaireName]: 'Nome del questionario',
  [T.enterQuestionnaireName]: 'Inserisci il nome del questionario',
  [T.updateQuestionnaireDescription]:
    'Il questionario è aggiornato. Fare clic su "Aggiorna" per salvare le modifiche.',
  [T.updateQuestionnaireDialogTitle]: 'Salva le modifiche nel questionario',
  [T.createdOn]: 'Creato il',
  [T.datasetDeletedTooltip]:
    'Il dataset originale è stato cancellato / modificato dal proprietario.',
  [T.mainFeatures]: 'Caratteristiche principali',
  [T.model]: 'Modello',
  [T.fromDate]: 'Data di Inizio',
  [T.sendQuestionnaire]: 'Invia questionario',
  [T.sentTo]: 'Inviato a',
  [T.questionnaireSendSuccess]: 'Questionario inviato con successo',
  [T.receivedFrom]: 'Ricevuto da',
  [T.questionnaireNotSharedYet]: 'Non ancora condiviso con nessuno.',
  [T.sentHistory]: 'Storia inviata',
  [T.byMe]: 'By Me',
  [T.all]: 'Tutti',
  [T.filesDeletedInDatasetDisclaimer]: 'Alcuni file sono stati eliminati',
  [T.allFilesDeletedInDatasetDisclaimer]:
    'Tutti i file del dataset sono stati cancellati',
  [T.resourceName]: 'Nome risorsa',
  [T.received]: 'Ricevuto',
  [T.usageLimitReached]:
    'Limite di utilizzo raggiunto. Riprova alle {{availableAt}}.',
  [T.docAnalystUsageLimitReached]:
    'Limite di utilizzo raggiunto. Per favore riprova più tardi.',
  [T.simpleAnalysis]: 'Analisi semplice',
  [T.scoringAnalysis]: 'Analisi con punteggio',
  [T.statistics]: 'Statistiche',
  [T.responseRanges]: 'Intervalli di risposta tra',
  [T.goodResponse]: '81% – 100% per buone',
  [T.averageResponse]: '51% – 80% per medie',
  [T.badResponse]: '0% – 50% per scarse',
  [T.goodResponses]: 'Risposte buone',
  [T.averageResponses]: 'Risposte medie',
  [T.badResponses]: 'Risposte scarse',

  //Smart Meet
  [T.regenerate]: 'Rigenera',
  [T.short]: 'Breve',
  [T.medium]: 'Medio',
  [T.detailed]: 'Dettagliato',
  [T.playRecording]: 'Riproduci registrazione',
  [T.resumeRecording]: 'Riprendi registrazione',
  [T.maxTwoHours]: '(Massimo 2 ore)',
  [T.uploadRecording]: 'Carica registrazione',
  [T.askAboutConversation]: 'Chiedi a Empower di questa conversazione',
  [T.deleteMeetingSuccess]: 'Meeting eliminato con successo!',
  [T.deleteMeetingError]: 'Eliminazione della riunione non riuscita!',
  [T.smartMeet]: 'Incontro Intelligente',
  [T.newRecording]: 'Nuova registrazione',
  [T.processRecording]: 'Elabora registrazione',
  [T.enterTitle]: 'Inserisci il titolo',
  [T.notesParsingError]: "Errore nell'analisi delle note",
  [T.stopRecordingError]: "Errore nell'arresto della registrazione.",
  [T.storageUnavailableError]:
    "L'archiviazione del browser non è disponibile. Controlla le impostazioni del browser e lo spazio di archiviazione.",
  [T.transcriptionGenerationError]:
    'Errore nella generazione della trascrizione.',
  [T.summaryRegenerationAlert]:
    'Sei sicuro di voler continuare? Questa operazione rigenererà i dati della riunione.',
  [T.transcriptRegenerationAlert]:
    'Sei sicuro di voler continuare? Questa operazione rielaborerà l`audio e i dati della riunione.',
  [T.askEmpowerNoDataAlert]:
    'La chat non è disponibile per le riunioni condivise.',
  [T.discard]: 'Scarta',
  [T.meetingDeleteConfirmation]:
    'Sei sicuro di voler eliminare questa riunione?',
  [T.discardMeetingAlert]:
    'Sei sicuro di voler scartare questa riunione? Tutti i dati andranno persi.',
  [T.failedFetchingMeetings]: 'Impossibile recuperare le riunioni.',
  [T.fileProcessingRequestSubmitted]:
    "Il file è stato messo in coda per l'elaborazione.",
  [T.fileProcessingStarted]: 'Elaborazione del file in corso.',
  [T.fileProcessingCompleted]: 'Elaborazione file completata.',
  [T.embeddingsDeletionRequestSubmitted]:
    'Pulizia dei dati della riunione richiesta.',
  [T.embeddingsDeletionStarted]:
    'Cancellazione dei risultati di elaborazione precedenti.',
  [T.embeddingsDeletionCompleted]: 'Dati della riunione precedente rimossi.',
  [T.smJobInitiationError]:
    'Impossibile avviare la generazione dei dati Smart Meet. Fare clic su Riprova per riprovare.',
  [T.transcriptionNotFoundError]:
    'Impossibile trovare la trascrizione per la riunione.',
  [T.processingMeetingGenericError]:
    "Si è verificato un errore durante l'esecuzione di questo passaggio. Fare clic su Riprova per riprovare.",
  [T.meetingProcessingFailed]:
    'Elaborazione della riunione non riuscita. Fare clic su Riprova per riprovare.',

  [T.genericNameError]: 'Impossibile aggiornare il nome.',
  [T.pause]: 'Pausa',
  [T.resume]: 'Riprendi',
  [T.summaryDescription]:
    'Genera automaticamente i punti chiave e le azioni dai tuoi incontri.',
  [T.summaryMeeting]:
    'Riassumi le riunioni e crea azioni da intraprendere in pochi secondi.',
  [T.exportToPdf]: 'Esporta in PDF',
  [T.exportToExcel]: 'Esporta in Excel',
  [T.meetings]: 'Riunioni',
  [T.thisMeet]: 'Questo Incontro',
  [T.thisMeetTooltip]:
    'Fai domande, ottieni riepiloghi e trova informazioni su questa riunione. ',
  [T.askSmartMeet]: 'Smart Meet',
  [T.askSmartMeetTooltip]:
    'Poni domande, riepiloghi e trova informazioni relative a tutte le riunioni. ',
  [T.record]: 'Registra',
  [T.notes]: 'Note',
  [T.stop]: 'fermata',
  [T.addNotes]: 'Aggiungi note',
  [T.summary]: 'Sommario',
  [T.transcript]: 'Trascrizione',
  [T.actionItems]: 'Azioni da intraprendere',
  [T.renameSpeakers]: 'Rinomina i parlanti',
  [T.nameYourAttendees]: 'Indica i nomi dei partecipanti',
  [T.speakerDescription]:
    'Nella tua registrazione erano presenti {{count}} parlanti. Assegna un nome ai parlanti per facilitarne lidentificazione.',
  [T.tagSpeakers]: 'Tag Altoparlanti',
  [T.browseToSelectAudioFiles]: 'Sfoglia per selezionare i file audio',
  [T.onlyMP3FilesAllowed]: 'Sono consentiti solo file MP3',
  [T.meetingPurpose]: 'Scopo della riunione',
  [T.keyTakeaways]: 'Punti chiave',
  [T.addTakeAway]: 'Aggiungi takeaway',
  [T.topics]: 'Argomenti',
  [T.nextSteps]: 'Prossimi passi',
  [T.addSteps]: 'Aggiungi prossimi passi',
  [T.noActionItemsFound]: 'Nessuna azione trovata',
  [T.noTranscriptionAvailable]: 'Nessuna trascrizione disponibile',
  [T.noSummaryAvailable]: 'Nessuna sintesi disponibile',
  [T.inProgressRecordingHeader]: 'Fare doppio clic per impostare il titolo',
  [T.maxRecordingAllowed]:
    'Durata massima di registrazione consentita: 120 minuti',
  [T.meetingSummary]: 'Riepilogo della riunione',
  [T.noMeetingPurpose]: 'Nessuno scopo della riunione specificato.',
  [T.noKeyTakeaways]: 'Nessun punto chiave specificato.',
  [T.topicsDiscussed]: 'Argomenti discussi',
  [T.noTopicsListed]: 'Nessun argomento elencato.',
  [T.noTextAvailable]: 'Nessun testo disponibile.',
  [T.noActionItemsRecorded]: 'Nessuna azione registrata.',
  [T.noNotesRecorded]: 'Nessuna nota registrata.',
  [T.noThoughtProcessRecorded]: 'Nessun processo di pensiero registrato.',
  [T.failedToCreate]: 'Non è riuscito a creare ',
  [T.failedToUpdate]: 'Aggiornamento non riuscito',
  [T.updatingMeeting]: 'Aggiornamento della riunione...',
  [T.regeneratingMeeting]: 'Rigenerazione della riunione...',
  [T.meetingBeingProcessed]: 'La riunione è in fase di elaborazione',
  [T.stoppingRecording]: 'Registrazione in corso di arresto',
  [T.stoppedRecording]: 'Registrazione interrotta.',
  [T.generatingTranscript]: 'Generazione della trascrizione',
  [T.generatedTranscript]: 'Trascrizione generata.',
  [T.uploadingAudio]: 'Caricamento audio',
  [T.uploadedAudio]: 'Audio caricato.',
  [T.processingAudio]: 'Elaborazione audio',
  [T.processedAudio]: 'Audio elaborato.',
  [T.generatingData]: 'Generazione dei dati',
  [T.generatingMeetingData]: 'Generazione dei dati della riunione',
  [T.generatedMeetingData]: 'Dati della riunione generati.',
  [T.meetingCreated]: 'Riunione creata.',
  [T.meetingCreatedDone]: 'Riunione creata.',
  [T.meetingSharedSuccessfully]: 'Riunione condivisa con successo!',
  [T.recording]: 'Registrazione...',
  [T.fileNotProcessed]: 'Impossibile elaborare il file',
  [T.draftMeetingTooltip]:
    'Questa riunione è salvata come bozza e non può essere aperta.',
  [T.noExistingMeeting]: 'Nessuna riunione esistente trovata.',
  [T.noExistingMeetingDescription]:
    'Importa un file o registra una nuova riunione per avviare il tuo prossimo SmartMeet.',
  [T.restrictedLimitSmartMeetUpload]:
    'È possibile caricare un solo file alla volta.',
  [T.askAnything]: 'Chiedi qualsiasi cosa',
  [T.actionItemsQuery]:
    'Quali azioni o passi successivi sono stati identificati durante la riunione?',
  [T.participantsQuery]:
    'Come possono i partecipanti dare seguito alle questioni sollevate durante la riunione?',
  [T.mainTopicsQuery]:
    'Quali sono stati i principali argomenti discussi durante la riunione?',
  [T.mainTopicsQueryMultiple]:
    'Quali sono stati i principali argomenti discussi durante le riunioni?',
  [T.summarizeMeetingQuery]: 'Puoi riassumere la riunione in poche frasi?',
  [T.askAboutYourMeeting]:
    'Chiedi a EGPT qualsiasi cosa su questa conversazione!',
  [T.askAboutYourMeetings]: 'Chiedi a EGPT qualsiasi cosa sulle tue riunioni!',
  [T.uploadInProgressWarning]:
    'È in corso un caricamento. Sei sicuro di voler lasciare la pagina?',
  [T.transcriptInProgressWarning]:
    'È in corso la generazione della trascrizione. Sei sicuro di voler lasciare la pagina?',

  // Data Analyst
  [T.dataAnalyst]: 'Analista dei dati',
  [T.dataAnalystInfo]: 'Analizza i tuoi dati con insight basati sull’AI',
  [T.dataAnalystDescription]:
    'Il tuo esperto Gen AI tutto-in-uno per analizzare dati aziendali con query personalizzate.',
  [T.noExistingAnalysis]: 'Nessuna analisi esistente trovata.',
  [T.noExistingAnalysisDescription]:
    'Avvia una nuova analisi e chatta con i tuoi dati aziendali!',
  [T.dataAnalystWelcomeTitle]:
    'Carica il tuo file Excel e iniziamo ad analizzare!',

  // Document Analysis statuses
  [T.L_DA_CM]: 'Completato',
  [T.L_DA_IP]: 'Inprogresso',
  [T.L_DA_CN]: 'Annullato',
  [T.L_DA_FL]: 'Fallito',
  [T.L_DA_PC]: 'Parzialmente completato',
  [T.L_DA_RGR]: 'Rigenerante',
  [T.L_DA_DR]: 'Bozza',

  // Assistants
  [T.assistants]: 'Assistenti',
  [T.allAssistant]: 'Tutti',
  [T.createdByMe]: 'Creato da me',
  [T.creator]: 'Creatore',
  [T.createAssistant]: 'Crea Assistente',
  [T.updateAssistant]: 'Aggiorna Assistente',
  [T.assistantName]: "Nome dell'Assistente",
  [T.assistantDescription]: "Descrizione dell'Assistente",
  [T.assistantInstructions]: "Istruzioni dell'Assistente",
  [T.assistantModal]: 'Modalità Assistente',
  [T.assistantCreatedSuccessfully]: 'Assistente creato con successo',
  [T.assistantUpdatedSuccessfully]: 'Assistente aggiornato con successo',
  [T.assistantDeletedSuccessfully]: 'Assistente eliminato con successo',
  [T.deleteAssistantTitle]: 'Elimina assistente',
  [T.deleteAssistantConfirmation]:
    "Sei sicuro di voler eliminare l'assistente?",
  [T.deleteAssistantConfirmButton]: 'Sì, elimina',
  [T.noDescriptionAvailable]: 'Nessuna descrizione disponibile',
  [T.assistantNotReadyDisclaimer]:
    'Questo assistente non può ancora avviare una chat: necessita di una fonte di conoscenza e di un modello AI abilitato.',
  [T.noFilePermissionDisclaimer]:
    'Non hai i permessi per alcune risorse di conoscenza di questo assistente, quindi non verranno utilizzate.',
  [T.iconUploadedSuccessfully]: 'Icona caricata con successo',
  [T.namePlaceholder]: 'Dai un nome al tuo assistente',
  [T.descriptionPlaceholder]:
    'Aggiungi una breve descrizione di questo assistente.',
  [T.instructions]: 'Istruzioni',
  [T.customInstructions]: 'Istruzioni Personalizzate',
  [T.instructionsPlaceholder]:
    'Cosa fa questo assistente? Come dovrebbe comportarsi? Cosa dovrebbe evitare?',
  [T.conversationStarters]: 'Iniziatori di conversazioni',
  [T.conversationStartersErrorMessage]:
    'Gli iniziatori di conversazione non dovrebbero essere vuoti',
  [T.conversationStartersPlaceholder]:
    'Esempi di prompt per iniziare la conversazione.',
  [T.aiModels]: 'Modelli AI',
  [T.aiModelsPlaceholder]: 'Seleziona qualsiasi modello AI',
  [T.personaPlaceholder]: 'Seleziona una persona',
  [T.knowledgeAddFiles]: 'Conoscenza aziendale (Aggiungi file)',
  [T.addFiles]: 'Aggiungi file',
  [T.knowledgeAddFilesUploaded]: '{{totalFiles}}/{{filesLimit}} file caricati',
  [T.enterpriseKnowledge]: 'Conoscenza aziendale',
  [T.worldKnowledgeWithWebSearch]: 'Conoscenza mondiale con ricerca sul web',
  [T.knowledge]: 'Conoscenza',
  [T.addAllWorkspaceContent]: `Aggiungi tutto il contenuto dell'area di lavoro`,
  [T.addKnowledge]: 'Aggiungi conoscenza',
  [T.addKnowledgeDescription]:
    'Carica documenti, testo o codice, oppure cerca e aggiungi riunioni e file esistenti',
  [T.defaultEnabled]: 'Attivata per impostazione predefinita',
  [T.worldKnowledgeDescription]:
    "Consenti all'assistente di utilizzare la conoscenza mondiale per rispondere alle tue domande.",
  [T.enterpriseKnowledgeDescription]: `Consenti all'assistente di utilizzare tutte le integrazioni condivise, i file e altri asset nell'area di lavoro.`,
  [T.conversationStartersCount]: '{{totalCon}}/6 aggiunti',
  [T.getStartedByCreatingNewAssistant]: 'Inizia creando un nuovo assistente',
  [T.noAssistantsEmptyStateDescription]:
    'Non hai nessun assistente. Crea assistenti basati su istruzioni, conoscenza e flussi di lavoro multi-task.',
  [T.loadingAssistants]: 'Caricamento assistenti...',
  [T.loadingAssistant]: 'Caricamento assistente...',
  [T.newAssistant]: 'Nuovo assistente',
  [T.selectPersona]: 'Seleziona persona',
  [T.none]: 'Nessuna',
  [T.selectPersonaDescription]:
    'Scegli una persona predefinita per precompilare le istruzioni.',
  [T.purposeInstructions]: 'Scopo (Istruzioni)',
  [T.writePurposeInstructionsPlaceholder]:
    'Descrivi lo scopo, ad esempio cosa fa questo assistente, come dovrebbe comportarsi e cosa dovrebbe evitare di fare.',
  [T.describeYourAssistantOptional]: 'Descrivi il tuo assistente (opzionale)',
  [T.configureTabLabel]: 'Configura',
  [T.knowledgeTabLabel]: 'Conoscenza',
  [T.accessTabLabel]: 'Accesso',
  [T.assistantPageTitle]: 'Assistente',
  [T.assistantPageDescription]:
    'Ottimizza il tuo flusso di lavoro. Lascia che gli assistenti IA gestiscano onboarding, conformità e altro, così non devi farlo tu.',
  [T.assistantNameRequired]: `Il nome dell'assistente è obbligatorio`,
  [T.noChangesToSave]: 'Nessuna modifica da salvare',
  [T.savingInProgress]: 'Salvataggio in corso...',
  [T.nameMinLengthError]: 'Il nome deve contenere almeno 3 caratteri',
  [T.nameMaxLengthError]: 'Il nome non deve superare i 100 caratteri',
  [T.descriptionMaxLengthError]:
    'La descrizione non deve superare i 500 caratteri',
  [T.instructionsMaxLengthError]:
    'Le istruzioni non devono superare i 12000 caratteri',
  [T.starterMaxLengthError]:
    'Il messaggio iniziale non deve superare i 200 caratteri',
  [T.maxConversationStartersError]:
    'Massimo 6 spunti di conversazione consentiti',
  [T.assistantPreviewNoFiles]: `Aggiungi file al database di conoscenza aziendale dell'assistente per avviare una chat.`,
  [T.preview]: 'Anteprima',
  [T.chooseEmojis]: `Selezionare l'immagine`,
  [T.keepItPrivate]: 'Mantienilo privato',
  [T.emojiDisclaimer]: "Per caricare un'emoji deve essere inferiore a 500 Kb",
  [T.assistantFilesPermission]: 'Non hai accesso ai seguenti file',
  [T.assistantNoFiles]: `I file di conoscenza aziendale dell'assistente sono stati eliminati`,
  [T.noFilesDisclaimer]:
    "I file aggiunti alla conoscenza dell'Assistente sono stati eliminati dagli spazi di lavoro. I controllori dell'Assistente possono aggiungere nuovi file o modificare le capacità dell'Assistente per avviare una nuova chat con lui.",
  [T.addFileDisclaimer]:
    'Assicurati che i file aggiunti nella conoscenza siano accessibili agli utenti con cui sono condivisi',
  [T.errorConfirmationDialog]: 'Risolvi i seguenti errori prima di procedere',
  [T.assistantDeletedDisclaimer]:
    'Non è possibile continuare a chattare con un assistente eliminato.',
  [T.outdatedVersionText]: `Non è possibile continuare a chattare con una versione obsoleta di questo assistente. Avvio `,
  [T.revokedVersionText]: `Accesso ai file di conoscenza dell'assistente revocato. Non puoi continuare a chattare. Clicca `,
  [T.revokedAssistantPermission]: `Accesso all'assistente revocato. Non puoi continuare a chattare. `,
  [T.customizeAssistant]: `Personalizza le risposte del modello AI per i tuoi casi d'uso specifici.`,
  [T.newChat]: 'nuova chat',
  [T.here]: 'qui',
  [T.revokedAssistant]: ' per visualizzare i file.',
  [T.updatedAssistant]: ` con l'assistente aggiornato.`,
  [T.assistantUniqueViolationError]: `L'assistente con lo stesso nome esiste già`,
  [T.noAiModelDisclaimer]: `Il modello AI dell'assistente è stato disattivato dall'amministratore. I controllori dell'assistente possono assegnargli un nuovo modello o richiedere l'accesso dell'amministratore al modello disabilitato per avviare una nuova chat.`,
  [T.noAiModelTitle]: 'Modello AI configurato disabilitato',
  [T.stayOnThisPage]: `Rimani su questa pagina`,
  [T.aiModelErrorMessage]: `Seleziona un modello AI`,
  [T.aiModelDisabledTooltip]: 'Il modello non supporta immagini come allegati.',
  [T.createUpdateConfirmationDialogTitle]: `Modifiche non salvate`,
  [T.leaveWithoutSaving]: `Esci senza salvare`,
  [T.createUpdateConfirmationDisclaimer]: `Stai per lasciare questa pagina con modifiche non salvate.`,
  [T.discardChangesTitle]: `Ignorare le modifiche?`,
  [T.discardChangesDisclaimer]: `Stai lasciando questa pagina con modifiche non salvate. Tutti i progressi andranno persi.`,
  [T.addImage]: `Aggiungi immagine`,
  [T.changeImage]: `Cambia immagine`,
  [T.uploadOrChooseAnImage]: `Carica o scegli un'immagine`,
  [T.close]: 'Chiudere',
  [T.assistantDeleted]: 'Assistente Soppresso',
  [T.conversationStarterErrorMessage]: `L'Assistant Starter non può essere più lungo di 300 caratteri`,
  [T.viewMore]: 'Vedi altro',
  [T.viewLess]: 'Vedi meno',
  [T.assistantSelfAssignmentError]: `L'autoassegnazione/disassegnazione di una risorsa non è consentita!`,
  [T.chatUnavailable]: 'Chat non disponibile',
  [T.shareUsingLink]: 'Condividi usando il link',
  [T.linkCopied]: 'Link copiato',
  [T.shareAssistantInviteDescription]:
    'Invita i tuoi colleghi e costruisci una responsabilità condivisa per questo agente.',
  [T.roleDescription]: 'Ruolo per gli utenti EmpowerGPT con il link',
  [T.errorGeneratingLink]: 'Errore durante la generazione del link',
  [T.filesInProcessTitle]:
    'I file di conoscenza dell’assistente sono in fase di elaborazione.',
  [T.filesInProcessDesc]:
    'La chat non è temporaneamente disponibile fino a quando tutti i documenti di conoscenza dell’assistente non saranno elaborati con successo. I seguenti file sono in fase di elaborazione:',
  [T.customLicense]: 'Licenza personalizzata',
  [T.creditsPerMonth]: 'Crediti al mese',
  [T.autoExpiry]: 'Scadenza automatica',
  [T.filesUploadLimit]: 'Limite di caricamento/importazione file per volta',
  [T.userLimit]: 'Limite utenti',
  [T.maxSearchPlus]: 'Limite Search+ (al mese)',
  [T.workflowRuns]: 'Esecuzioni del flusso di lavoro (al mese)',
  [T.workflowCredits]: 'Crediti del flusso di lavoro (%)',
  [T.workflowRunsRequired]:
    'Le esecuzioni del flusso di lavoro sono obbligatorie',
  [T.percentageRange]: 'Inserisci un valore compreso tra 0 e 100',
  [T.maxDocAnalystAnalysis]: 'Analisi documenti (al mese)',
  [T.maxDocAnalystQuestionPerAnalysis]: 'Domande doc analyst per analisi',
  [T.maxOcrFiles]: 'File OCR (al mese)',
  [T.maxSmartMeetDurationSecs]: 'Durata Smart Meet (secondi, al mese)',
  [T.maxDataAnalystQuery]: 'Query data analyst (al mese)',
  [T.unlimitedAccess]: 'Illimitato',
  [T.createTenants]: 'Crea tenant',
  [T.maxExpiryDateError]:
    'La data di scadenza deve essere inferiore o uguale a 1 mese a partire da oggi',
  [T.tenantPlan]: 'Piano tenant',
  [T.expiryDays]: 'Giorni di scadenza obbligatori',
  [T.fileUploadLimit]: 'Limite di upload dei file obbligatorio',
  [T.userLimitRequired]: 'Limite utenti obbligatorio',
  [T.expiryDate]: 'Scade il',
  [T.expiryDateRequired]: 'La data di scadenza è obbligatoria',
  [T.trialExpiryMaxOneMonth]:
    'La scadenza della prova può essere al massimo tra un mese da oggi',
  [T.license]: 'Licenza',
  [T.block]: 'Blocca',
  [T.numberGreaterThanZero]: 'Inserisci un numero maggiore di 0',
  [T.minimumValueShouldBeOne]: 'Il valore minimo dovrebbe essere 1',
  [T.updateTenant]: 'Aggiornamento degli inquilini',
  [T[PERSONA_TYPE.PROJECT_MANAGER_ASSISTANT]]: 'Assistente del Project Manager',
  [T[PERSONA_TYPE.DEVELOPER_COMPANION]]: 'Compagno dello Sviluppatore',
  [T[PERSONA_TYPE.STUDENT_STUDY_BUDDY]]: 'Compagno di Studio',
  [T[PERSONA_TYPE.SALES_CRM_STRATEGIST]]: 'Stratega Vendite & CRM',
  [T[PERSONA_TYPE.KNOWLEDGE_OPS_ANALYST]]:
    'Analista della Gestione della Conoscenza',
  [T[PERSONA_TYPE.EXECUTIVE_ASSISTANT]]: 'Assistente Esecutivo',
  [T[PERSONA_TYPE.CUSTOMER_SUPPORT_AGENT_TRAINER]]:
    'Formatore degli Agenti di Supporto Clienti',

  [T[`${PERSONA_TYPE.PROJECT_MANAGER_ASSISTANT}-desc`]]:
    'Sono l’Assistente del Project Manager. Voglio tenere traccia delle scadenze, monitorare le consegne e garantire una collaborazione fluida tra i team. Ti aiuto a gestire progetti complessi organizzando i compiti, riassumendo le riunioni e mantenendo tutti allineati.',

  [T[`${PERSONA_TYPE.DEVELOPER_COMPANION}-desc`]]:
    'Sono il Compagno dello Sviluppatore. Voglio scrivere codice pulito, risolvere i bug più velocemente e non rimanere mai bloccato. Ti aiuto a spiegare il codice, generare snippet riutilizzabili e navigare nel tuo stack tecnologico e nella documentazione in modo efficiente.',

  [T[`${PERSONA_TYPE.STUDENT_STUDY_BUDDY}-desc`]]:
    'Sono il tuo Compagno di Studio. Voglio comprendere argomenti difficili, prepararmi bene per gli esami e rimanere organizzato nello studio. Ti aiuto a semplificare concetti complessi, riassumere gli appunti delle lezioni e creare materiali di studio personalizzati.',

  [T[`${PERSONA_TYPE.SALES_CRM_STRATEGIST}-desc`]]:
    'Sono lo Stratega delle Vendite. Voglio costruire relazioni solide con i clienti e concludere accordi più rapidamente. Ti aiuto a riassumere i dati del CRM, redigere messaggi persuasivi e offrire approfondimenti per migliorare le tue vendite.',

  [T[`${PERSONA_TYPE.KNOWLEDGE_OPS_ANALYST}-desc`]]:
    'Sono l’Analista della Conoscenza. Voglio mantenere le informazioni interne ordinate, accessibili e utili per l’intero team. Ti aiuto a trovare risposte rapidamente, mantenere documentazioni chiare e strutturare al meglio la base di conoscenza.',

  [T[`${PERSONA_TYPE.EXECUTIVE_ASSISTANT}-desc`]]:
    'Sono l’Assistente Esecutivo. Voglio assicurarmi che nulla venga dimenticato, dalle riunioni cruciali alle decisioni strategiche. Ti aiuto redigendo comunicazioni, riassumendo report chiave e gestendo la tua agenda per permetterti di concentrarti sulla leadership.',

  [T[`${PERSONA_TYPE.CUSTOMER_SUPPORT_AGENT_TRAINER}-desc`]]:
    'Sono il Formatore del Supporto Clienti. Voglio fornire un’assistenza clienti rapida, accurata e coerente. Ti aiuto analizzando i ticket, redigendo risposte chiare e preparando materiali di onboarding per far avere successo al tuo team di supporto.',

  // Confluence
  [T.contentImportFromConfluence]: 'Atlassian Confluence',
  [T.confluenceModalTitle]: 'Importare contenuti da Confluence',
  [T.confluenceModalSubtitle]:
    "Naviga all'interno di Confluence e seleziona i contenuti richiesti per l'importazione.",
  [T.confluenceMySpaces]: 'I miei spazi',
  [T.confluenceSharedSpaces]: 'Spazi condivisi',
  [T.openInConfluence]: 'Apri in Confluence',
  [T.confluenceResourceProviderWelcomeTitle]:
    "Passaggi per configurare l'importazione da Confluence",
  [T.confluenceWelcomeInstruction1]:
    "Dettagli sull'account amministratore dell'organizzazione Atlassian.",
  [T.confluenceWelcomeInstruction2]:
    "Crea e configura un'app OAuth 2.0 in Atlassian Developer.",
  [T.confluenceWelcomeInstruction3]:
    "Inserisci i dettagli per l'applicazione creata.",
  [T.confluenceWelcomeInstruction4]:
    "Aggiungi le autorizzazioni richieste all'ambito API dell'applicazione creata.",
  [T.confluenceConfigurationSuccessTitle]:
    'Importazione da Confluence configurata',
  [T.confluenceConfigurationSuccessDescription1]:
    'Ora è possibile importare contenuti da Confluence in EmpowerGPT come raccolte.',
  [T.confluenceConfigurationSuccessDescription2]:
    'La visibilità dei contenuti importati si baserà sulle autorizzazioni definite in Confluence.',
  [T.confluenceAdminConfigurationStep1Start]: 'In una nuova scheda, vai alla ',
  [T.atlassianManagementText]:
    "pagina di gestione del token API dell'account Atlassian.",
  [T.confluenceAdminConfigurationStep1End]:
    " Assicurati di accedere con l'account amministratore dell'organizzazione Atlassian.",
  [T.confluenceAdminConfigurationStep2]:
    'Clicca sul pulsante “Crea token API” e inserisci un nome adatto, ad esempio “EmpowerGPT - [Nome Azienda]”.',
  [T.confluenceAdminConfigurationStep3]:
    "Dopo aver cliccato su Crea, sarà possibile copiare il token API. Incolla il token API insieme all'indirizzo email dell'admin dell'organizzazione.",
  [T.apiTokenRequired]: 'Il token API è richiesto',
  [T.apiToken]: 'TOKEN API',
  [T.confluenceAdminConfigurationStep4]:
    "Incolla l'URL di base per le applicazioni Atlassian della tua organizzazione qui sotto. (Ad esempio, se il nome della tua organizzazione è Contoso, l'URL di base sarà https://contoso.atlassian.net/wiki)",
  [T.invalidConfluenceUrl]: 'URL base di Confluence fornito non valido.',
  [T.confluenceStep1Title]:
    "Dettagli sull'account amministratore dell'organizzazione Atlassian",
  [T.atlassianBaseUrl]: 'URL base Atlassian',
  [T.confluenceStep2Title]:
    "Crea e configura un'app OAuth 2.0 in Atlassian Developer",
  [T.confluenceStep2Instruction1Start]: 'In una nuova scheda, accedi a ',
  [T.confluenceStep2Instruction1End]: 'Atlassian Developer.',
  [T.confluenceStep2Instruction2]:
    "Una volta effettuato l'accesso, clicca sul “Menu Utente” in alto a destra e seleziona “Developer Console” dal menu a discesa.",
  [T.confluenceStep2Instruction3]:
    'Clicca sul pulsante “Crea” nella sezione “Le mie app” e seleziona “Integrazione OAuth 2.0” dal menu a discesa.',
  [T.confluenceStep2Instruction4]:
    "Inserisci un nome adatto per l'applicazione, ad esempio “EmpowerGPT - [Nome Azienda]”. Seleziona la casella per accettare i termini per gli sviluppatori Atlassian e clicca su “Crea”.",
  [T.confluenceStep2Instruction5]:
    "Dopo la creazione, verrai indirizzato alla pagina “Panoramica” dell'applicazione. Vai alla pagina “Autorizzazione” e clicca su “Aggiungi” accanto a “OAuth 2.0 (3LO)” per abilitare l'autorizzazione utente.",
  [T.confluenceStep2Instruction6]:
    'Incolla il seguente URL nel campo “Callback URL” e clicca su “Salva modifiche”.',
  [T.callBackUrl]: 'URL di Callback',
  [T.confluenceStep2Instruction7]:
    'Ora vai alla pagina “Distribuzione” e clicca su “Modifica” davanti alla sezione “Controlli di distribuzione”. Cambia lo stato di distribuzione in “Condivisione”.',
  [T.confluenceStep2Instruction8]:
    'Aggiungi il nome della tua azienda come nome del fornitore e incolla il seguente link nel campo della privacy policy.',
  [T.privacyPolicy]: 'Privacy Policy',
  [T.privacyPolicyRequired]: 'Privacy Policy richiesta',
  [T.confluenceStep2Instruction9]:
    'Seleziona “No” dal menu a tendina “La tua app memorizza dati personali?” e clicca su “Salva modifiche” alla fine.',
  [T.appCreationStepsPerformed]:
    'Tutti i passaggi precedenti sono stati eseguiti in Atlassian Developer.',
  [T.confluenceStep3Title]: "Inserisci i dettagli dell'applicazione creata",
  [T.confluenceStep3Instruction1]: 'Vai alla pagina “Impostazioni”.',
  [T.confluenceStep3Instruction2]:
    "Copia l'ID cliente e il segreto e inserisci ciascuno nel rispettivo campo qui sotto.",
  [T.clientId]: 'ID Cliente',
  [T.clientSecret]: 'Segreto',
  [T.confluenceStep4Title]:
    "Aggiungi le autorizzazioni richieste all'applicazione creata",
  [T.confluenceStep4Instruction1]:
    'Vai alla pagina “Permessi” e clicca su “Aggiungi” accanto alla riga “API di Confluence”. Il pulsante “Aggiungi” dovrebbe diventare “Configura”.',
  [T.confluenceStep4Instruction2]:
    'Clicca sul pulsante “Configura” e poi su “Modifica ambiti” sotto la scheda “Ambiti classici”.',
  [T.confluenceStep4Instruction3]:
    'Seleziona le seguenti autorizzazioni attivando le caselle nella colonna “Seleziona”.',
  [T.confluenceStep4Instruction3a]:
    'Leggi il riepilogo dello spazio di Confluence',
  [T.confluenceStep4Instruction3b]:
    'Leggi il riepilogo dei contenuti di Confluence',
  [T.confluenceStep4Instruction3c]:
    'Leggi i contenuti dettagliati di Confluence',
  [T.confluenceStep4Instruction4]:
    "I passaggi sopra sono stati eseguiti sull'applicazione creata in Atlassian Developer.",
  [T.resourceProviderConfluenceEnabledSuccessfully]:
    'Confluence abilitato con successo.',
  [T.resourceProviderConfluenceDisabledSuccessfully]:
    'Confluence disabilitato con successo.',
  [T.errorUpdatingConfluence]: "Errore durante l'aggiornamento di Confluence.",
  [T.resourceProviderConfluenceCreationFailed]:
    "Errore durante l'abilitazione di Confluence.",
  [T.viewDetails]: 'Visualizza dettagli',
  [T.hideDetails]: 'Nascondi dettagli',
  [T.authWindowClosed]: 'La finestra di autenticazione è stata chiusa.',
  [T.tokenExchangeFailed]: 'Scambio di gettoni fallito',
  [T.failedRefreshToken]: 'Impossibile aggiornare il token di accesso',
  [T.errorDecodingToken]: 'Errore nella decodifica del token: ',
  [T.noWhitespaceAllowed]: 'Rimuovere gli spazi bianchi',
  [T.browseToSelect]: 'Sfoglia per selezionare',
  [T.browseToSelectDocs]: 'Sfoglia per selezionare documenti',
  [T.viewDocuments]: 'Visualizza documenti',
  [T.selectAllFiles]: 'Spazi di lavoro completi',
  [T.allEnterpriseKnowledgeInfo]:
    'Questo assistente avrà accesso a tutti i contenuti nei tuoi spazi di lavoro',
  [T.selectFromWorkspace]: "Seleziona dall'area di lavoro",
  [T.selectFromWorkspaces]: 'Seleziona dagli spazi di lavoro',
  [T.uploadUpToFiles]: 'Carica (fino a {{ files }} file)',
  [T.uploadFilesProgress]: 'Carica ({{ uploaded }}/{{ limit }} file)',
  [T.uploadLimitReached]: 'Limite di caricamento raggiunto',
  [T.uploadNew]: 'Carica nuovo',
  [T.controller]: 'Controllore',

  // Settings
  [T.systemSettings]: 'Impostazioni di sistema',
  [T.security]: 'Sicurezza',
  [T.documentsUploaded]: 'Documenti caricati',
  [T.assistantsCreated]: 'Assistenti creati',
  [T.aboutYou]: 'A proposito di te',
  [T.aboutYouSubtitle]:
    'Queste informazioni verranno utilizzate per personalizzare la tua esperienza',
  [T.companyName]: "Nome dell'azienda",
  [T.department]: 'Dipartimento',
  [T.jobRole]: 'Ruolo lavorativo',
  [T.country]: 'Paese',
  [T.deleteAccount]: 'Elimina account',
  [T.deleteAccountInfo]:
    "Elimina definitivamente l'intero account, i documenti caricati in My Workspace e le tue chat. Questa operazione è irreversibile.",
  [T.enableForNewChats]: 'Abilita per nuove chat',
  [T.aboutYouLabel]:
    'Parla di te a EmpowerGPT per ottenere risposte più personalizzate.',
  [T.aboutYouPlaceholder]:
    '- Cosa fai principalmente al lavoro?\n- Quali sono le tue principali responsabilità?',
  [T.giveInstructionsLabel]: 'Come vorresti che rispondesse EmpowerGPT?',
  [T.giveInstructionsPlaceholder]:
    '- Che tono dovrebbe usare EmpowerGPT: formale o informale?\n- Lunghezza preferita delle risposte di EmpowerGPT: breve o dettagliata?',
  [T.changePasswordLabel]:
    'La tua password è la chiave del tuo account. Assicurati che sia forte e sicura.',
  [T.settingsSavedSuccessfully]: 'Impostazioni salvate con successo',
  [T.profileUpdatedSuccessfully]: 'Profilo aggiornato con successo',

  // attach document and image
  [T.maxChatFileSize]:
    'Il file "{{ name }}" è troppo grande. La dimensione massima per i file di {{type}} è "{{ size }}mb".',
  [T.maxUploadedFileSize]:
    'Alcuni file superano il limite di dimensione previsto per il loro formato.',
  [T.maxUploadFile]: 'Il limite massimo di file allegati è "{{ files }}".',
  [T.unSupportedFile]:
    'Il file "{{ name }}" non è stato caricato a causa di un formato non supportato.',
  [T.webSearchOnMsg]:
    'Disabilita la ricerca web per abilitare la funzione di allegato dei file',
  [T.chatFileName]: ' {{ status }} {{ name }}',
  [T.uploading]: 'Caricamento',
  [T.preparing]: 'Preparazione',
  [T.processing]: 'Elaborazione',
  [T.processed]: 'Elaborato',
  [T.Unprocessed]: 'Non elaborato',
  [T.unsupportedFile]: 'Non supportato {{ name }}.',
  [T.uploadFailed]: 'CARICAMENTO_FALLITO',
  [T.retryMsg]: 'Errore durante il caricamento di {{ name }}. Riprova.',
  [T.documentRemoved]: 'Documento rimosso con successo',
  [T.unsupportedModelForImage]: `Il modello selezionato non supporta le immagini, passare a un modello che supporta l'analisi delle immagini.`,
  [T.modelUnavailableForChat]: `Il modello selezionato è stato disabilitato dall'amministratore dell'organizzazione. Passa a un altro modello disponibile per continuare la chat.`,
  [T.uploadFailedText]: 'Caricamento non riuscito. Riprova',
  [T.uploadingOrProcessingText]: '{{status}} allegati',
  [T.failedOrUnsupportedText]:
    'Errore {{status}} allegati. Rimuovi gli allegati con un errore per inviare il messaggio.',
  [T.switchToListView]: 'Passa alla vista elenco',
  [T.switchToGridView]: 'Passa alla vista griglia',
  [T.perUserLimits]: 'Limiti per utente',
  [T.noLimit]: 'Nessun limite',
  [T.modelUsageInChat]: 'Utilizzo del modello in chat',
  [T.maximumQueriesLimit]: 'Limite massimo di richieste in 3 ore',
  [T.maximumAnalysisLimit]: 'Analisi massime in 3 ore',
  [T.resetToDefault]: 'Ripristina ai valori predefiniti',
  [T.fieldValidationMessage]: 'Inserisci un numero valido maggiore di 0.',
  [T.userLimitsUpdateSuccessMsg]:
    'I limiti per utente sono stati aggiornati con successo.',

  //PAYG
  [T.paygTitle]: 'Pay As You Go',
  [T.paygDescription]:
    'I crediti prepagati Pay As You Go mantengono operativo il tuo team quando raggiunge il limite di utilizzo. Disattiva per interrompere immediatamente ogni utilizzo in eccedenza.',
  [T.paygCapReachedTitle]:
    'Limite raggiunto — Le funzionalità AI sono bloccate.',
  [T.paygCapReachedDescription]:
    "Il tuo team ha perso l'accesso alle funzionalità AI. Non vengono applicati costi aggiuntivi. Aggiorna il limite per ripristinare l'accesso alle funzionalità.",
  [T.paygApproachingCapTitle]:
    'Ti stai avvicinando al limite del saldo — Ricarica.',
  [T.paygCapReachedPlanAvailableTitle]:
    'Limite raggiunto — crediti Pay As You Go esauriti.',
  [T.paygCapReachedPlanAvailableDescription]:
    'Aumenta il limite per mantenere il Pay As You Go disponibile per il tuo team.',
  [T.paygApproachingCapPlanLowTitle]:
    'Ti stai avvicinando al limite — anche i crediti in-plan sono in esaurimento.',
  [T.paygApproachingCapPlanLowDescription]:
    'Mancano {{currency}}{{amount}} al tuo limite e anche i crediti in-plan stanno per esaurirsi. Aumenta il limite per evitare un blocco.',
  [T.paygApproachingCapDescription]:
    'Mancano {{currency}}{{amount}} al tuo limite. Al ritmo attuale, il tuo team esaurirà il budget. Considera di aumentarlo ora.',
  [T.paygBalance]: 'Saldo Pay As You Go',
  [T.paygCreditsLimitExceedTooltip]:
    'Si è verificato un utilizzo aggiuntivo di {{excess}} crediti Pay As You Go, che verrà automaticamente regolato rispetto a eventuali acquisti effettuati nello stesso mese.',
  [T.paygInPlanCreditLimitReachedTooltip]:
    'Si è verificato un utilizzo aggiuntivo di {{excess}} crediti in-plan. I crediti in-plan consumati in eccesso verranno detratti dal saldo Pay As You Go.',
  [T.creditsSpent]: 'Crediti spesi',
  [T.purchasedOn]: 'Acquistato il',
  [T.expiresOn]: 'Scade il',
  [T.paygNoCapSetTitle]: 'Nessun limite impostato',
  [T.paygNoCapSetDescription]:
    'Attiva Pay As You Go per impostare un limite di credito e coprire automaticamente i consumi extra',
  [T.paygEnablePayAsYouGo]: 'Attiva Pay As You Go',
  [T.paygEnableTitle]: 'Attiva Pay As You Go',
  [T.paygEnableDescription]:
    'Quando i crediti del piano si esauriscono, le funzionalità AI continuano a funzionare attingendo dal saldo prepagato Pay As You Go.',
  [T.paygTopUp]: 'Ricarica',
  [T.paygTopUpAmount]: 'Importo ricarica',
  [T.paygTopUpAmountHint]: 'Questo importo è al netto delle tasse.',
  [T.paygTopUpCredits]: 'Crediti: {{credits}}',
  [T.paygTopUpCreditsTooltip]:
    'I crediti inutilizzati rimarranno disponibili e potranno essere utilizzati il mese successivo.',
  [T.paygMaxTopUpAmount]: "L'importo massimo di ricarica è €{{max}}.",
  [T.paygPremiumFeaturesCap]: 'Limite di utilizzo funzionalità premium',
  [T.paygWorkflowLabel]: 'Workflow',
  [T.paygEditPremiumTitle]: 'Modifica limite utilizzo premium',
  [T.paygEditPremiumDescription]:
    'Imposta il limite di utilizzo del saldo Pay As You Go per le funzionalità premium.',
  [T.paygEditPremiumSuccess]:
    'Limite di utilizzo funzionalità premium aggiornato con successo.',
  [T.paygEditPremiumFailed]:
    'Impossibile aggiornare il limite di utilizzo funzionalità premium.',
  [T.paygMonthlyCap]: 'Limite mensile',
  [T.paygCheckoutFailed]: 'Impossibile avviare il pagamento. Riprova.',
  [T.paygBillingInfo]:
    'Questo importo viene addebitato in anticipo per attivare il saldo Pay As You Go. Puoi disattivare o modificare in qualsiasi momento da Impostazioni → Pay As You Go.',
  [T.paygUpdateCap]: 'Aggiorna',
  [T.paygEnableButton]: 'Attiva Pay As You Go',
  [T.paygTopUpButton]: 'Ricarica',
  [T.highToLow]: 'Dal più alto al più basso',
  [T.lowToHigh]: 'Dal più basso al più alto',
  [T.paygConsumedPercent]: 'Pay As You Go consumato in %',
  [T.paygClearFilters]: 'Cancella filtri',
  [T.current]: 'Corrente',
  [T.history]: 'Storico',
  [T.credits]: 'Crediti',
  [T.paygCreditsLabel]: 'Crediti PAYG',
  [T.paygPlanCreditsLabel]: 'Crediti del piano',
  // PAYG individual limits
  [T.paygIndividualLimitColumn]: 'Limite individuale',
  [T.paygIndividualLimitSharedPool]: 'Pool condiviso',
  [T.paygIndividualLimitCustom]: 'Limite personalizzato',
  [T.paygIndividualLimitCustomValue]: 'Personalizzato: {{amount}}',
  [T.paygIndividualLimitUnlimited]: 'Illimitato',
  [T.paygIndividualLimitSharedPoolDesc]:
    'Ricevi una quota uguale del pool del team.',
  [T.paygIndividualLimitCustomDesc]: 'Imposta un importo mensile specifico.',
  [T.paygIndividualLimitUnlimitedDesc]:
    "Nessun tetto di spesa, fatturato per tutto l'utilizzo.",
  [T.paygEditIndividualLimit]: 'Modifica limite individuale',
  [T.paygIndividualLimitSuccess]: 'Il limite individuale è stato aggiornato.',
  [T.paygIndividualLimitFailed]:
    'Impossibile aggiornare il limite individuale. Riprova.',
  [T.chargedTaxIncl]: 'Addebitato (IVA inclusa)',
  [T.chargedDate]: 'Data addebito',
  [T.paygEnableSuccess]: 'Pay As You Go è stato attivato con successo.',
  [T.paygDisableSuccess]: 'Pay As You Go è stato disattivato.',
  [T.paygEnableFailed]: 'Impossibile attivare Pay As You Go. Riprova.',
  [T.paygDisableFailed]: 'Impossibile disattivare Pay As You Go. Riprova.',
  [T.paygAlreadyExists]:
    'Pay As You Go con lo stesso tetto mensile è già attivo.',
  [T.paygInvalidLimit]: 'Il tetto mensile non può essere ridotto.',
  [T.paygNotEnabled]:
    'Pay As You Go non è attivo. Attiva la funzione per procedere.',
  [T.paygDisableConfirmDescription]:
    "La disattivazione del Pay As You Go interromperà l'utilizzo dei crediti in eccedenza. Puoi riattivarlo in qualsiasi momento.",
  [T.paygEnableConfirmDescription]:
    "L'attivazione del Pay As You Go riprenderà l'utilizzo dei crediti in eccedenza. Vuoi continuare?",
  [T.paygStatusCancelled]: 'Annullato',
  [T.paygStatusPastDue]: 'Pagamento scaduto',
  [T.paygStatusBlocked]: 'Bloccato',
  [T.paygStatusExpired]: 'Scaduto',
  [T.paygStatusRenewed]: 'Rinnovato',
  [T.paygStatusUnavailable]: 'Non disponibile',
  [T.paygFetchUsageFailed]: 'Impossibile caricare i dati di utilizzo. Riprova.',
  [T.paygFetchHistoryFailed]:
    'Impossibile caricare i dati della cronologia. Riprova.',
  // License disclaimer — standard licence (PAYG not offered)
  [T.licenseDisclaimerStandard90Owner]:
    'Oltre il 90% dei crediti AI della tua organizzazione è stato consumato.',
  [T.licenseDisclaimerStandard90User]:
    'Oltre il 90% dei crediti AI della tua organizzazione è stato consumato. Contatta il tuo amministratore.',
  [T.licenseDisclaimerStandard100Owner]:
    'Limite mensile di crediti AI della tua organizzazione raggiunto. Per assistenza immediata, contatta il servizio clienti.',
  [T.licenseDisclaimerStandard100User]:
    'Limite mensile di crediti AI della tua organizzazione raggiunto. Contatta il tuo amministratore.',
  // License disclaimer — PAYG offered but switched off
  [T.licenseDisclaimerPaygAvailable90Owner]:
    'È stato utilizzato oltre il 90% del limite di crediti in-plan della tua organizzazione. Abilita il Pay As You Go per evitare un blocco.',
  [T.licenseDisclaimerPaygAvailable90User]:
    'È stato utilizzato oltre il 90% del limite di crediti in-plan della tua organizzazione. Contatta il tuo amministratore per abilitare il Pay As You Go.',
  [T.licenseDisclaimerPaygAvailable100Owner]:
    'Limite di crediti in-plan della tua organizzazione raggiunto — le funzionalità AI sono bloccate. Abilita il Pay As You Go per continuare.',
  [T.licenseDisclaimerPaygAvailable100User]:
    'Limite di crediti in-plan della tua organizzazione raggiunto. Contatta il tuo amministratore.',
  [T.licenseDisclaimerEnablePayg]: 'Abilita Pay As You Go',
  // License disclaimer — PAYG active (is_payg_active)
  [T.licenseDisclaimerPayg90Owner]:
    'Utilizzato oltre il 90% dei crediti Pay As You Go della tua organizzazione.',
  [T.licenseDisclaimerPayg90User]:
    'Utilizzato oltre il 90% dei crediti Pay As You Go della tua organizzazione. Contatta il tuo amministratore.',
  [T.licenseDisclaimerBoth90Owner]:
    'Utilizzato oltre il 90% dei crediti Pay As You Go e in-plan della tua organizzazione.',
  [T.licenseDisclaimerBoth90User]:
    'Utilizzato oltre il 90% dei crediti Pay As You Go e in-plan della tua organizzazione. Contatta il tuo amministratore.',
  [T.licenseDisclaimerPayg100Owner]:
    'Tutti i crediti Pay As You Go della tua organizzazione sono stati utilizzati.',
  [T.licenseDisclaimerPayg100User]:
    'Tutti i crediti Pay As You Go della tua organizzazione sono stati utilizzati. Contatta il tuo amministratore.',
  [T.licenseDisclaimerPaygCovering]:
    'Il Pay As You Go sta coprendo i consumi della tua organizzazione mentre i crediti in-plan si esauriscono.',
  [T.licenseDisclaimerBoth100Owner]:
    'Crediti in-plan e Pay As You Go della tua organizzazione esauriti — le funzionalità AI sono bloccate.',
  [T.licenseDisclaimerBoth100User]:
    'Crediti in-plan e Pay As You Go della tua organizzazione esauriti — le funzionalità AI sono bloccate. Contatta il tuo amministratore.',
  [T.licenseDisclaimerRaiseCap]: 'Ricarica',
  [T.licenseDisclaimerRestoreAccess]: "Ripristina l'accesso",

  //help & support
  [T.helpSupport]: 'Supporto',
  [T.chooseOptions]: 'Scegli una delle opzioni qui sotto per aiuto e feedback.',
  [T.contactSupport]: 'Contatta il supporto',
  [T.contactCustomerSupport]: 'Contatta il supporto clienti',
  [T.ReportIssue]: 'Segnala un problema',
  [T.suggestedImprovements]: 'Suggerisci miglioramenti',
  [T.attachFile]: 'Allega file',
  [T.uploadFile]: 'Carica file',
  [T.supportTicketError]:
    "Errore nell'invio del messaggio al supporto. Riprova oppure contatta direttamente il supporto all'indirizzo {{supportEmail}}",
  [T.fileSizeError]: 'Il limite massimo di file allegati è 5',
  [T.sizeExceedError]: 'Supera la dimensione massima del file di 7 MB.',
  [T.subject]: 'Oggetto',
  [T.reportIssueSubject]: 'Riassumi il problema che stai affrontando.',
  [T.reportIssueDescription]:
    'Descrivi il problema in dettaglio e, se possibile, i passaggi per riprodurlo.',
  [T.suggestedImprovements]:
    'Descrivi il miglioramento suggerito o le nuove richieste di funzionalità.',
  [T.issueText]:
    'I tuoi suggerimenti sono stati condivisi con il team. Potremmo contattarti per ulteriori informazioni se necessario.',
  [T.supportText]:
    'Il team ti risponderà presto a riguardo. Riceverai risposte su ',
  [T.successMsg]: 'Messaggio inviato con successo',
  [T.issueReported]: 'Problema segnalato',
  [T.fileUploadingInProgress]: 'Caricamento del file in corso...',
  [T.accountTypeUpdateMsg]:
    "Tipo di account aggiornato; l'applicazione si ricaricherà tra 3 secondi.",
  [T.realmDeletedMsg]:
    'Il tuo tenant è stato eliminato. Reindirizzamento alla pagina di accesso.',
  [T.invalidToken]:
    'Token non valido/scaduto. Reindirizzamento alla pagina di accesso.',
  [T.userDeletedMsg]: "Il tuo account è stato rimosso dall'organizzazione.",
  [T.proSearchTooltip]:
    'Instrada la tua richiesta tramite una pianificazione AI avanzata per risposte più intelligenti.',
  [T.deepseekModelDisclaimer]:
    'DeepSeek offre risultati ottimali con prompt in inglese.',
  [T.createClient]: 'Creare un client di servizio',
  [T.createClientDescription]:
    'Fare clic sul pulsante per creare un ClientId, ClientSecret e Realm per il client del servizio.',
  [T.configurationDescription]:
    'Queste informazioni verranno utilizzate per personalizzare la tua esperienza',
  [T.clientIdPlaceholder]: "Inserisci l'ID client",
  [T.tokenRefreshRate]: 'Frequenza di aggiornamento del token',
  [T.tokenRefreshRatePlaceholder]:
    'Inserisci la frequenza di aggiornamento del token in ore',
  [T.configurationDisclaimer]:
    '** La frequenza di aggiornamento del token è impostata di default a 1 ora e verrà fornito un token di aggiornamento! **',
  [T.clientIdAndRefreshRate]:
    'ID client e frequenza di aggiornamento del token',
  [T.urlAndSecretId]: 'Ottieni URL e Secret ID',
  [T.externalApiWelcomeTitle]: 'Passaggi per configurare le integrazioni API',
  [T.externalApiWelcomeInstruction1]:
    'ID client e frequenza di aggiornamento del token',
  [T.externalApiWelcomeInstruction2]: 'Ottieni URL e Secret ID',
  [T.externalApiConfigured]: 'API esterna configurata con successo',
  [T.externalApiConfigurationDescription]:
    'Utilizza le credenziali generate per comunicare con le API EmpowerGPT',
  [T.tokenRefreshRateRequired]:
    'La frequenza di aggiornamento del token è obbligatoria',
  [T.secretId]: 'Segreto cliente',
  [T.authorizeUrl]: 'URL di autorizzazione',
  [T.authenticateUrl]: 'URL di autenticazione',
  [T.authenticationType]: 'Tipo di autenticazione',
  [T.headerName]: 'Nome intestazione',
  [T.algorithm]: 'Algoritmo',
  [T.authenticateUrlPlaceholder]: "Inserisci l'URL di autenticazione",
  [T.secretToken]: 'Token segreto',
  [T.includeSecretId]: 'Includi il token ID segreto.',
  [T.headerNameRequired]: "Il nome dell'intestazione è obbligatorio",
  [T.algorithmRequired]: "L'algoritmo è obbligatorio",
  [T.authTypePlaceholder]: 'Inserisci il tipo di autenticazione',
  [T.algorithmPlaceholder]: "Inserisci l'algoritmo",
  [T.chatCompletion]: 'Completamento chat',
  [T.chatStreaming]: 'Streaming chat',
  [T.secretTokenUpdateSuccess]: 'Secret‑Token erfolgreich aktualisiert',
  [T.secretTokenUpdateError]: 'Fehler bei der Aktualisierung des Secret‑Tokens',
  [T.logoutUrl]: 'URL di logout',
  [T.regenerateSecret]: 'Rigenerare il segreto',
  [T.step]: 'Passo',
  [T.bookmark]: 'Segnalibri',
  [T.bookmarkDescription]: 'Empower GPT Documentazione',

  // Organization Logo
  [T.logoDeletedSuccess]: 'Logo cancellato con successo',
  [T.logoDeletedError]: `Errore nell'eliminazione del logo`,
  [T.logoUpdatedSuccess]: 'Logo aggiornato con successo',
  [T.logoUpdatedError]: `Errore nell'aggiornamento del logo`,
  [T.orgLogoSize]: 'Le dimensioni del logo non devono superare i 5MB',
  [T.logo]: 'Logo',
  [T.orgLogo]: `Logo dell'organizzazione`,
  [T.logoTabDesc]:
    'Personalizzate il vostro account aggiungendo il logo della vostra organizzazione intorno al prodotto. Il vostro logo apparirà come quello di Intech negli esempi seguenti.',
  [T.switchText]: 'Utilizzare un logo per tutti i luoghi',
  [T.squareLogoSignin]: 'Logo quadrato per la registrazione/iscrizione',
  [T.rectangleLogoSideNav]: 'Logo a rettangolo per il navigatore laterale',
  [T.squareLogoSideNav]: 'Logo quadrato per il navigatore laterale',
  [T.maxSize]: 'La dimensione massima deve essere di 5 mb',

  // Canvas
  [T.errorUpdatingCanvas]: 'Errore durante l’aggiornamento della tela',
  [T.writeSomethingPlaceholder]: 'Scrivi qualcosa …',
  [T.editOrExplainPlaceholder]: 'Modifica o spiega...',
  [T.canvasFooterMsg1]: 'Stai visualizzando una versione precedente',
  [T.canvasFooterMsg2]: 'Ripristina questa versione per apportare modifiche',
  [T.canvasRestoreVersion]: 'Ripristina questa versione',
  [T.canvasBackToLatestVersion]: 'Torna all’ultima versione',
  [T.canvas]: 'Canvas',
  [T.createNewCanvasChat]: 'Crea una nuova chat canvas',
  [T.canvasDisclaimer]:
    'Siamo entusiasti di presentare la nostra funzione Canvas in versione beta. Tieni presente che potrebbe avere alcune particolarità mentre la perfezioniamo.',
  [T.noCanvasModels]:
    'Nessun modello di intelligenza artificiale disponibile per le chat canvas. Contatta il tuo amministratore.',
  [T.duration]: 'Durata',
  [T.speaker]: 'Oratore',

  // Actions
  [T[ACTIONS_CATEGORIES.OUTLOOK_EMAIL]]: 'Outlook Email',
  [T[ACTIONS_CATEGORIES.OUTLOOK_CALENDAR]]: 'Calendario Outlook',
  [T[ACTIONS_CATEGORIES.GMAIL]]: 'Gmail',
  [T[ACTIONS_CATEGORIES.GOOGLE_CALENDAR]]: 'Google Calendar',
  [T[ACTIONS_CATEGORIES.SLACK]]: 'Slack',
  [T[ACTIONS_CATEGORIES.GOOGLE_DRIVE]]: 'Google Drive',
  [T[ACTIONS_CATEGORIES.GOOGLE_SHEETS]]: 'Fogli Google',
  [T[ACTIONS_CATEGORIES.HUBSPOT]]: 'HubSpot',
  [T[ACTIONS_CATEGORIES.JIRA]]: 'Jira',
  [T[ACTIONS_CATEGORIES.CONFLUENCE]]: 'Confluence',
  [T[ACTIONS_CATEGORIES.MICROSOFT_TEAMS]]: 'Microsoft Teams',
  [T[ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT]]: 'Microsoft SharePoint',
  [T[ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE]]: 'Microsoft OneDrive',
  [T[ACTIONS_CATEGORIES.SQL_DATABASE]]: 'Database SQL',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-desc`]]:
    'Interroga ed esplora il tuo database SQL in linguaggio naturale. Supporta PostgreSQL, MySQL, MariaDB e SQL Server.',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.EXECUTE_SQL}`]]:
    'Esegui SQL',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.EXECUTE_SQL}-desc`]]:
    'Esegui query SELECT sul database connesso e ottieni risultati in linguaggio naturale.',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.SEARCH_OBJECTS}`]]:
    'Cerca oggetti',
  [T[`${ACTIONS_CATEGORIES.SQL_DATABASE}-${SQL_DATABASE.SEARCH_OBJECTS}-desc`]]:
    'Scopri schemi, tabelle, colonne e altri oggetti del database tramite corrispondenza di pattern.',

  [T[ACTIONS_CATEGORIES.SAP_S4HANA]]: 'SAP S/4HANA',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-desc`]]:
    'Accesso in sola lettura a ordini di manutenzione, avvisi, stock materiali e documenti materiale SAP.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_ORDERS}`]]:
    'Elenca ordini di manutenzione',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_ORDERS}-desc`
  ]]:
    'Elenca gli ordini di manutenzione con tipo, priorità, divisione e date pianificate.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER}`]]:
    'Ottieni ordine di manutenzione',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER}-desc`
  ]]: 'Ottieni tutti i dettagli di un singolo ordine di manutenzione.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER_OPERATIONS}`
  ]]: 'Ottieni operazioni ordine',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_ORDER_OPERATIONS}-desc`
  ]]:
    'Ottieni le operazioni di un ordine di manutenzione con centri di lavoro e divisioni.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_NOTIFICATIONS}`
  ]]: 'Elenca avvisi di manutenzione',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MAINTENANCE_NOTIFICATIONS}-desc`
  ]]:
    'Elenca gli avvisi di manutenzione con priorità, equipment e date di malfunzionamento.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION}`
  ]]: 'Ottieni avviso di manutenzione',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION}-desc`
  ]]: 'Ottieni tutti i dettagli di un singolo avviso di manutenzione.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_ITEMS}`
  ]]: 'Ottieni posizioni avviso',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_ITEMS}-desc`
  ]]:
    'Ottieni le posizioni di un avviso con codici parte oggetto e codici danno.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_TASKS}`
  ]]: 'Ottieni attività avviso',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MAINTENANCE_NOTIFICATION_TASKS}-desc`
  ]]: 'Ottieni le attività di un avviso con stato e persona responsabile.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_STOCK}`]]:
    'Elenca stock materiali',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_STOCK}-desc`
  ]]: 'Elenca i materiali con le rispettive unità di misura base.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK}`]]:
    'Ottieni stock materiale',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK}-desc`]]:
    'Ottieni i dettagli di stock di un materiale con la suddivisione per modello contabile.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK_QUANTITIES}`
  ]]: 'Ottieni quantità di stock',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_STOCK_QUANTITIES}-desc`
  ]]:
    'Ottieni le quantità di stock per divisione, magazzino, lotto e tipo di stock.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENTS}`]]:
    'Elenca documenti materiale',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENTS}-desc`
  ]]:
    'Elenca le testate dei documenti materiale con date di registrazione e codici movimento merci.',
  [T[`${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_DOCUMENT}`]]:
    'Ottieni documento materiale',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.GET_MATERIAL_DOCUMENT}-desc`
  ]]: 'Ottieni un documento materiale con tutte le sue posizioni.',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENT_ITEMS}`
  ]]: 'Elenca posizioni documento materiale',
  [T[
    `${ACTIONS_CATEGORIES.SAP_S4HANA}-${SAP_S4HANA.LIST_MATERIAL_DOCUMENT_ITEMS}-desc`
  ]]:
    'Elenca le posizioni dei documenti materiale con quantità, tipi di movimento e magazzini.',

  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-desc`]]:
    'Chatta con le tue e-mail di Outlook, crea bozze e invia messaggi.',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-desc`]]:
    'Visualizza e gestisci gli eventi del tuo calendario Outlook.',
  [T[`${ACTIONS_CATEGORIES.GMAIL}-desc`]]:
    'Chatta con le tue e-mail, crea bozze e invia messaggi.',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_CALENDAR}-desc`]]:
    'Visualizza e gestisci gli eventi del tuo calendario.',
  [T[`${ACTIONS_CATEGORIES.SLACK}-desc`]]:
    'Un’unica piattaforma. Tutti i tuoi team di go-to-market. Perfettamente allineati.',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DRIVE}-desc`]]:
    'Accedi ai tuoi file, organizza documenti e collabora in Google Drive.',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-desc`]]:
    'Gestisci e analizza i dati nei fogli di Google.',
  [T[`${ACTIONS_CATEGORIES.HUBSPOT}-desc`]]:
    'Gestisci contatti, offerte e campagne direttamente dalla chat.',
  [T[`${ACTIONS_CATEGORIES.JIRA}-desc`]]:
    'Cerca, crea e aggiorna i ticket Jira direttamente dalla chat.',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-desc`]]:
    'Cerca, leggi e gestisci pagine e commenti di Confluence direttamente dalla chat.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-desc`]]:
    'Accesso contestuale a documenti, elenchi e pagine attraverso i tuoi siti SharePoint.',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-desc`]]:
    'Leggi, cerca e redigi documenti utilizzando il linguaggio naturale, senza cambiare strumenti.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-desc`]]:
    'Leggi, gestisci e genera file nel tuo OneDrive utilizzando il linguaggio naturale',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.CREATE_DRAFT}`]]:
    'Crea bozza',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEND_EMAIL}`]]:
    'Invia email',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTENT}`
  ]]: 'Cerca email per contenuto',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTACT}`
  ]]: 'Cerca email per contatto',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.CREATE_DRAFT}-desc`]]:
    'Componi una email e salvala come bozza nel tuo account Outlook, senza inviarla',
  [T[`${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEND_EMAIL}-desc`]]:
    'Componi e invia direttamente un’email tramite il tuo account Outlook usando questo assistente',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTENT}-desc`
  ]]:
    'Trova email nella tua casella Outlook cercando parole chiave nel corpo o nell’oggetto',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_EMAIL}-${OUTLOOK_EMAIL.SEARCH_EMAIL_BY_CONTACT}-desc`
  ]]: 'Individua email basate sul nome del mittente o sull’indirizzo email',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.CREATE_EVENT}`
  ]]: 'Crea evento',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.DELETE_EVENTS}`
  ]]: 'Elimina eventi',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_DATE_EVENTS}`
  ]]: 'Ottieni eventi per data',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_TODAY_EVENTS}`
  ]]: 'Ottieni eventi di oggi',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDARS}`
  ]]: 'Elenca calendari',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDAR_EVENTS}`
  ]]: 'Elenca eventi del calendario',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.UPDATE_EVENT}`
  ]]: 'Aggiorna evento',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.CREATE_EVENT}-desc`
  ]]: 'Programma un nuovo evento o riunione nel tuo Calendario Outlook',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.DELETE_EVENTS}-desc`
  ]]: 'Rimuovi un evento specifico dal tuo Calendario Outlook.',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_DATE_EVENTS}-desc`
  ]]:
    'Recupera tutti gli eventi di una data specifica dal tuo Calendario Outlook',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_TODAY_EVENTS}-desc`
  ]]:
    'Recupera tutti gli eventi programmati per oggi dal tuo Calendario Outlook',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDARS}-desc`
  ]]: 'Mostra tutti i calendari collegati al tuo account Outlook',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.LIST_CALENDAR_EVENTS}-desc`
  ]]:
    'Mostra tutti gli eventi di un calendario selezionato nel tuo account Outlook',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.UPDATE_EVENT}-desc`
  ]]: 'Modifica i dettagli di un evento esistente nel tuo Calendario Outlook',
  [T[
    `${ACTIONS_CATEGORIES.OUTLOOK_CALENDAR}-${OUTLOOK_CALENDAR.GET_EVENT}-desc`
  ]]:
    'Recupera i dettagli di un evento specifico per ID dal tuo Calendario Outlook',

  // Jira
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ACCESSIBLE_RESOURCES}`]]:
    'Ottieni Risorse Accessibili',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_CURRENT_USER}`]]:
    'Ottieni Utente Corrente',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE}`]]: 'Ottieni Ticket',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_REMOTE_LINKS}`]]:
    'Ottieni Collegamenti Esterni del Ticket',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_TYPE_FIELDS}`]]:
    'Ottieni Campi Tipo Ticket',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECT_ISSUE_TYPES}`]]:
    'Ottieni Tipi di Ticket del Progetto',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_LINK_TYPES}`]]:
    'Ottieni Tipi di Collegamento Ticket',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_TRANSITIONS}`]]:
    'Ottieni Transizioni',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECTS}`]]: 'Ottieni Progetti',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.LOOKUP_ACCOUNT_ID}`]]:
    'Cerca ID Account',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_COMMENT}`]]: 'Aggiungi Commento',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_WORKLOG}`]]:
    'Aggiungi Registro Lavoro',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.CREATE_ISSUE}`]]: 'Crea Ticket',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.UPDATE_ISSUE}`]]: 'Aggiorna Ticket',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.TRANSITION_ISSUE}`]]:
    'Fai Transitare Ticket',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.SEARCH_ISSUES}`]]: 'Cerca Ticket',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ACCESSIBLE_RESOURCES}-desc`]]:
    'Elenca i siti Atlassian a cui il tuo account puo accedere',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_CURRENT_USER}-desc`]]:
    'Recupera le informazioni dell utente Atlassian attualmente autenticato',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE}-desc`]]:
    'Recupera un ticket Jira specifico tramite la sua chiave o ID',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_REMOTE_LINKS}-desc`]]:
    'Recupera i collegamenti esterni (es. pagine Confluence, URL esterni) su un ticket Jira',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_TYPE_FIELDS}-desc`]]:
    'Recupera i campi obbligatori e opzionali per un tipo di ticket in un progetto',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECT_ISSUE_TYPES}-desc`]]:
    'Recupera i tipi di ticket disponibili per un progetto Jira',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_ISSUE_LINK_TYPES}-desc`]]:
    'Elenca i tipi di collegamento tra ticket disponibili, ad esempio blocca o si riferisce a',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_TRANSITIONS}-desc`]]:
    'Elenca le transizioni di workflow valide disponibili per un ticket Jira',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.GET_PROJECTS}-desc`]]:
    'Elenca i progetti Jira visibili all utente corrente',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.LOOKUP_ACCOUNT_ID}-desc`]]:
    'Risolve l ID account Atlassian di un utente tramite nome o email',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_COMMENT}-desc`]]:
    'Aggiunge un commento a un ticket Jira',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.ADD_WORKLOG}-desc`]]:
    'Registra il lavoro svolto su un ticket Jira',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.CREATE_ISSUE}-desc`]]:
    'Crea un nuovo ticket Jira in un progetto',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.UPDATE_ISSUE}-desc`]]:
    'Aggiorna i campi di un ticket Jira esistente',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.TRANSITION_ISSUE}-desc`]]:
    'Fa transitare un ticket Jira attraverso il suo workflow',
  [T[`${ACTIONS_CATEGORIES.JIRA}-${JIRA.SEARCH_ISSUES}-desc`]]:
    'Cerca ticket Jira utilizzando JQL',

  // Confluence
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_ACCESSIBLE_RESOURCES}`
  ]]: 'Ottieni Risorse Accessibili',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_CURRENT_USER}`]]:
    'Ottieni Utente Corrente',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE}`]]:
    'Ottieni Pagina',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_DESCENDANTS}`]]:
    'Ottieni Sottopagine',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_FOOTER_COMMENTS}`
  ]]: 'Ottieni Commenti a Piè di Pagina',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_INLINE_COMMENTS}`
  ]]: 'Ottieni Commenti Incorporati',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_FOOTER_COMMENT_CHILDREN}`
  ]]: 'Ottieni Risposte al Commento a Piè di Pagina',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_SPACES}`]]:
    'Ottieni Spazi',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGES_IN_SPACE}`]]:
    'Ottieni Pagine nello Spazio',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_PAGE}`]]:
    'Crea Pagina',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.UPDATE_PAGE}`]]:
    'Aggiorna Pagina',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_FOOTER_COMMENT}`]]:
    'Crea Commento a Piè di Pagina',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_INLINE_COMMENT}`]]:
    'Crea Commento Incorporato',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.SEARCH_CQL}`]]:
    'Cerca in Confluence',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_ACCESSIBLE_RESOURCES}-desc`
  ]]: 'Elenca i siti Atlassian a cui il tuo account puo accedere',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_CURRENT_USER}-desc`]]:
    'Recupera le informazioni dell utente Atlassian attualmente autenticato',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE}-desc`]]:
    'Recupera una pagina Confluence tramite il suo ID',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_DESCENDANTS}-desc`
  ]]: 'Recupera le sottopagine di una pagina Confluence',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_FOOTER_COMMENTS}-desc`
  ]]: 'Recupera i commenti a piè di pagina di una pagina Confluence',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGE_INLINE_COMMENTS}-desc`
  ]]: 'Recupera i commenti incorporati di una pagina Confluence',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_FOOTER_COMMENT_CHILDREN}-desc`
  ]]: 'Recupera le risposte a un commento a piè di pagina di Confluence',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_SPACES}-desc`]]:
    'Elenca gli spazi Confluence',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.GET_PAGES_IN_SPACE}-desc`]]:
    'Elenca le pagine in uno spazio Confluence',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_PAGE}-desc`]]:
    'Crea una nuova pagina Confluence',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.UPDATE_PAGE}-desc`]]:
    'Aggiorna il contenuto e facoltativamente il titolo di una pagina Confluence esistente',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_FOOTER_COMMENT}-desc`
  ]]: 'Aggiunge un commento a piè di pagina a una pagina Confluence',
  [T[
    `${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.CREATE_INLINE_COMMENT}-desc`
  ]]:
    'Aggiunge un commento incorporato a un testo selezionato in una pagina Confluence',
  [T[`${ACTIONS_CATEGORIES.CONFLUENCE}-${CONFLUENCE.SEARCH_CQL}-desc`]]:
    'Cerca pagine e contenuti Confluence utilizzando CQL',

  // Microsoft Teams
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEARCH_MESSAGES}`
  ]]: 'Cerca messaggi',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHANNELS}`]]:
    'Elenca canali',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHANNEL_MESSAGES}`
  ]]: 'Ottieni messaggi del canale',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MESSAGES}`
  ]]: 'Ottieni messaggi della chat',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHANNEL_MESSAGE}`
  ]]: 'Invia messaggio al canale',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHAT_MESSAGE}`
  ]]: 'Invia messaggio alla chat',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEARCH_MESSAGES}-desc`
  ]]: 'Cerca messaggi in tutte le tue chat di Teams utilizzando parole chiave',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHANNELS}-desc`
  ]]: 'Elenca tutti i canali di tutti i team di cui sei membro',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHANNEL_MESSAGES}-desc`
  ]]:
    'Ottieni messaggi da un canale specifico di Teams con filtro data opzionale',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MESSAGES}-desc`
  ]]:
    'Ottieni messaggi da una chat specifica di Teams con filtro data opzionale',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHANNEL_MESSAGE}-desc`
  ]]:
    'Invia un messaggio a un canale specifico di Teams con formattazione testo o HTML',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.SEND_CHAT_MESSAGE}-desc`
  ]]:
    'Invia un messaggio a una chat specifica di Teams con formattazione testo o HTML',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHATS}`]]:
    'Elenca chat',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MEMBERS}`
  ]]: 'Ottieni membri della chat',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_CHATS}-desc`
  ]]:
    'Elenca tutte le chat individuali, chat di gruppo e chat di riunione di cui sei membro',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_CHAT_MEMBERS}-desc`
  ]]:
    'Ottieni tutti i membri di una chat specifica inclusi nomi visualizzati, indirizzi email e ruoli',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_MEETINGS}`]]:
    'Elenca riunioni',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_TRANSCRIPT}`
  ]]: 'Ottieni trascrizione della riunione',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.LIST_MEETINGS}-desc`
  ]]:
    'Elenca le tue riunioni online di Teams con oggetto, orari e link di partecipazione',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_TEAMS}-${MICROSOFT_TEAMS.GET_TRANSCRIPT}-desc`
  ]]: 'Ottieni la trascrizione di una specifica riunione di Teams',

  // Google Docs
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.SEARCH_DOCS}`]]:
    'Cerca documenti',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.CREATE_DOCUMENT}`]]:
    'Crea documento',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FETCH_DOCUMENT_CONTENT}`
  ]]: 'Recupera contenuto documento',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.INSERT_TEXT}`]]:
    'Inserisci testo',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.REPLACE_TEXT}`]]:
    'Sostituisci testo',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FORMAT_TEXT}`]]:
    'Formatta testo',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FIND_AND_REPLACE_ALL}`]]:
    'Trova e sostituisci tutto',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.SEARCH_DOCS}-desc`]]:
    'Cerca documenti nei tuoi Google Docs utilizzando parole chiave e filtri',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.CREATE_DOCUMENT}-desc`]]:
    'Crea un nuovo documento Google Docs con un titolo specificato',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FETCH_DOCUMENT_CONTENT}-desc`
  ]]:
    'Recupera il contenuto e i metadati di un documento Google Docs specifico',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.INSERT_TEXT}-desc`]]:
    'Inserisci testo in posizioni specifiche in un documento Google Docs',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.REPLACE_TEXT}-desc`]]:
    'Sostituisci passaggi di testo specifici in un documento Google Docs',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FORMAT_TEXT}-desc`]]:
    'Applica stili di formattazione a testo specifico in un documento Google Docs',
  [T[
    `${ACTIONS_CATEGORIES.GOOGLE_DOCS}-${GOOGLE_DOCS.FIND_AND_REPLACE_ALL}-desc`
  ]]:
    'Trova e sostituisci tutte le occorrenze di testo in un documento Google Docs con corrispondenza maiuscole/minuscole opzionale',

  // Google Sheets
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.SEARCH_FILES}`]]:
    'Cerca file',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.CREATE_ROWS}`]]:
    'Crea righe',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.UPDATE_ROWS}`]]:
    'Aggiorna righe',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.LIST_ROWS}`]]:
    'Elenca righe',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.GET_METADATA}`]]:
    'Ottieni metadati',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.ADD_SHEET}`]]:
    'Aggiungi foglio',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.SEARCH_FILES}-desc`]]:
    'Cerca file di fogli di calcolo nei tuoi Google Sheets utilizzando parole chiave e filtri',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.CREATE_ROWS}-desc`]]:
    'Inserisci righe vuote in un foglio specifico in una posizione specificata',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.UPDATE_ROWS}-desc`]]:
    'Aggiorna le righe esistenti in un foglio con nuovi valori',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.LIST_ROWS}-desc`]]:
    'Elenca le righe da un foglio a partire da un numero di riga specifico',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.GET_METADATA}-desc`]]:
    'Ottieni informazioni sui metadati di un foglio di calcolo inclusi nomi e proprietà dei fogli',
  [T[`${ACTIONS_CATEGORIES.GOOGLE_SHEETS}-${GOOGLE_SHEETS.ADD_SHEET}-desc`]]:
    'Aggiungi una nuova scheda foglio a un foglio di calcolo esistente con dimensioni specificate',

  // Microsoft SharePoint
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_PROFILE}`
  ]]: 'Ottieni profilo',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVES}`
  ]]: 'Elenca unità',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_SITES}`
  ]]: 'Cerca siti',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_SITE}`
  ]]: 'Ottieni sito',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SUBSITES}`
  ]]: 'Elenca sottositi',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVE_CHILDREN}`
  ]]: 'Elenca contenuto unità',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_RECENT_FILES}`
  ]]: 'Elenca file recenti',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_USERS}`
  ]]: 'Elenca utenti sito',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_LISTS}`
  ]]: 'Elenca elenchi sito',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST}`
  ]]: 'Ottieni elenco',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_COLUMNS}`
  ]]: 'Elenca colonne',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_COLUMN}`
  ]]: 'Ottieni colonna',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_LIST_ITEMS}`
  ]]: 'Elenca elementi elenco',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST_ITEM}`
  ]]: 'Ottieni elemento elenco',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_PAGES}`
  ]]: 'Elenca pagine sito',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUPS}`
  ]]: 'Ottieni gruppi',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUP_MEMBERS}`
  ]]: 'Ottieni membri gruppo',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.ADD_GROUP_MEMBER}`
  ]]: 'Aggiungi membro gruppo',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.REMOVE_GROUP_MEMBER}`
  ]]: 'Rimuovi membro gruppo',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_FILES}`
  ]]: 'Cerca file',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.UPLOAD_FILE}`
  ]]: 'Carica file',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_FOLDER}`
  ]]: 'Ottieni cartella',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_PROFILE}-desc`
  ]]: "Ottieni le informazioni del profilo per l'utente corrente",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVES}-desc`
  ]]: "Elenca le unità in un sito o le unità accessibili dall'utente corrente",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_SITES}-desc`
  ]]: 'Cerca siti SharePoint utilizzando parole chiave',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_SITE}-desc`
  ]]: 'Ottieni informazioni dettagliate su un sito SharePoint specifico',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SUBSITES}-desc`
  ]]: "Elenca tutti i sottositi all'interno di un sito SharePoint",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_DRIVE_CHILDREN}-desc`
  ]]:
    "Elenca file e cartelle in un'unità nella radice o all'interno di una cartella",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_RECENT_FILES}-desc`
  ]]: "Elenca i file aperti di recente dall'utente corrente",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_USERS}-desc`
  ]]: 'Elenca tutti gli utenti che hanno accesso a un sito SharePoint',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_LISTS}-desc`
  ]]: "Elenca tutti gli elenchi SharePoint all'interno di un sito",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST}-desc`
  ]]: 'Ottieni metadati e dettagli per un elenco SharePoint specifico',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_COLUMNS}-desc`
  ]]: 'Elenca tutte le definizioni delle colonne in un elenco SharePoint',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_COLUMN}-desc`
  ]]: 'Ottieni la definizione e i metadati di una colonna specifica',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_LIST_ITEMS}-desc`
  ]]: 'Elenca elementi da un elenco SharePoint con filtro opzionale',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_LIST_ITEM}-desc`
  ]]:
    'Ottieni dati dettagliati per un elemento specifico in un elenco SharePoint',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.LIST_SITE_PAGES}-desc`
  ]]: "Elenca tutte le pagine del sito all'interno di un sito SharePoint",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUPS}-desc`
  ]]: "Ottieni tutti i gruppi per l'utente corrente o un utente specifico",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_GROUP_MEMBERS}-desc`
  ]]: 'Ottieni tutti i membri di un gruppo specifico',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.ADD_GROUP_MEMBER}-desc`
  ]]: 'Aggiungi un utente come membro a un gruppo',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.REMOVE_GROUP_MEMBER}-desc`
  ]]: 'Rimuovi un utente da un gruppo',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.SEARCH_FILES}-desc`
  ]]: "Cerca file per nome all'interno di un'unità",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.UPLOAD_FILE}-desc`
  ]]: 'Carica un file in una cartella SharePoint',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_SHAREPOINT}-${MICROSOFT_SHAREPOINT.GET_FOLDER}-desc`
  ]]: 'Risolvi un percorso cartella per ottenere ID unità e cartella',

  // Microsoft OneDrive
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_AVAILABLE_DRIVES}`
  ]]: 'Elenca unità disponibili',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.GET_FOLDER_BY_PATH}`
  ]]: 'Ottieni cartella per percorso',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FOLDERS_BY_NAME}`
  ]]: 'Cerca cartelle per nome',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FILES_BY_NAME}`
  ]]: 'Cerca file per nome',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.CREATE_FOLDER}`
  ]]: 'Crea cartella',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_FOLDER_CHILDREN}`
  ]]: 'Elenca contenuto cartella',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.DOWNLOAD_FILE}`
  ]]: 'Scarica file',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_AVAILABLE_DRIVES}-desc`
  ]]: "Elenca tutte le posizioni OneDrive accessibili per l'utente corrente",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.GET_FOLDER_BY_PATH}-desc`
  ]]:
    "Recupera una cartella tramite il suo percorso relativo alla radice dell'unità",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FOLDERS_BY_NAME}-desc`
  ]]: "Cerca cartelle per nome nell'unità",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.SEARCH_FILES_BY_NAME}-desc`
  ]]: "Cerca file per nome nell'unità",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.CREATE_FOLDER}-desc`
  ]]:
    'Crea una cartella per percorso, creando le cartelle padre mancanti se necessario',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.LIST_FOLDER_CHILDREN}-desc`
  ]]:
    "Elenca tutti i file e le cartelle all'interno di un percorso cartella specifico",
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_ONEDRIVE}-${MICROSOFT_ONEDRIVE.DOWNLOAD_FILE}-desc`
  ]]: 'Scarica un file da OneDrive tramite ID file',

  [T[ACTIONS_CATEGORIES.DATEV_ACCOUNTING]]: 'DATEV Contabilità',
  [T[`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-desc`]]:
    'Accedi a DATEV contabilità — mandati, anni fiscali, conti mastro e registrazioni.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.LIST_CLIENTS}`
  ]]: 'Elenca Mandati',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.LIST_CLIENTS}-desc`
  ]]: 'Elenca tutti i mandati contabili DATEV accessibili.',
  [T[`${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_CLIENT}`]]:
    'Ottieni Mandato',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_CLIENT}-desc`
  ]]: 'Ottieni un singolo mandato contabile DATEV tramite UUID.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEARS}`
  ]]: 'Ottieni Anni Fiscali',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEARS}-desc`
  ]]: 'Restituisce tutti gli ID degli anni fiscali per un mandato.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEAR}`
  ]]: 'Ottieni Anno Fiscale',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_FISCAL_YEAR}-desc`
  ]]: 'Restituisce i dettagli di un singolo anno fiscale.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_GENERAL_LEDGER_ACCTS}`
  ]]: 'Ottieni Conti Mastro',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_GENERAL_LEDGER_ACCTS}-desc`
  ]]: 'Restituisce i conti del libro mastro per un anno fiscale.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_SUMS_AND_BALANCES}`
  ]]: 'Ottieni Somme e Saldi',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_SUMS_AND_BALANCES}-desc`
  ]]: 'Restituisce somme e saldi mensili per un anno fiscale.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_ACCOUNTING_SEQUENCES}`
  ]]: 'Ottieni Sequenze Contabili',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_ACCOUNTING_SEQUENCES}-desc`
  ]]: 'Restituisce le sequenze contabili per un anno fiscale.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_TERMS_OF_PAYMENT}`
  ]]: 'Ottieni Termini di Pagamento',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_TERMS_OF_PAYMENT}-desc`
  ]]: 'Restituisce i termini di pagamento per un anno fiscale.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DOCUMENT_TYPES}`
  ]]: 'Tipi di Documento',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DOCUMENT_TYPES}-desc`
  ]]: 'Restituisce tutti i tipi di documento configurati per un mandato DATEV.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DUO_VERSION}`
  ]]: 'Versione DUO',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_ACCOUNTING}-${DATEV_ACCOUNTING.GET_DUO_VERSION}-desc`
  ]]:
    'Restituisce le estensioni file consentite per la versione DUO del mandato.',

  [T[ACTIONS_CATEGORIES.DATEV_HR]]: 'DATEV HR',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-desc`]]:
    'Accedi a DATEV HR — paghe, dati dipendenti, previdenza sociale, assenze e buste paga.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.LIST_HR_CLIENTS}`]]:
    'Elenca Clienti HR',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.LIST_HR_CLIENTS}-desc`]]:
    'Elenca tutti i clienti HR accessibili con il token corrente.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_HR_CLIENT}`]]:
    'Ottieni Cliente HR',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_HR_CLIENT}-desc`]]:
    'Ottieni un singolo cliente HR tramite ID.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_MASTER_DATA}`]]:
    'Dati Anagrafici Dipendente',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_MASTER_DATA}-desc`
  ]]: 'Restituisce i dati anagrafici di un singolo dipendente.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SALARY_DETAILS}`]]:
    'Dettagli Stipendio Dipendente',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SALARY_DETAILS}-desc`
  ]]: 'Restituisce i dettagli dello stipendio di un singolo dipendente.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_TAX_PAYMENTS}`]]:
    'Pagamenti Fiscali Dipendente',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_TAX_PAYMENTS}-desc`
  ]]: 'Restituisce i pagamenti delle imposte sul reddito di un dipendente.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SOCIAL_SECURITY}`
  ]]: 'Previdenza Sociale Dipendente',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_SOCIAL_SECURITY}-desc`
  ]]: 'Restituisce i dati previdenziali di un singolo dipendente.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ABSENCES}`]]:
    'Assenze Dipendente',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ABSENCES}-desc`]]:
    'Restituisce i dati sulle assenze di un dipendente.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ID_BY_PERSONNEL_NUM}`
  ]]: 'Cerca ID Dipendente',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_ID_BY_PERSONNEL_NUM}-desc`
  ]]: "Cerca l'ID dipendente DATEV tramite numero di matricola aziendale.",
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_MASTER_DATA}`
  ]]: 'Dati Anagrafici Tutti i Dipendenti',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_MASTER_DATA}-desc`
  ]]: 'Restituisce i dati anagrafici di tutti i dipendenti di un cliente.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SALARY_DETAILS}`
  ]]: 'Stipendi Tutti i Dipendenti',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SALARY_DETAILS}-desc`
  ]]: 'Restituisce i dettagli stipendio di tutti i dipendenti.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_TAX_PAYMENTS}`
  ]]: 'Imposte Tutti i Dipendenti',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_TAX_PAYMENTS}-desc`
  ]]: 'Restituisce i pagamenti fiscali di tutti i dipendenti.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SOCIAL_SECURITY}`
  ]]: 'Previdenza Tutti i Dipendenti',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_SOCIAL_SECURITY}-desc`
  ]]: 'Restituisce i contributi previdenziali di tutti i dipendenti.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_ABSENCES}`]]:
    'Assenze Tutti i Dipendenti',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_ALL_EMPLOYEES_ABSENCES}-desc`
  ]]: 'Restituisce le assenze di tutti i dipendenti.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_CLIENT}`]]:
    'Cliente Paghe',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_CLIENT}-desc`]]:
    'Restituisce le informazioni del cliente paghe inclusi i diritti di accesso ai tipi di documento.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORTS}`]]:
    'Report Paghe',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORTS}-desc`]]:
    'Restituisce i documenti paghe per un cliente e un periodo.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_DOCUMENT_AVAILABILITY}`
  ]]: 'Disponibilità Documenti Paghe',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_DOCUMENT_AVAILABILITY}-desc`
  ]]:
    'Verifica se i documenti paghe sono disponibili per un cliente e un periodo.',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_PAYSLIP_NUMBERS}`
  ]]: 'Numeri Buste Paga Dipendente',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_EMPLOYEE_PAYSLIP_NUMBERS}-desc`
  ]]:
    'Restituisce i numeri dipendenti con buste paga per un determinato periodo.',
  [T[`${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORT_METADATA}`]]:
    'Metadati Report Paghe',
  [T[
    `${ACTIONS_CATEGORIES.DATEV_HR}-${DATEV_HR.GET_PAYROLL_REPORT_METADATA}-desc`
  ]]:
    'Restituisce i metadati sui report paghe disponibili per tutti i dipendenti.',

  [T[ACTIONS_CATEGORIES.MICROSOFT_D365]]: 'Dynamics 365',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-desc`]]:
    'Interroga Dynamics 365 — clienti, fornitori, articoli, vendite, acquisti e reportistica di contabilità generale.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMERS}`]]:
    'Elenca Clienti',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMERS}-desc`
  ]]:
    'Dati anagrafici clienti: contatti, indirizzi, termini di pagamento, limiti di credito, saldi.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDORS}`]]:
    'Elenca Fornitori',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDORS}-desc`
  ]]:
    'Dati anagrafici fornitori: dettagli aziendali, indirizzi, termini di pagamento, registrazione fiscale, saldi.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_ITEMS}`]]:
    'Elenca Articoli',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_ITEMS}-desc`]]:
    'Dati anagrafici articoli: descrizioni, prezzi, costi unitari, gruppi fiscali, livelli di inventario.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_EMPLOYEES}`]]:
    'Elenca Dipendenti',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_EMPLOYEES}-desc`
  ]]:
    'Dati anagrafici dipendenti: dati personali, stato occupazionale, mansioni, dati bancari.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_COMPANY_INFORMATION}`
  ]]: 'Elenca Informazioni Azienda',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_COMPANY_INFORMATION}-desc`
  ]]:
    'Profilo azienda: nome, indirizzo, contatti, numeri di registrazione fiscale, dati bancari.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_BANK_ACCOUNTS}`
  ]]: 'Elenca Conti Bancari',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_BANK_ACCOUNTS}-desc`
  ]]: 'Conti bancari: numeri di conto, nomi banca, saldi, codici IBAN/SWIFT.',
  [T[`${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CURRENCIES}`]]:
    'Elenca Valute',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CURRENCIES}-desc`
  ]]:
    'Dati anagrafici valute: codici, simboli, codici ISO, impostazioni di arrotondamento.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_INVOICES}`
  ]]: 'Elenca Fatture di Vendita',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_INVOICES}-desc`
  ]]:
    'Fatture di vendita aperte: dettagli cliente, importi, informazioni fiscali, scadenze, stato.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_SALES_INVOICES}`
  ]]: 'Elenca Fatture di Vendita Registrate',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_SALES_INVOICES}-desc`
  ]]: 'Fatture di vendita registrate (definitive).',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_CREDIT_MEMOS}`
  ]]: 'Elenca Note di Credito Vendita',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_CREDIT_MEMOS}-desc`
  ]]:
    'Note di credito vendita: dettagli cliente, importi, informazioni fiscali, riferimenti fattura correlati.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_ORDERS}`
  ]]: 'Elenca Ordini di Vendita',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_SALES_ORDERS}-desc`
  ]]:
    'Ordini di vendita: dettagli cliente, indirizzi, stato ordine, date di consegna, totali.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMER_PAYMENTS}`
  ]]: 'Elenca Pagamenti Clienti',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_CUSTOMER_PAYMENTS}-desc`
  ]]:
    'Transazioni di pagamento clienti: importi, date, metodi, fatture correlate.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_INVOICES}`
  ]]: 'Elenca Fatture di Acquisto',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_INVOICES}-desc`
  ]]:
    'Fatture di acquisto aperte: dettagli fornitore, importi, scadenze, termini di pagamento, stato.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_PURCHASE_INVOICES}`
  ]]: 'Elenca Fatture di Acquisto Registrate',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_POSTED_PURCHASE_INVOICES}-desc`
  ]]: 'Fatture di acquisto registrate (definitive).',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_CREDIT_MEMOS}`
  ]]: 'Elenca Note di Credito Acquisto',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_CREDIT_MEMOS}-desc`
  ]]:
    'Note di credito acquisto: dettagli fornitore, importi, valuta, termini di pagamento, stato.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_ORDERS}`
  ]]: 'Elenca Ordini di Acquisto',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_PURCHASE_ORDERS}-desc`
  ]]:
    'Ordini di acquisto: dettagli fornitore, stato ordine, informazioni consegna/pagamento, totali.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDOR_PAYMENTS}`
  ]]: 'Elenca Pagamenti Fornitori',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_VENDOR_PAYMENTS}-desc`
  ]]:
    'Transazioni di pagamento fornitori: importi, date, metodi, dettagli applicazione fattura.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GL_ACCOUNTS}`
  ]]: 'Elenca Conti Mastro',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GL_ACCOUNTS}-desc`
  ]]:
    'Piano dei conti: numeri, nomi, categorie, saldi, impostazioni di registrazione (sola lettura).',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GENERAL_LEDGER_ENTRIES}`
  ]]: 'Elenca Registrazioni Contabili',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_GENERAL_LEDGER_ENTRIES}-desc`
  ]]:
    'Registrazioni contabili registrate: numero registrazione, data registrazione, tipo documento, conto, importi dare/avere.',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_TRIAL_BALANCES}`
  ]]: 'Elenca Bilanci di Verifica',
  [T[
    `${ACTIONS_CATEGORIES.MICROSOFT_D365}-${MICROSOFT_D365.LIST_TRIAL_BALANCES}-desc`
  ]]:
    'Dati bilancio di verifica per tutti i conti mastro: numeri conto, nomi, tipi, saldi dare/avere.',

  [T.addAction]: 'Aggiungi azioni per assistente',
  [T.noParametersAction]: "L'azione non ha parametri",
  [T.removeAll]: 'Rimuovi tutto',
  [T.addAll]: 'Aggiungi tutto',
  [T.connect]: 'Connetti',
  [T.disconnect]: 'Disconnetti',
  [T.connected]: 'Connesso',
  [T.notConnected]: 'Non connesso',
  [T.connectors]: 'Connettori',
  [T.manageConnectors]: 'Gestisci connettori',
  [T.addConnector]: 'Aggiungi connettore',
  [T.addConnectors]: 'Aggiungi connettori',
  [T.connectorsModalDescription]:
    'Aumenta la tua produttività con i connettori.',
  [T.searchConnector]: 'Cerca connettore',
  [T.noConnectorsConnectedYetTitle]: 'Nessun connettore è ancora connesso.',
  [T.noConnectorsConnectedYetDescription]:
    'Vai alla scheda Tutti i connettori e connetti un connettore.\nI connettori connessi verranno visualizzati qui.',
  [T.noRemainingConnectorsToConnectTitle]:
    'Non ci sono altri connettori da connettere al momento.',
  [T.noRemainingConnectorsToConnectDescription]:
    'Tutti i connettori sono connessi, non ce ne sono altri disponibili.',
  [T.noConnectorMatchTitle]: 'Nessun connettore corrisponde a questo nome.',
  [T.noConnectorMatchDescription]:
    "Cerca il connettore inserendo il suo nome esatto oppure sfoglia l'elenco completo dei connettori.",
  [T.showAll]: 'Mostra tutto',
  [T.showLess]: 'Mostra meno',
  [T.workflowsNavLabel]: 'Flussi di lavoro',
  [T.connectorsDescription]:
    'Collega i tuoi strumenti e usali direttamente negli Assistants per vedere il lavoro concreto in tempo reale.',
  [T.noConnectorsFound]: 'Non sono stati ancora aggiunti connettori.',
  [T.askForConfirmation]: 'Chiedi conferma',
  [T.askForConfirmationTooltip]:
    "Ti verrà chiesto di confermare questa azione durante l'utilizzo in chat.",
  [T.toolPermissions]: 'Autorizzazioni strumenti',
  [T.enableAll]: 'Abilita tutto',
  [T.connectedActions]: 'Azioni collegate',
  [T.actionsLibrary]: 'Libreria delle azioni',
  [T.addActionsDescription]:
    'Aggiungi azioni che il tuo assistente può eseguire.',
  [T.noActionsConnectedYet]: 'Nessuna azione collegata',
  [T.addConnections]: 'Aggiungi connessioni',
  [T.enabledCount]: '{{count}}/{{total}} abilitate',
  [T.addActions]: 'Aggiungi azioni',
  [T.connectorConfigDescription]:
    'La configurazione selezionata verrà applicata a tutte le attività di azione in questa integrazione.',
  [T.connectorOwnConnectionQuestion]:
    'Gli utenti di questo assistente devono usare la propria connessione {{connector}} per questa azione?',
  [T.connectorDefaultOption]:
    'Sì, gli utenti dovranno connettere il proprio account {{connector}}.',
  [T.connectorAdvancedOption]:
    'No, tutti gli utenti devono usare la stessa connessione preselezionata. (Avanzata)',
  [T.connectorAttentionDescription]:
    'Scegli con attenzione la connessione. Chiunque utilizzi questo assistente può accedervi tramite questa azione, quindi assicurati che sia conforme a tutte le politiche di accesso.',
  [T.connectedSuccessfully]: 'Connessione riuscita',
  [T.actionsLimitDescription]:
    'Puoi aggiungere fino a 10 azioni per assistente.',
  [T.addConnectorDescription]:
    'La configurazione selezionata verrà applicata a tutte le attività di azione in questa integrazione.',
  [T.addActionDisclaimer]:
    'Gli utenti di questo assistente dovrebbero usare la propria connessione {{action_category}} per questa azione?',
  [T.defaultConnectionDisclaimer]:
    'Sì, gli utenti dovranno collegare il proprio account {{action_category}}.',
  [T.preSelectedDisclaimer]:
    'No, tutti gli utenti dovrebbero usare la stessa connessione preselezionata.',
  [T.attention]: 'Attenzione',
  [T.rulesDisclaimer]:
    'Prestare attenzione nella scelta di una connessione. Tutti gli utenti dell’assistente potranno usarla durante l’uso di questa azione. Assicurati che ciò non violi le regole di accesso.',
  [T.addConnection]: 'Aggiungi connessione',
  [T.addNewAction]: 'Aggiungi nuova azione',
  [T.addNewActions]: 'Aggiungi nuove azioni',
  [T.action]: 'Azioni',
  [T.preBuildActionText]:
    'Seleziona un’azione predefinita o crea una nuova azione personalizzata per connetterti a strumenti esterni.',
  [T.noActionsAvailable]: 'Nessuna azione disponibile.',
  [T.authenticationDisclaimer]:
    "L'utente deve prima autorizzarsi per poter eseguire questa azione.",
  [T.authenticate]: 'Autenticare',
  [T.deny]: 'Rifiutare',
  [T.advanceConnectionAuthenticationMsg]:
    'Chiedi al proprietario di questo assistente di autorizzare nuovamente.',
  [T.addAdvanceConnectionTooltip]:
    'Bitte fügen Sie die Verbindung hinzu, um diese Aktion zu verwenden',

  [T.canvasResponseTooLong]:
    'Errore durante lo streaming della tela. Risposta troppo lunga.',

  //Self Signup
  [T.companyInfoDesc]: 'Ci piacerebbe sapere qualcosa in più su di te...',
  [T.enterCompanyName]: 'Qual è il nome della tua azienda?',
  [T.firstName]: 'Nome',
  [T.lastName]: 'Cognome',
  [T.confirmPassword]: 'Conferma password',
  [T.password]: 'Password',
  [T.emailVerification]: 'Verifica email',
  [T.emailSentText]:
    'Abbiamo inviato un’email a {{email}} per verificare il tuo indirizzo.',
  [T.pleaseVerifyEmail]:
    'Per favore clicca sul pulsante “Verifica email” per continuare.',
  [T.contactUsText]: 'Per assistenza, contattaci a info@empowergpt.io',
  [T.notSeeingEmail]: 'Non hai ricevuto l’email?',
  [T.checkSpam]: 'Controlla la cartella spam oppure ',
  [T.resendEmail]: ' Reinvia email',
  [T.companyNameRequired]: 'Il nome dell’azienda è obbligatorio',
  [T.addCompanyName]: 'Inserisci il nome dell’azienda',
  [T.companySize]: 'Qual è la dimensione della tua azienda?',
  [T.companySizeRequired]: 'La dimensione dell’azienda è obbligatoria',
  [T.companySizeKey]: 'Dimensione azienda',
  [T.roleText]: 'Qual è il tuo ruolo?',
  [T.roleRequired]: 'Il ruolo è obbligatorio',
  [T.basedCountry]: 'In quale paese ha sede la tua azienda?',
  [T.countrySelectionRequired]: 'Il paese è obbligatorio',
  [T.startFreeTrial]: 'Inizia la mia prova gratuita',
  [T.billing]: 'Fatturazione',
  [T.paymentMethod]: 'Metodi di pagamento',
  [T.billingText]:
    'Gestisci le informazioni di fatturazione della tua organizzazione.',
  [T.upgradePlan]: 'Aggiorna piano',
  [T.paymentDesc]:
    'Il metodo predefinito viene utilizzato automaticamente per tutti i tuoi abbonamenti',
  [T.addPaymentMethod]: 'Aggiungi metodo di pagamento',
  [T.noPaymentAdded]: 'Nessun metodo di pagamento aggiunto.',
  [T.trialLi1]: 'Accesso alle funzioni principali di chat e assistente',
  [T.trialLi2]: 'Inizia con 5 € di credito per chat e utilizzo dei file',
  [T.trialLi3]: 'Aggiungi fino a 5 membri del team',
  [T.trialLi4]: 'Workspace sicuro con cronologia di base',
  [T.trialLi5]: 'Accesso limitato ai Mini Esperti',
  [T.trialLi6]: 'Perfetto per testare ed esplorare EmpowerGPT',
  [T.essentialFeaturesHeading]: 'Limiti di utilizzo mensili e capacità',
  [T.essentialLi1]:
    'Chat con IA di livello enterprise con politica di fair use',
  [T.essentialLi2]: 'Elaborazione file: 7 milioni di parole / 150+ file',
  [T.essentialLi3]: 'Search Plus: 50 ricerche',
  [T.essentialLi4]: 'Usa 1 app predefinita',
  [T.essentialLi5]: 'Doc Analyst: 3 analisi (fino a 10 domande ciascuna)',
  [T.essentialLi6]: 'OCR: 50 file',
  [T.essentialTagline]: 'Il tuo ingresso nell’IA enterprise',
  [T.perMonthPerUser]: '/mese per utente',
  [T.pricingUpgrade]: 'Aggiorna',
  [T.yearly]: 'Annuale',
  [T.save20]: 'Risparmia 20%',
  [T.monthly]: 'Mensile',
  [T.trial]: 'Prova',
  [T.professional]: 'Professional',
  [T.essential]: 'Essenziale',
  [T.freeTrial]: '7 giorni di prova gratuita',
  [T.trialCardText]:
    'Per chiunque voglia provare le straordinarie funzionalità dei prodotti EmpowerGPT.',
  [T.currentPlan]: 'Piano attuale',
  [T.perMonth]: 'al mese',
  [T.essentialCardText]:
    'Inizia con 1 utente – prova gratuita di 7 giorni, senza carta di credito, SaaS ospitato nell’UE, supporto digitale al servizio.',
  [T.upgrade]: 'Passa',
  [T.upgradeToPro]: 'Passa a Pro',
  [T.upgradeToProfessional]: 'Passa a Professional',
  [T.billedAnnually]: 'Fatturato annualmente',
  [T.letsTalk]: 'Parliamone',
  [T.contactSales]: 'Contatta vendite',
  [T.billedMonthly]: 'Fatturato mensilmente',
  [T.selfSignUpFailed]: 'Registrazione automatica non riuscita',
  [T.passwordValidateFailure]:
    'Deve includere maiuscola, numero e carattere speciale',
  [T.passwordMatchFailed]: 'Le password non corrispondono',
  [T.firstNameRequired]: 'Il nome è obbligatorio',
  [T.firstNameInvalid]:
    'Non sono ammessi caratteri speciali o spazi aggiuntivi.',
  [T.lastNameRequired]: 'Il cognome è obbligatorio',
  [T.lastNameInvalid]:
    'Non sono ammessi caratteri speciali o spazi aggiuntivi.',
  [T.passwordRequired]: 'La password è obbligatoria',
  [T.confirmPasswordRequired]: 'La conferma della password è obbligatoria',
  [T.emailSuccessfullySend]: `Account creato con successo! Verifica il tuo account tramite l'e-mail che ti abbiamo inviato`,
  [T.emailVerificationSuccessfullySend]:
    'Link di verifica email inviato con successo! Controlla la tua email per il link di verifica.',
  [T.noAccount]: 'Non hai un account?  ',
  [T.seatManagement]: 'Gestione posti',
  [T.seatManagementDesc]:
    'Migliora la tua esperienza aggiungendo posti extra al tuo piano',
  [T.updateSeats]: 'Aggiorna posti',
  [T.updatePlan]: 'Aggiorna piano',
  [T.availableSeat]: 'Posti disponibili',
  [T.totalPrice]: 'Prezzo totale',
  [T.updateSubscription]: 'Aggiorna abbonamento',
  [T.seats]: 'Posti',
  [T.seatSelectorDescription]:
    'Aggiungi più posti per aumentare la produttività e la collaborazione.',
  [T.calculateTotal]: 'Calcola totale',
  [T.purchasedPlan]: 'Piano acquistato',
  [T.orderSummary]: 'Riepilogo ordine',
  [T.selectedPlan]: 'Piano {{plan}}',
  [T.proceedToPayment]: 'Procedi al pagamento',
  [T.checkOutDesc]:
    'Il tuo abbonamento è programmato per il rinnovo il {{date}} per {{price}}',
  [T.businessOwner]: 'Titolare d’impresa',
  [T.seniorExecutive]: 'Dirigente',
  [T.manager]: 'Manager',
  [T.associate]: 'Associato',
  [T.other]: 'Altro',
  [T.executive]: 'Quadro',
  [T.signUpSuccess]: 'Reindirizzamento alla pagina di login',
  [T.trialEnds]: 'La tua prova gratuita terminerà tra {{days}} giorni il: ',
  [T.trialEndsToday]: 'Il tuo periodo di prova gratuito scade oggi: ',
  [T.trialEndedTitle]: 'La tua prova gratuita è terminata: ',
  [T.trialEndingOn]: 'La tua prova gratuita termina il:',
  [T.endsOn]: 'Termina il: ',
  [T.viewPlan]: 'Visualizza piano',
  [T.trialExpiredTitle]: 'La tua prova gratuita è terminata.',
  [T.subscriptionExpiredTitle]: 'Il tuo abbonamento è terminato.',
  [T.subscriptionExpiredDesc]:
    'Per continuare a usare Empower GPT, aggiorna il tuo piano.',
  [T.upgradeNow]: 'Aggiorna ora',
  [T.excludingTax]: '(Escluse imposte e IVA)',
  [T.month]: 'mese',
  [T.vat]: 'IVA',
  [T.toBeCalculated]: 'Da calcolare',
  [T.addCard]: 'Aggiungi un metodo di pagamento',
  [T.companyInfoFailure]: 'Impossibile salvare le informazioni aziendali',
  [T.checkoutSuccessfully]: 'Piano aggiornato con successo',
  [T.subscriptionSuccessfullyUpdated]: 'Abbonamento aggiornato con successo',
  [T.occupiedSeats]: 'Posti occupati',
  [T.newSeats]: 'Nuovi posti',
  [T.totalSeats]: 'Numero totale di posti',
  [T.currentAmount]: 'Adeguamento di fatturazione: €{{amount}}',
  [T.newChargeAmount]:
    'Importo totale per il prossimo ciclo di abbonamento: €{{amount}}',
  [T.discardChange]: 'Annulla modifiche',
  [T.userInvitePartialSuccess]:
    'Alcuni utenti non sono stati invitati. {{emails}} su {{total}} non riusciti.',
  [T.errorCalculatingPreview]: 'Errore nel calcolo della fattura',
  [T.backTo]: 'Torna a ',
  [T.seatsNotAvailable]: 'Acquista più posti per aggiungere altri utenti',
  [T.domainBlocked]:
    'Per favore fornisci un indirizzo email valido e permanente. Domini email temporanei o di uso singolo non sono consentiti.',
  [T.userAlreadyExist]: 'L’utente esiste già',
  [T.updatePaymentMethod]: 'Aggiorna metodo di pagamento',
  [T.errorGettingStripeDashboardUrl]:
    'Errore durante il recupero dell’URL della dashboard di Stripe',
  [T.errorDiscoveringTenant]: 'Errore durante la scoperta del tenant',
  [T.bestAIModelSelected]: 'Miglior modello di IA selezionato',
  [T.essentials]: 'Essenziali',
  [T.upgradeRestricted]: '⚠️ Aggiornamento limitato',
  [T.upgradeRestrictedInfo]:
    'Contatta il proprietario dell’organizzazione per aggiornare il tuo piano.',
  [T.bestAIModelSelected]: 'Miglior modello AI selezionato',
  [T.confirmCheckout]: 'Conferma checkout',
  [T.confirmCheckoutDesc]: 'Vuoi procedere?',
  [T.confirmPayment]: 'Conferma pagamento',
  [T.amountDeduction]:
    'L’importo di {{amount}} verrà addebitato dal tuo conto.',
  [T.confirmUpgrade]: 'Conferma aggiornamento',
  [T.updateSubscriptionDesc]:
    'Sei sicuro di voler aggiornare il tuo abbonamento?',
  [T.minusSeatWarningDesc]:
    'Se riduci il numero di postazioni, la modifica avrà effetto immediato. Non potrai assegnare utenti alle postazioni rimosse e la modifica della fatturazione verrà applicata a partire dal ciclo successivo.',
  [T.minusSeatWarningTitle]: 'La modifica avrà effetto immediato!',
  [T.minusSeatsDesc]:
    'Il tuo abbonamento verrà aggiornato alla fine del ciclo di fatturazione corrente.',
  [T.unableToPreviewInvoice]:
    'Impossibile visualizzare l’anteprima della fattura',
  [T.errorUpdatingSubscription]:
    'Errore durante l’aggiornamento dell’abbonamento',
  [T.subscriptionSyncError]: 'Errore di sincronizzazione dell’abbonamento',
  [T.noSubscription]: 'Impossibile trovare l’abbonamento',
  [T.invalidSubscription]: 'Abbonamento non valido',
  [T.wrongAddress]:
    'La località fiscale del cliente non è valida o non è riconosciuta.',
  [T.subscriptionCancelledText]:
    'Nessuna fattura imminente trovata, l’abbonamento potrebbe essere impostato per la cancellazione.',
  [T.insufficientBalance]:
    'La carta non ha fondi sufficienti per elaborare il pagamento.',
  [T.endTrialError]:
    'Non siamo in grado di procedere con il pagamento, riprova più tardi',
  [T.modelStatusDeprecated]: 'Il modello è stato deprecato con successo.',
  [T.modelStatusDeprecatedError]:
    'Il modello selezionato è deprecato. Scegline un altro.',
  [T.modelConfiguration]: 'Configurazione del modello',
  [T.defaultChatModel]: 'Modello di chat predefinito',
  [T.defaultChatModelMoto]:
    'Scegli il modello predefinito per tutte le nuove chat. Gli utenti possono modificarlo selezionando\nil proprio modello predefinito nelle impostazioni dell account.',
  [T.modelConfigurationMoto]:
    'Scegli quali modelli sono consentiti nel tuo spazio di lavoro',
  [T.searchModelsPlaceholder]: 'Modelli di ricerca.',
  [T.regionHostedEu]: 'Ospitato nell UE',
  [T.regionHostedUs]: 'Ospitato negli Stati Uniti',
  [T.regionHostedGlobal]: 'Ospitato a livello globale',
  [T.regionHostedOther]: 'Organizzato a {{region}}',
  [T.allModels]: 'Tutti i modelli',
  [T.addNewModel]: 'Aggiungi nuovo modello',
  [T.editModel]: 'Modifica modello',
  [T.modelName]: 'Nome del modello', // small improvement: add "del"
  [T.updateModel]: 'Aggiorna modello',
  [T.addDate]: 'Data di aggiunta',
  [T.providedBy]: 'Fornito da',
  [T.knowledgeCutoffDate]: 'Data di interruzione della conoscenza',
  [T.modelProvidedBy]: 'Modello fornito da',
  [T.modelDeploymentProvider]: 'Fornitore di distribuzione del modello',
  [T.modelUpdate]: 'Modello {{modelName}} {{status}} con successo',
  [T.enabled]: 'abilitato',
  [T.disabled]: 'disabilitato',
  [T.modelUpdateFailed]: 'Errore durante l aggiornamento del modello',
  [T.modelCreate]: 'Modello creato con successo',
  [T.modelCode]: 'Codice modello',
  [T.modelPriority]: 'Priorità modello',
  [T.ragCost]: 'Costo RAG',
  [T.ctFactor]: 'CT Factor',
  [T.ptFactor]: 'PT Factor',
  [T.modelRegion]: 'Regione',
  [T.modelAvailabilityInFeature]:
    'Disponibilità del modello nelle funzionalità',
  [T.deprecate]: 'Deprecato',
  [T.confirmDeprecateModelMessage]:
    'Sei sicuro di voler deprecare questo modello?',
  [T.scoringAnalysisDisclaimer]:
    'Analisi del punteggio rilasciata in Beta. Potrebbero verificarsi alcune discrepanze.',
  [T.cardActionRequiredError]:
    'È richiesta un’azione aggiuntiva dell’utente per completare il pagamento.',
  [T.cardExpiredError]: 'Il pagamento è stato rifiutato dal provider.',
  [T.analysisQuestionLimitReached]: 'Limite di domande di analisi raggiunto.',

  [T.paymentFailedError]: 'Il tentativo di pagamento non è riuscito, riprova.',
  [T.stripeTenantNotFoundError]: 'Il tenant non esiste.',
  [T.tenantDomainAlreadyExistsError]: 'Il dominio esiste già.',
  [T.searchTenantNotFoundError]: 'Linquilino cercato non è stato trovato.',
  [T.activeSubscriptionAlreadyExistsError]: 'Hai già un abbonamento attivo.',
  [T.upgradeYearlyPlan]: 'Aggiorna al piano annuale',
  [T.upgradeToYearly]: 'Passa all’abbonamento annuale',
  [T.upgradeToYearlyDesc]:
    'Passa all’abbonamento annuale e risparmia fino al 10%.',
  [T.shiftToYearlyPlan]: 'Passa al piano annuale',
  [T.upgradeToYearlyPlanButton]: 'Passa al piano annuale',
  [T.totalAmountToPayLine]: 'Importo totale da pagare: {{amount}}',
  [T.confirmYearlyUpgrade]: 'Conferma passaggio al piano annuale',
  [T.confirmYearlyUpgradeAmount]:
    'L’importo {{amount}} verrà addebitato sul tuo account.',
  [T.confirmYearlyUpgradeQuestion]: 'Vuoi procedere?',
  [T.cancelled]: 'Annullato',
  [T.updatedSubscriptionRequired]:
    'È necessario un abbonamento attivo per aggiornare i posti.',
  [T.subscriptionUpgradedSuccessfully]: 'Abbonamento aggiornato con successo.',
  [T.subscriptionUpgradeFailed]: 'Aggiornamento dell’abbonamento non riuscito.',
  [T.trialAlreadyExpired]: 'La prova è già scaduta',
  [T.subscriptionUpdateNotAllowed]:
    "L'abbonamento è stato annullato e i pagamenti non sono consentiti.",
  [T.minimumSeatsViolation]: 'Violazione del numero minimo di posti',
  [T.maximumSeatsViolation]:
    'Il numero massimo di posti con il tuo piano è 250, contattare il reparto vendite per procedere',
  [T.subscriptionRenewalNotAllowed]:
    "Il rinnovo dell'abbonamento non è consentito, l'abbonamento potrebbe essere impostato per l'annullamento",
  [T.subscriptionUpdateError]: "Errore nell'aggiornamento dell'abbonamento",
  [T.proceedToUpgrade]: "Procedi con l'aggiornamento",
  [T.upgradeConfirmDesc]:
    'Sei sicuro di voler passare il tuo abbonamento a un piano annuale?',
  [T.expired]: 'Scaduto',
  [T.selectFromWorkspace]: "Seleziona dall'area di lavoro",
  [T.uploadNew]: 'Carica nuovo',
  [T.controller]: 'Controllore',
  [T.domainNotRecognized]: 'Dominio non riconosciuto!',
  [T.domainInvalidFormat]:
    'Inserisci un nome di dominio valido (non sono ammessi caratteri speciali e maiuscole).',
  [T.domainNotRegistered]: 'Il dominio {{domain}} non è registrato.',
  [T.validDomainRequired]:
    'Si prega di utilizzare un link di dominio valido per accedere.',
  [T.checkEmailForDomain]:
    'Puoi trovare il dominio registrato nella tua email. Per ulteriore assistenza, contattaci a info@empowergpt.ai',
  [T.dontRememberDomain]: 'Non ricordi il dominio?',
  [T.loginFromThisLink]: 'Accedi da questo link:',
  [T.linkPlaceholder]: 'link',
  [T.signup]: 'Iscriviti',
  [T.alreadyHaveAccount]: ' Hai già un account?',
  [T.userAlreadyExists]: 'Questo utente esiste già.',
  [T.login]: 'Accedi',
  [T.signupInfo]:
    "Intelligenza artificiale aziendale per testo, voce, immagini e conoscenze: sicura e pronta all'uso",
  [T.workEmail]: 'E-mail di lavoro',
  [T.emailRequired]: 'Lindirizzo e-mail è obbligatorio',
  [T.recaptchaRequired]: 'Verifica di essere un essere umano',
  [T.signupConfirmation1]: 'Un invito è stato inviato al tuo indirizzo e-mail.',
  [T.signupConfirmation2]:
    "Clicca sul pulsante “Clicca per procedere” nell'e-mail ricevuta per configurare il tuo account. Il link di invito scadrà dopo 14 giorni.",
  [T.login]: 'Accedi',
  [T.creatingTenant]: 'Creazione del tenant',
  [T.settingUpWorkspaces]: 'Configurazione degli spazi di lavoro',
  [T.configuringPreferences]: 'Configurazione delle preferenze',
  [T.finalizingAccountSettings]:
    'Finalizzazione delle impostazioni dell’account',
  [T.welcome]: 'Benvenuto',
  [T.compareModelTitle]: 'Confronta modelli',
  [T.compareModelDescription]: 'Fianco a fianco',
  [T.chatHelperText]:
    '<highlight>Ciao,\u00A0</highlight> <span>come posso aiutarti oggi?</span>',
  [T.welcomeAndSignIn]: 'Welcome and Sign In',
  [T.signIn]: 'Sign In',
  [T.welcomeAndSignIn]: 'Benvenuto e Accedi',
  [T.signIn]: 'Accedi',
  [T.compareModelTitle]: 'Confronta modelli',
  [T.compareModelDescription]: 'Fianco a fianco',
  [T.chatHelperText]:
    '<highlight>Ciao,\u00A0</highlight> <span>come posso aiutarti oggi?</span>',
  [T.verifyingUser]: 'Verifica dell’utente in corso...',
  [T.credentialVerifying]: 'Attendere mentre verifichiamo le tue credenziali.',
  [T.setUpPassword]: 'Configura la password del tuo account',
  [T.passwordGuide]:
    'Una password sicura aiuta a prevenire accessi non autorizzati al tuo account email.',
  [T.reEnterPassword]: 'Reinserisci la password',
  [T.verificationFailed]: 'Verifica non riuscita',
  [T.verificationFailedDescription]:
    'La verifica non è andata a buon fine a causa della scadenza dellindirizzo e-mail!',
  [T.returnToLogin]: 'Torna al login',
  [T.passwordLength]: 'Sono richiesti almeno 8 caratteri',
  [T.specialCaseWarning]: 'Aggiungi almeno un carattere speciale',
  [T.passwordNotMatched]: 'Le password non corrispondono',
  [T.passwordRequirementSpecial]: 'Almeno un carattere speciale',
  [T.passwordRequirementUppercase]: 'Almeno un carattere maiuscolo',
  [T.passwordRequirementLowercase]: 'Almeno un carattere minuscolo',
  [T.passwordRequirementNumber]: 'Almeno un numero',
  [T.passwordRequirementMinLength]: 'Almeno 8 caratteri',
  [T.passwordRequirementMatch]: 'La password deve corrispondere',
  [T.organizationSubDomain]: 'Sottodominio dell’organizzazione',
  [T.organizationSubDomainPlaceholder]: 'la-tua-organizzazione',
  [T.checkAvailability]: 'Verifica disponibilità',
  [T.domainAvailable]: 'Il dominio è disponibile',
  [T.domainUnavailable]: 'Il dominio non è disponibile',

  [T.verifyEmail]: 'Verifica la tua email',
  [T.sentEmailMessage]: 'Abbiamo inviato un’email a ',
  [T.verificationEmailMessage]:
    'Clicca sul link nell’email per completare la registrazione. Se non la trovi, controlla la cartella <span>spam</span>.',
  [T.resendVerificationEmail]: 'Invia nuovamente l’email di verifica',
  [T.changeEmail]: 'Cambia email',

  [T.fillDetailMsg]: 'Compila i dettagli per iniziare.',
  [T.continueWithGoogle]: 'Continua con Google',
  [T.continueWithMicrosoft]: 'Continua con Microsoft',

  [T.dedicatedLoginUrl]:
    'Dopo la registrazione creeremo il tuo URL di accesso dedicato',
  [T.marketingConsent]:
    'Accetto di ricevere aggiornamenti via email sulla guida di onboarding, prodotti, servizi e novità da INTECH Automation & Intelligence GmbH.',

  [T.or]: 'Oppure',
  [T.example]: 'esempio: ',
  [T.enterEmail]: 'Inserisci la tua email',

  [T.trialHeading]: 'Inizia la tua prova gratuita di 7 giorni di EmpowerGPT!',
  [T.trialDescription]:
    'Goditi l’accesso completo senza rischi. Puoi annullare in qualsiasi momento, senza impegni.',
  [T.trustedEnterprise]:
    'Affidabile per conoscenza aziendale, conformità e protezione dei dati interni.',

  [T.noCreditCard]: 'Nessuna carta di credito richiesta',
  [T.secureKnowledge]: 'Ricerca sicura della conoscenza (RAG)',
  [T.teamReady]: 'Ambiente pronto per il team con workspace AI privato',
  [T.teamReadyEnvironment]: 'Ambiente pronto per il lavoro di squadra',
  [T.anyDocumentUpload]: 'Carica e consulta un numero illimitato di documenti',
  [T.easyUpgrade]: 'Facile aggiornamento quando si passa al piano Enterprise',

  [T.compliance]: 'Conformità',
  [T.freeTrial7DayHeading]: 'La tua prova gratuita di 7 giorni include:',
  [T.readyLoginUrl]: 'Il tuo URL di accesso è pronto',
  [T.yourLoginUrl]: 'Il tuo URL di accesso è:',
  [T.bookMarkUrl]:
    "Aggiungi questo URL di accesso ai preferiti: lo utilizzerai per effettuare l'accesso ogni volta.",
  [T.copyUrl]: 'Copia URL',
  [T.startOnboarding]: "Inizia l'onboarding",
  [T.needHelp]: "Hai bisogno di aiuto? Contattaci all'indirizzo",
  [T.welcome]: 'Benvenuto',
  [T.manageConnectorAccess]:
    'Gestisci chi ha accesso a questo connettore e cosa può fare.',
  [T.sqlDatabaseConnectionString]: 'Stringa di connessione al database (DSN)',
  [T.sqlDatabaseConnectionStringInvalid]:
    'Formato DSN non valido. Supportati: postgres://, mysql://, mariadb://, sqlserver://',
  [T.sqlDatabaseSupportedFormats]: 'Formati supportati:',
  [T.sapClientIdLabel]: 'ID client SAP',
  [T.sapClientIdPlaceholder]: 'Inserisci ID client SAP',
  [T.sapClientIdRequired]: "L'ID client OAuth è obbligatorio",
  [T.sapClientIdInvalid]:
    'Formato ID client non valido. Usa solo lettere, con trattini bassi consentiti tra le parole (es. my_client_id).',
  [T.sapTenantIdLabel]: 'Sottodominio tenant SAP',
  [T.sapTenantIdPlaceholder]: 'my300123',
  [T.sapTenantIdHelperText]:
    'Utilizzato per costruire gli URL di autenticazione, token e informazioni utente.',
  [T.sapTenantIdRequired]: 'Il sottodominio tenant SAP è obbligatorio',
  [T.sapTenantIdInvalid]:
    'Formato sottodominio tenant non valido. Usa solo lettere minuscole, numeri e trattini, iniziando e terminando con una lettera o un numero (es. my300123).',
  [T.requiredText]: 'Obbligatorio',
  [T.paymentPlanCreationFailed]:
    'Errore nella creazione del piano di pagamento',
  [T.paymentPlanAlreadyExist]:
    'Un piano di pagamento per questo cliente esiste già',
  [T.paymentPlanUpdateFailed]:
    'Errore durante l’aggiornamento del piano di pagamento',

  // Data Library
  [T.failed]: 'Non riuscito',
  [T.clickAndNameYourFolder]: 'Clicca e dai un nome alla tua cartella',
  [T.createNewFolder]: 'Crea nuova cartella',
  [T.viewOnlyAccessTitle]: 'Hai accesso in sola lettura ai dati.',
  [T.viewOnlyAccessDescription]:
    'Questo file è di sola lettura. È possibile solo visualizzarne il contenuto.',
  [T.theFolderIsEmpty]: 'La cartella è vuota',
  [T.uploadAndImportNewFiles]: 'Carica e importa nuove cartelle/file',
  [T.folderEmptyDescription]:
    "Questa cartella è vuota. Non c'è nulla da visualizzare.",
  [T.uploadSupportedFormatsDescription]:
    'Carica i tuoi documenti o cartelle nei seguenti formati supportati e limiti!',
  [T.nameCollection]: 'Nome raccolta',
  [T.webLinks]: 'Link Web',
  [T.addedCountOf5]: '{{count}}/5 Aggiunti',
  [T.addWebLink]: 'Aggiungi link web',
  [T.uploadingEllipsis]: 'Caricamento in corso...',

  [T.documentsUploadedSuccessfully]:
    '{{count}} documenti caricati con successo.',
  [T.documentUploadFailed]: '{{count}} caricamento documento non riuscito.',
  [T.uploadingFilesCount]: 'Caricamento di {{count}} file in corso...',
  [T.scanningFilesCount]: 'Lettura di {{processed}} di {{total}} file...',
  [T.preparingFolderFiles]: 'Preparazione dei file in corso...',
  [T.uploadedFileSingular]: '{{count}} file caricato',
  [T.uploadedFilePlural]: '{{count}} file caricati',
  [T.filesUploadedOfSingular]:
    '{{successCount}} di {{fileCount}} file caricato',
  [T.filesUploadedOfPlural]: '{{successCount}} di {{fileCount}} file caricati',
  [T.uploadingFileSingular]: 'Caricamento di {{count}} file in corso...',
  [T.uploadingFilePlural]: 'Caricamento di {{count}} file in corso...',
  [T.retryFailedDocument]: 'Riprova il documento non riuscito',
  [T.abortUpload]: 'Annullare il caricamento?',
  [T.abortUploadDescription]:
    'Se esci da questa pagina, i caricamenti in corso verranno annullati. Sei sicuro di voler continuare?',
  [T.yesAbortAll]: 'Sì, interrompi tutto',
  [T.noKeepUploading]: 'No, continua a caricare',
  [T.supportedDocFormats]:
    'PDF, PPT, PPTX, DOC, DOCX, ODS, ODP, ODT, RTF (300 MB)',
  [T.supportedMediaFormats]: 'MP3, MP4, MPGA, MPEG, WAV, M4A, WEBM (400 MB)',
  [T.supportedSpreadsheetFormats]: 'XLS, XLSX, CSV, TXT (50 MB)',
  [T.itemSelected]: '{{count}} elemento selezionato',
  [T.itemsSelected]: '{{count}} elementi selezionati',
  [T.selectAll]: 'Seleziona tutto',
  [T.userOrUserGroups]: 'Utente o gruppi utente',
  [T.searchByNameOrEmail]: 'Cerca per nome o email...',
  [T.searchByExistingNameOrEmail]: 'Cerca utente esistente per nome o email...',
  [T.loadingMore]: 'Caricamento in corso...',
  [T.noMoreItemsToLoad]: 'Nessun altro elemento da caricare',
  [T.unsupportedFilesLabel]: 'File non supportati',
  [T.modifiedSyncBy]: 'Modificato/Sincronizzato da',
  [T.modifiedOrSyncBy]: 'Modificato da o Sincronizzato da',
  [T.modifiedSyncOn]: 'Modificato/Sincronizzato il',
  [T.modifiedOrSyncOnTime]: 'Data di modifica o data di sincronizzazione',
  [T.statusOfResource]: 'Stato della risorsa',

  // Data Library Dialogs
  [T.areYouSure]: 'Sei sicuro?',
  [T.actionCannotBeUndone]:
    'Questa azione non può essere annullata. Tutti i progressi attuali andranno persi.',
  [T.aiOverview]: 'Panoramica AI',
  [T.summaryNotAvailable]: 'Il riepilogo non è disponibile per questa risorsa.',
  [T.undetected]: 'Non rilevato',
  [T.resourceNameLabel]: 'Nome {{resource}}',
  [T.nameYourResource]: 'Dai un nome al tuo {{resource}}',
  [T.remove]: 'Rimuovi',
  [T.searchSharedUsers]: 'Cerca utenti condivisi...',
  [T.whoHasAccess]: 'Chi ha accesso',
  [T.noMatchesFound]: 'Nessuna corrispondenza trovata',
  [T.noUsersHaveAccess]: 'Nessun utente ha accesso',
  [T.permissionSettings]: 'Impostazioni permessi',
  [T.selectDestinationFolder]: 'Seleziona cartella di destinazione',
  [T.accessOnly]: 'Solo accesso',
  [T.pastLocation]:
    'Posizione precedente: cartella {{folder}} nello spazio di lavoro {{workspace}}',
  [T.movePermissionTitle]: 'Permesso di spostamento',
  [T.movePermissionDescription]:
    'Puoi spostare i tuoi file solo negli spazi di lavoro/cartelle in cui hai il permesso di spostamento!',
  [T.noResourceFoundHere]: 'Nessuna risorsa trovata qui',
  [T.importFromExternalApps]: 'Importa da app esterne',
  [T.integrationNotFound]: 'Tipo di integrazione "{{type}}" non trovato.',
  [T.navigateSharePoint]:
    "Naviga nella cartella di destinazione o nella libreria per iniziare l'importazione.",
  [T.navigateOneDrive]:
    'Naviga nel tuo OneDrive e seleziona la cartella o il file di destinazione da importare.',
  [T.navigateConfluence]: 'Naviga nei tuoi spazi e pagine Confluence.',
  [T.failedToLoadSharePoint]: 'Impossibile caricare i dati di SharePoint.',
  [T.failedToLoadOneDrive]: 'Impossibile caricare i dati di OneDrive.',
  [T.failedToLoadConfluence]: 'Impossibile caricare i dati di Confluence.',
  [T.navigateGoogleDrive]:
    'Esplora Google Drive e seleziona la cartella o il file da importare.',
  [T.failedToLoadGoogleDrive]: 'Impossibile caricare i dati di Google Drive.',
  [T.googleDriveMyDrive]: 'I miei spazi',
  [T.googleDriveSharedDrives]: 'Condiviso con me',
  [T.openInGoogleDrive]: 'Apri in Google Drive',
  [T.noItemsFound]: 'Nessun elemento trovato.',
  [T.noSpacesOrPagesFound]: 'Nessuno spazio o pagina trovata.',
  [T.mySpaces]: 'I miei spazi',
  [T.sharedSpaces]: 'Spazi condivisi',
  [T.myDrive]: 'Il mio Drive',
  [T.sharedWithMeLabel]: 'Condiviso con me',
  [T.open]: 'Apri',
  [T.viewer]: 'Visualizzatore',
  [T.shareResourceTitle]: 'Condividi - {{name}}',

  // Data Library Header, Hooks & Utils
  [T.viewOnlyAccess]: 'Visualizza solo',
  [T.noPermissionToCreateResources]: 'Non hai il permesso di creare risorse.',
  [T.clearFilter]: 'Cancella filtro',
  [T.inProgressStatus]: 'In corso',
  [T.retryingStatus]: 'Nuovo tentativo',
  [T.unsupportedStatus]: 'Non supportato',
  [T.openInLabel]: 'Apri in',
  [T.synced]: 'Sincronizzato',
  [T.workspacesSecuredDescription]:
    'Utilizza aree di lavoro protette e con controllo degli accessi per la collaborazione privata.',
  [T.myWorkspaceDescription]:
    'I contenuti nella mia area di lavoro sono accessibili solo a te.',
  [T.publicWorkspaceDescription]:
    'I contenuti in Pubblico sono condivisi con tutti gli utenti.',
  [T.entityActionSuccess]: '{{entity}} {{action}} con successo.',
  [T.failedToActionEntity]: 'Impossibile {{action}} {{entity}}.',
  [T.cannotImportIntoPublicWorkspace]:
    "Impossibile importare in un'area di lavoro pubblica",
  [T.cannotImportIntoPrivateWorkspace]:
    "Impossibile importare in un'area di lavoro privata",
  [T.noExternalIntegrations]:
    'Non è possibile importare dati da fonti esterne finché non li configuri dalle impostazioni.',
  [T.keepExistingRolesOnSubItems]:
    'Mantieni i ruoli esistenti sugli elementi secondari',
  [T.applyToAllSubFoldersAndFiles]: 'Applica a tutte le sottocartelle e i file',
  [T.applyToFilesOnly]: 'Applica solo ai file',
  [T.resourceNameIsRequired]: 'Il nome della risorsa è obbligatorio',
  [T.cannotAssignRegularUserAsController]:
    "Non è possibile assegnare un utente regolare come controller dell'area di lavoro",
  [T.unauthorizedUsersNotAllowedAsController]:
    "Gli utenti non autorizzati non sono consentiti come controller dell'area di lavoro",
  [T.selectAtLeastOneUserOrGroup]: 'Seleziona almeno un utente o un gruppo',
  [T.pleaseSelectRole]: 'Seleziona un ruolo',
  [T.pleaseSelectAssignmentStrategy]: 'Seleziona una strategia di assegnazione',
  [T.collectionNameIsRequired]: 'Il nome della raccolta è obbligatorio',
  [T.collectionNameTooShort]: 'Il nome della raccolta è troppo corto',
  [T.invalidUrl]: 'URL non valido',
  [T.atLeastOneLinkRequired]: 'È richiesto almeno un link valido',
  [T.sharedTab]: 'Condiviso',
  [T.updated]: 'aggiornato',
  [T.created]: 'creato',
  [T.modified]: 'Modificato',
  [T.disableGoogleSSOToEnableThisOption]:
    'Disabilita SSO di Google per abilitare questa opzione',
  [T.disableMicrosoftSSOToEnableThisOption]:
    'Disabilita SSO di Microsoft per abilitare questa opzione',
  [T.maxLimitExceeded]: 'Hai superato il limite massimo.',
  [T.disableGoogleSSOToEnableThisOption]:
    'Disabilita SSO di Google per abilitare questa opzione',
  [T.disableMicrosoftSSOToEnableThisOption]:
    'Disabilita SSO di Microsoft per abilitare questa opzione',
  [T.resourceDeletionFailed]: 'Eliminazione della risorsa non riuscita.',
  [T.resourceDeleteSuccess]: 'Risorsa eliminata con successo.',
  [T.cannotRemoveYourself]:
    "Non è possibile rimuovere se stessi dall'elenco dei contatti condivisi",
  [T.adTokenExpired]:
    'Connessione allo stream della chat interrotta. Ricaricazione della pagina in {{seconds}} secondi…',
  [T.dataHostedByThirdPartiesComesWithSharingRestrictions]:
    'I dati ospitati da terze parti vengono condivisi con restrizioni.',
  [T.contentVisibilityDependsEntirelyOnItsSourcePermissionsExceptWhenItIsInPublicOrMyWorkspace]:
    'La visibilità dei contenuti dipende interamente dalle autorizzazioni della sorgente, ad eccezione quando si trovano in "Pubblico" o "Il mio spazio di lavoro".',
  [T.retry]: 'Riprova',
  [T.retryAll]: 'Riprova tutto',
  [T.cancelAll]: 'Annulla tutto',
  [T.syncingDescription]:
    'Attendere! Stiamo sincronizzando i tuoi dati dal tuo provider di terze parti.',
  [T.syncingTitle]: 'I tuoi dati sono in fase di sincronizzazione.',
  [T.syncFailedTitle]: 'Sincronizzazione dei dati non riuscita.',
  [T.syncFailedDescription]:
    'La sincronizzazione dei dati non è riuscita! Riprova con il pulsante di importazione.',
  [T.editAvailableModels]: 'Modifica modelli disponibili',
  [T.thinkingEffort]: 'Sforzo di ragionamento',
  [T.chooseThinkingEfforts]: 'Scegli lo sforzo di ragionamento',
  [T.thinkingEffortDescription]:
    'Uno sforzo maggiore produce risposte più approfondite, ma richiede più tempo e consuma più rapidamente i tuoi limiti.',
  [T.off]: 'Disattivato',
  [T.minimal]: 'Minimo',
  [T.low]: 'Basso',
  [T.high]: 'Alto',
  [T.xhigh]: 'Extra',
  [T.max]: 'Massimo',
  [T.hostedGloballyByProvider]: 'Ospitato globalmente da {{provider}}',
  [T.hostedInRegionByProvider]: 'Ospitato nella {{region}} da {{provider}}',
  [T.model_Llama_3_1_405B_description]:
    'Il più grande LLM open-weight. Ideale per attività multilingue, pipeline RAG e deployment enterprise on-prem su larga scala.',
  [T.model_Llama_3_2_90B_description]:
    'Modello open-weight multimodale efficiente con comprensione delle immagini. Ideale per attività di visione e inferenza self-hosted.',
  [T.model_deepseek_v3_description]:
    'Modello di ragionamento avanzato con contesto da 1M token e miglioramento 2× su ARC-AGI-2 rispetto a Gemini 3 Pro. Ideale per ricerca complessa, coding agentico e attività multimodali.',
  [T.model_gpt_5_description]:
    'Modello flagship unificato di OpenAI. Ideale per ragionamento complesso, coding e lavoro conoscitivo agentico in oltre 40 domini professionali.',
  [T.model_minio1_description]:
    'Modello di ragionamento leggero. Ideale per attività analitiche rapide ed economiche senza bisogno di compute avanzato.',
  [T.model_Mistral_large_description]:
    'Modello multilingue avanzato con conformità ai dati EU. Ideale per casi enterprise europei, coding e scenari sensibili alla compliance.',
  [T.model_gemini_3_1_pro_description]:
    'Modello di ragionamento avanzato di Google con contesto da 1M token e miglioramento 2× su ARC-AGI-2 rispetto a Gemini 3 Pro. Ideale per ricerca complessa, coding agentico e task multimodali.',
  [T.model_gemini_3_pro_preview_description]:
    'Modello di ragionamento avanzato di Google. Ideale per ricerca complessa, coding agentico e task multimodali.',
  [T.model_gpt_5_2_description]:
    'Modello all-purpose potente con modalità Instant, Thinking e Pro. Ideale per attività quotidiane e workflow agentici multi-step.',
  [T.model_gpt_5_3_chat_description]:
    'Modello GPT-5 focalizzato sul coding e ingegneria software autonoma. Ideale per sviluppatori professionisti e agenti a lunga esecuzione.',
  [T.model_claude_opus_4_6_description]:
    'Modello più avanzato di Anthropic. Ideale per ragionamento profondo, sintesi di ricerca e analisi di documenti complessi.',
  [T.model_claude_sonnet_4_6_description]:
    'Modello veloce e altamente capace. Ideale per coding, analisi documentale e task aziendali strutturati ad alto throughput.',
  [T.model_gemini_2_0_flash_description]:
    'Modello multimodale estremamente veloce ed economico. Ideale per Q&A ad alto volume e applicazioni a bassa latenza.',
  [T.model_gemini_2_5_flash_description]:
    'Versione migliorata di Flash 2.0 con maggiore velocità e precisione. Ideale per task multimodali veloci e contesti estesi.',
  [T.model_gpt_4o_description]:
    'Modello multimodale veloce con voce e visione native. Ideale per interazioni in tempo reale e uso quotidiano.',
  [T.model_gpt_5_1_description]:
    'Versione raffinata di GPT-5 con routing automatico tra modalità Instant e Thinking. Ideale per uso quotidiano personalizzato e controllabile.',
  [T.model_o1_description]:
    'Modello di ragionamento profondo con chain-of-thought esplicita. Ideale per matematica, logica e problemi STEM avanzati.',
  [T.model_gpt_4_1_description]:
    'Specialista a contesto lungo con finestra da 1M token. Ideale per grandi codebase, documenti legali e pipeline RAG multi-documento.',
  [T.model_gpt_5_4_description]:
    'Modello frontier che combina ragionamento, coding e workflow agentici. Ideale per task complessi di livello production con bassa allucinazione.',
  [T.model_gpt_4_32k_description]:
    'GPT-4 con finestra di contesto estesa a 32K. Ideale per attività su documenti lunghi che richiedono qualità GPT-4 senza accesso ai modelli più recenti.',
  [T.model_Llama_3_70B_Instruct_description]:
    'Modello instruction da 70B di generazione precedente. Ideale per attività generiche in ambienti self-hosted con budget ridotti.',
  [T.model_Mistral_large_02_description]:
    'Mistral Large aggiornato con miglioramento nel seguire istruzioni e nelle capacità di coding. Ideale per workload enterprise europei che richiedono migliore generazione di codice.',
  [T.model_cohere_description]:
    'Progettato per Enterprise RAG e utilizzo di strumenti. Ideale per retrieval-augmented generation, Q&A basato su fonti e workflow strutturati su dati.',
  [T.model_Llama_3_1_8b_Instruct_description]:
    'Modello open-weight leggero. Ideale per inferenza on-device o a bassa latenza con risorse computazionali limitate.',
  [T.model_Llama_3_1_70B_Instruct_description]:
    'Modello open-weight di dimensione media. Ideale per instruction-following, riassunti e deployment self-hosted con buon equilibrio tra costo e qualità.',
  [T.model_gpt_3_5_turbo_description]:
    'Modello generico veloce e a basso costo. Ideale per attività ad alto volume e latenza critica dove la qualità è secondaria.',
  [T.model_gpt_3_5_turbo_16k_description]:
    'GPT-3.5 Turbo con finestra di contesto estesa. Ideale per semplici attività su documenti lunghi a costo minimo.',
  [T.model_gpt_4_description]:
    'Versione originale di GPT-4. Ideale per ragionamento generale e task linguistici; in gran parte superata dai modelli più recenti.',
  [T.model_gpt_4_turbo_description]:
    'Versione GPT-4 ottimizzata più veloce e meno costosa con contesto da 128K. Ideale per task sensibili al costo che richiedono qualità GPT-4.',
  [T.model_grok_3_description]:
    'Modello di punta di xAI con accesso a dati in tempo reale da X (Twitter). Ideale per ragionamento STEM, analisi trend live e social intelligence.',
  [T.model_minio4_description]:
    'Modello di ragionamento leggero. Ideale per attività analitiche rapide ed economiche senza bisogno di compute avanzato.',
  [T.model_gpt_5_6_luna_description]:
    'Livello veloce ed economico, progettato per carichi di lavoro ad alto volume. Ideale per attività sensibili alla latenza e con vincoli di budget, come la classificazione e le ricerche semplici.',
  [T.model_gpt_5_6_terra_description]:
    "Modello equilibrato per l'uso quotidiano, con prestazioni di livello top di gamma di ultima generazione a circa la metà del prezzo. Ideale per l'implementazione con monitoraggio, la revisione iniziale e i carichi di lavoro generali di produzione.",
  [T.model_gpt_5_6_sol_description]:
    'Modello di ragionamento di punta dotato del sistema di sicurezza più solido mai realizzato da OpenAI. Ideale per problemi complessi e ad alto rischio, articolati in più fasi, in cui è richiesta la massima capacità possibile.',
  [T.model_claude_opus_5_description]:
    'Un modello di punta dalle prestazioni elevate, che si avvicina alle capacità di intelligenza artificiale di fascia alta a metà prezzo. Ideale per attività di programmazione complesse, lavoro intellettuale e compiti agentici a lungo termine.',
  [T.model_claude_opus_4_7_description]:
    'Modello di punta con maggiore capacità di sviluppo software, visione ad alta risoluzione e autoverifica su attività di lunga durata. Ideale per lavori di coding complessi e flussi di lavoro autonomi a lungo termine.',
  [T.model_claude_opus_4_8_description]:
    'Giudizio più accurato e maggiore onestà, con flussi di lavoro dinamici per migrazioni di codice su larga scala. Ideale per coding agentico, ragionamento e lavoro di conoscenza su vasta scala.',
  [T.model_gemini_3_5_flash_description]:
    "Il modello Flash più intelligente di Google, con prestazioni di livello massimo nell'esecuzione agentica, nel coding e nelle attività di lunga durata su larga scala. Ideale per coding iterativo, utilizzo di strumenti in più fasi e cicli agentici rapidi.",

  //Notifications
  [T.notifications]: 'Notifiche',
  [T.closeNotifications]: 'Chiudi notifiche',
  [T.markAllAsRead]: 'Segna tutto come letto',
  [T.unread]: 'Non letto',
  [T.allCaughtUp]: 'Sei aggiornato',
  [T.allCaughtUpDescription]:
    'Queste sono tutte le tue notifiche degli ultimi {{NOTIFICATION_RETENTION_DAYS}} giorni',
  [T.markAsRead]: 'Segna come letto',
  [T.markAsUnread]: 'Segna come non letto',
  [T.mute]: 'Silenzia notifiche',
  [T.dismiss]: 'Chiudi',
  [T.viewChanges]: 'Visualizza modifiche',
  [T.retentionDays]:
    'Periodo di conservazione: {{NOTIFICATION_RETENTION_DAYS}} giorni',
  [T.okay]: 'OK',
  [T.category]: 'Categoria',
  [T.inApp]: "Nell'app",
  [T.mandatory]: 'Obbligatorio',
  [T.mandatoryDescription]:
    'Il tuo team non può abilitare/disabilitare questa categoria di notifica',
  [T.optional]: 'Facoltativo',
  [T.optionalDescription]:
    'Il tuo team può abilitare/disabilitare questa categoria di notifica',
  [T.notificationsDescription]:
    'Scegli quali notifiche vuoi ricevere da Empower GPT',
  [T.organizationNotifications]: 'Notifiche organizzazione',
  [T.organizationNotificationsDescription]:
    'Gestisci le preferenze di notifica per la tua organizzazione',
  [T.notificationFetchError]: 'Impossibile recuperare le notifiche',
  [T.notificationMarkAllReadError]:
    'Impossibile contrassegnare tutte le notifiche come lette',
  [T.notificationReadStatusUpdateError]:
    'Impossibile aggiornare lo stato di lettura della notifica',
  [T.notificationDismissError]: 'Impossibile eliminare la notifica',
  [T.notificationDismissAllError]: 'Impossibile eliminare tutte le notifiche',
  [T.notificationPreferencesFetchError]:
    'Impossibile recuperare le preferenze di notifica',
  [T.notificationPreferencesUpdateError]:
    'Impossibile aggiornare le preferenze di notifica',
  [T.notificationMandatoryCategoryError]:
    'Questa categoria di notifica è obbligatoria e non può essere modificata',
  // Notification categories
  [T.notifCatDocumentProcessing]: 'Elaborazione documenti',
  [T.notifCatContentSharing]: 'Condivisione contenuti',
  [T.notifCatAssistantUpdates]: 'Aggiornamenti assistente',
  [T.notifCatWorkspaceChanges]: 'Modifiche area di lavoro',
  [T.notifCatConnectorSyncStatus]: 'Stato sincronizzazione connettore',
  [T.notifCatSystemAnnouncements]: 'Annunci di sistema',
  [T.notifCatWorkflowEvents]: 'Eventi del flusso di lavoro',
  [T.notifCatTenantLifecycle]: 'Ciclo di vita tenant',
  [T.notifCatSubscriptionAndBilling]: 'Abbonamento e fatturazione',
  [T.notifCatUserAndRoles]: 'Utenti e ruoli',
  [T.notifCatDocAnalyst]: 'Analista documenti',
  // Notification category descriptions
  [T.notifCatDescDocumentProcessing]:
    'Elaborazione completata, errori, aggiornamenti batch, report di errore e metriche delle prestazioni.',
  [T.notifCatDescContentSharing]:
    'Documenti, cartelle o raccolte aggiunti, modificati, eliminati o condivisi.',
  [T.notifCatDescAssistantUpdates]:
    'Assistenti condivisi, aggiornamenti ai preferiti, inviti alla collaborazione e modifiche alle versioni.',
  [T.notifCatDescWorkspaceChanges]:
    'Aggiornamenti degli iscritti, modifiche ai ruoli, nuovi inviti e adeguamenti delle autorizzazioni.',
  [T.notifCatDescConnectorSyncStatus]:
    'Sincronizzazioni SharePoint, OneDrive, Google Drive, modifiche agli accessi e avvisi di archiviazione.',
  [T.notifCatDescSystemAnnouncements]:
    'Nuovi modelli AI, finestre di manutenzione, rollout di funzionalità e aggiornamenti di sistema.',
  [T.notifCatDescWorkflowEvents]:
    'Esecuzioni del flusso di lavoro, errori, approvazioni, rifiuti e aggiornamenti di stato.',
  [T.notifCatDescTenantLifecycle]:
    'Creazione ed eliminazione di organizzazioni e aree di lavoro, modifiche alle autorizzazioni e richieste di accesso.',
  [T.notifCatDescSubscriptionAndBilling]:
    'Aggiornamenti abbonamento, avvisi di fatturazione, modifiche al piano, rinnovi e notifiche sui limiti di utilizzo.',
  [T.notifCatDescUserAndRoles]:
    'Notifiche relative alle modifiche degli account utente e agli aggiornamenti dei ruoli.',
  [T.notifCatDescDocAnalyst]:
    'Analisi completata, errori, aggiornamenti batch, report di errore e metriche delle prestazioni.',
  // Notification subcategories
  [T.notifSubCatDocumentProcessed]: 'Documento elaborato',
  [T.notifSubCatDocumentFailed]: 'Documento fallito',
  [T.notifSubCatBatchUploadComplete]: 'Caricamento batch completato',
  [T.notifSubCatDocumentShared]: 'Documento condiviso',
  [T.notifSubCatAccessChanged]: 'Accesso modificato',
  [T.notifSubCatConnectorSyncComplete]:
    'Sincronizzazione connettore completata',
  [T.notifSubCatConnectorSyncFailed]: 'Sincronizzazione connettore fallita',
  [T.notifSubCatTenantSettingChanged]: 'Impostazione tenant modificata',
  [T.notifSubCatSubscriptionUpdated]: 'Abbonamento aggiornato',
  [T.notifSubCatSubscriptionExpiryReminder]: 'Promemoria scadenza abbonamento',
  [T.notifSubCatAccountTypeChanged]: 'Tipo di account modificato',
  [T.notifSubCatUsageLimitWarning]: 'Avviso limite di utilizzo',
  [T.notifSubCatSystemMaintenance]: 'Manutenzione del sistema',
  [T.notifSubCatModelAdded]: 'Modello aggiunto',
  [T.notifSubCatModelDeprecated]: 'Modello deprecato',
  [T.notifSubCatWeeklyDigest]: 'Digest settimanale',
  [T.notifSubCatNewTenantCreated]: 'Nuovo tenant creato',
  [T.notifSubCatTenantDeactivationWarn]: 'Avviso disattivazione tenant',
  [T.notifSubCatAssistantShared]: 'Assistente condiviso',
  [T.notifSubCatAssistantUpdated]: 'Assistente aggiornato',
  [T.notifSubCatAssistantRemoved]: 'Assistente rimosso',
  [T.notifSubCatAnalysisCompleted]: 'Analisi completata',
  [T.notifSubCatAnalysisPartial]: 'Analisi parziale',
  [T.notifSubCatAnalysisFailed]: 'Analisi fallita',
  [T.notifSubCatDatasetModified]: 'Dataset modificato',
  [T.notifSubCatWorkspaceDeleted]: 'Area di lavoro eliminata',
  [T.notifSubCatWorkspaceCreated]: 'Area di lavoro creata',
  [T.notifSubCatWorkspaceAssigned]: 'Area di lavoro assegnata',
  [T.notifSubCatRoleChanged]: 'Ruolo modificato',
  [T.notifSubCatUserAdded]: 'Utente aggiunto',
  [T.notifSubCatUserRemoved]: 'Utente rimosso',
  [T.notifSubCatWorkflowCompleted]: 'Flusso di lavoro completato',
  [T.notifSubCatWorkflowFailed]: 'Flusso di lavoro fallito',
  [T.notifSubCatApprovalRequired]: 'Approvazione richiesta',
  [T.notifSubCatApprovalReminder]: 'Promemoria approvazione',
  // Notification summary and subcategory description templates
  [T.notifSummaryDocumentProcessed]:
    '{{filename}} è stato elaborato con successo.',
  [T.notifSubCatDescDocumentProcessed]:
    'Il documento {{filename}} è stato elaborato con successo.',

  [T.notifSummaryDocumentFailed]:
    '{{filename}} non è riuscito a elaborare. {{reason}}.',
  [T.notifSubCatDescDocumentFailed]:
    'Il documento {{filename}} non è riuscito a elaborare. {{reason}}.',

  [T.notifSummaryBatchUploadComplete]:
    'Batch completato: {{X}} di {{Y}} documenti elaborati, {{Z}} falliti.',
  [T.notifSubCatDescBatchUploadComplete]:
    'Caricamento batch completato: {{X}} di {{Y}} documenti elaborati, {{Z}} falliti.',

  [T.notifSummaryDocumentShared]:
    '{{sharer_name}} ha condiviso {{document_name}} con te.',
  [T.notifSubCatDescDocumentShared]:
    '{{sharer_name}} ha condiviso {{document_name}} con te.',

  [T.notifSummaryAccessChanged]:
    'Il tuo accesso a {{document_name}} è stato revocato a {{role}}.',
  [T.notifSubCatDescAccessChanged]:
    "L'accesso dell'utente al documento {{document_name}} è stato revocato a {{role}}.",

  [T.notifSummaryConnectorSyncComplete]:
    'Sincronizzazione {{connector_name}} completata: {{X}} nuovi, {{Y}} aggiornati, {{Z}} rimossi.',
  [T.notifSubCatDescConnectorSyncComplete]:
    'Sincronizzazione completata per {{connector_name}}: {{X}} nuovi documenti, {{Y}} aggiornati, {{Z}} rimossi.',

  [T.notifSummaryConnectorSyncFailed]:
    'Sincronizzazione {{connector_name}} fallita: {{error_summary}}.',
  [T.notifSubCatDescConnectorSyncFailed]:
    'Sincronizzazione {{connector_name}} fallita: {{error_summary}}.',

  [T.notifSummaryTenantSettingChanged]:
    'Le impostazioni per {{org_name}} sono state aggiornate.',
  [T.notifSubCatDescTenantSettingChanged]:
    'Piano di abbonamento per {{org_name}} aggiornato a {{plan_name}}. Nuovi limiti: {{summary}}.',

  [T.notifSummarySubscriptionUpdated]:
    'Abbonamento per {{org_name}} aggiornato a {{plan_name}}.',
  [T.notifSubCatDescSubscriptionUpdated]:
    'Piano di abbonamento per {{org_name}} aggiornato a {{plan_name}}. Nuovi limiti: {{summary}}.',

  [T.notifSummaryAccountTypeChanged]:
    'Il tuo ruolo è stato modificato da {{prev_role}} a {{new_role}}.',
  [T.notifSubCatDescAccountTypeChanged]:
    'Il tipo di account / ruolo è stato modificato da {{prev_role}} a {{new_role}}.',

  [T.notifSummarySubscriptionExpiryReminder]:
    'Il tuo abbonamento scade il {{date}}. Rinnova per evitare interruzioni.',
  [T.notifSubCatDescSubscriptionExpiryReminder]:
    "L'abbonamento EmpowerGPT per {{org_name}} scade il {{date}}. Rinnova per evitare interruzioni.",

  [T.notifSummaryUsageLimitWarning]:
    'Stai raggiungendo o superando i limiti di utilizzo per {{exceed_limit}}.',
  [T.notifSubCatDescUsageLimitWarning]:
    'Superamento dei limiti di utilizzo per {{exceed_limit}}.',

  [T.notifSummarySystemMaintenance]:
    'Manutenzione programmata. Il servizio potrebbe essere temporaneamente non disponibile.',
  [T.notifSubCatDescSystemMaintenance]:
    'Manutenzione programmata o aggiornamento della piattaforma.',

  [T.notifSummaryModelAdded]: 'Il modello AI {{model_name}} è ora disponibile.',
  [T.notifSubCatDescModelAdded]:
    'Il modello AI {{model_name}} è stato aggiunto.',

  [T.notifSummaryModelDeprecated]:
    'Il modello AI {{model_name}} è stato deprecato.',
  [T.notifSubCatDescModelDeprecated]:
    'Il modello AI {{model_name}} è stato deprecato.',

  [T.notifSummaryWeeklyDigest]:
    'Il tuo digest di utilizzo settimanale è pronto.',
  [T.notifSubCatDescWeeklyDigest]:
    'Ecco il digest settimanale {{weekly_usage}}.',

  [T.notifSummaryNewTenantCreated]:
    "L'organizzazione {{org_name}} è stata creata.",
  [T.notifSubCatDescNewTenantCreated]:
    'La nuova organizzazione {{org_name}} è stata creata.',

  [T.notifSummaryTenantDeactivationWarn]:
    "L'abbonamento della tua organizzazione si disattiva tra 1 settimana.",
  [T.notifSubCatDescTenantDeactivationWarn]:
    "L'abbonamento tenant è a 1 settimana dalla disattivazione.",

  [T.notifSummaryAssistantShared]:
    "{{creator_name}} ha condiviso l'assistente {{assistant_name}} con te.",
  [T.notifSubCatDescAssistantShared]:
    "{{creator_name}} ha condiviso l'assistente {{assistant_name}} con te.",

  [T.notifSummaryAssistantUpdated]:
    "L'assistente {{name}} è stato aggiornato da {{editor_name}}.",
  [T.notifSubCatDescAssistantUpdated]:
    "L'assistente {{name}} è stato aggiornato da {{editor_name}}.",

  [T.notifSummaryAssistantRemoved]: "L'assistente {{name}} è stato rimosso.",
  [T.notifSubCatDescAssistantRemoved]: "L'assistente {{name}} è stato rimosso.",

  [T.notifSummaryAnalysisCompleted]:
    '{{analysis_title}} completata — {{X}} di {{Y}} domande risposte.',
  [T.notifSubCatDescAnalysisCompleted]:
    'Analisi {{analysis_title}} completata — {{X}} di {{Y}} domande risposte.',

  [T.notifSummaryAnalysisPartial]:
    '{{analysis_title}} parzialmente completata — {{Z}} domande senza risposta.',
  [T.notifSubCatDescAnalysisPartial]:
    'Analisi {{analysis_title}} parzialmente completata — {{Z}} domande senza risposta.',

  [T.notifSummaryAnalysisFailed]: '{{analysis_title}} fallita: {{reason}}.',
  [T.notifSubCatDescAnalysisFailed]:
    'Analisi {{analysis_title}} fallita: {{reason}}.',

  [T.notifSummaryDatasetModified]:
    "Il dataset {{name}} è stato modificato — l'analisi {{title}} potrebbe essere interessata.",
  [T.notifSubCatDescDatasetModified]:
    "Il dataset {{name}} è stato modificato — l'analisi {{title}} potrebbe essere interessata.",

  [T.notifSummaryWorkspaceDeleted]:
    "L'area di lavoro {{name}} e tutti i suoi contenuti sono stati eliminati definitivamente.",
  [T.notifSubCatDescWorkspaceDeleted]:
    "L'area di lavoro {{name}} e tutti i suoi contenuti sono stati eliminati definitivamente.",

  [T.notifSummaryWorkspaceCreated]:
    "{{creator_name}} ha creato l'area di lavoro {{workspace_name}}.",
  [T.notifSubCatDescWorkspaceCreated]:
    "{{creator_name}} ha creato l'area di lavoro {{workspace_name}}.",

  [T.notifSummaryWorkspaceAssigned]:
    'Sei stato aggiunto a {{workspace_name}} come {{role}}.',
  [T.notifSubCatDescWorkspaceAssigned]:
    'Sei stato aggiunto alla nuova area di lavoro {{workspace_name}} come {{role}}.',

  [T.notifSummaryRoleChanged]:
    'Il tuo ruolo in {{workspace_name}} è stato modificato in {{new_role}}.',
  [T.notifSubCatDescRoleChanged]:
    "Il tuo ruolo nell'area di lavoro {{workspace_name}} è stato modificato in {{new_role}}.",

  [T.notifSummaryUserAdded]:
    'Sei stato aggiunto a {{workspace_name}} come {{role}}.',
  [T.notifSubCatDescUserAdded]:
    "Sei stato aggiunto all'area di lavoro {{workspace_name}} come {{role}}.",

  [T.notifSummaryUserRemoved]:
    'Il tuo accesso a {{workspace_name}} è stato revocato.',
  [T.notifSubCatDescUserRemoved]:
    "Il tuo accesso all'area di lavoro {{workspace_name}} è stato revocato.",

  [T.notifSummaryWorkflowCompleted]:
    'Flusso di lavoro {{workspace_name}} completato: {{status_summary}}.',
  [T.notifSubCatDescWorkflowCompleted]:
    'Flusso di lavoro completato con {{status_summary}}.',

  [T.notifSummaryWorkflowFailed]:
    'Flusso di lavoro {{workspace_name}} fallito al passo {{N}}: {{error_summary}}.',
  [T.notifSubCatDescWorkflowFailed]:
    'Flusso di lavoro {{workspace_name}} fallito al passo {{N}}: {{error_summary}}.',

  [T.notifSummaryApprovalRequired]:
    'Il flusso di lavoro {{workspace_name}} richiede la tua approvazione al passo {{step_name}}.',
  [T.notifSubCatDescApprovalRequired]:
    'Il flusso di lavoro {{workspace_name}} richiede la tua approvazione al passo {{step_name}}.',

  [T.notifSummaryApprovalReminder]:
    'Richiesta di approvazione in sospeso per {{workflow_name}} richiede azione.',
  [T.notifSubCatDescApprovalReminder]:
    'Promemoria richiesta di approvazione o escalation.',
  // Workflows
  [T.generateWithAiComingSoon]: 'Genera con AI (Prossimamente)',
  [T.createWithAi]: 'Crea (Prossimamente)',
  [T.addCondition]: 'Aggiungi condizione',
  [T.ifElseConditionTitle]: 'Condizione IF/Else',
  [T.branchExecution]: 'Esecuzione del ramo',
  [T.conditionsLabel]: 'Condizioni',
  [T.executeThisBranchIf]: 'Esegui questo ramo se',
  [T.elseIf]: 'Altrimenti se',
  [T.removeCondition]: 'Rimuovi condizione',
  [T.removingConditionsDisabled]:
    'La rimozione delle condizioni è disabilitata',
  [T.fieldLabel]: 'Campo',
  [T.operatorLabel]: 'Operatore',
  [T.matchText]: 'Testo da confrontare',
  [T.opEquals]: 'Uguale',
  [T.opNotEquals]: 'Diverso',
  [T.opContains]: 'Contiene',
  [T.opLessThan]: 'Minore di',
  [T.opLessThanOrEqual]: 'Minore o uguale',
  [T.opGreaterThan]: 'Maggiore di',
  [T.opGreaterThanOrEqual]: 'Maggiore o uguale',
  [T.firstMatchWinsSequential]: 'Prima corrispondenza vince (sequenziale)',
  [T.allowMultipleConditions]: 'Consenti più condizioni',
  [T.stopTheWorkflow]: 'Interrompi il workflow',
  [T.continueUsingErrorMessage]:
    'Continua usando il messaggio di errore come output',
  [T.continueOnNewErrorPath]: 'Continua sul nuovo percorso di errore',
  [T.regenerateNoun]: 'Rigenerare {{noun}}?',
  [T.regenerateWarning]:
    "Il valore attuale verrà invalidato. Tutto ciò che lo utilizza smetterà di funzionare fino all'aggiornamento. Questa azione non può essere annullata.",
  [T.regeneratingEllipsis]: 'Rigenerazione in corso…',
  [T.secretNoun]: 'Segreto',
  [T.passwordNoun]: 'Password',
  [T.workflowSaveFailed]: 'Salvataggio del workflow non riuscito',
  [T.wfStartOrder]: 'Avvia ordine',
  [T.wfOrderPlaced]: 'Ordine effettuato',
  [T.wfPreparingOrder]: 'Preparazione ordine',
  [T.wfCancelOrder]: 'Annulla ordine',
  [T.wfOutForDelivery]: 'In consegna',
  [T.wfOrderDelivered]: 'Ordine consegnato',
  [T.wfUntitledWorkflow]: 'Workflow senza titolo',
  [T.wfCreatedSuccessfully]: 'Workflow creato correttamente',
  [T.wfCreatedButEditorFailed]:
    "Workflow creato, ma non è stato possibile aprire l'editor. Aggiorna l'elenco se necessario.",
  [T.wfCreateFailed]: 'Creazione del workflow non riuscita',
  [T.wfNameAlreadyExists]: 'Esiste già un workflow con questo nome.',
  [T.wfInvalidSearchQuery]:
    'La query di ricerca email non è valida. Controlla virgolette e parentesi e usa solo gli operatori supportati.',
  [T.wfCreditLimitExceeded]:
    'Esecuzione del workflow interrotta, limite mensile di crediti raggiunto.',
  [T.wfRunsLimitExceeded]:
    'Limite mensile di esecuzioni del workflow raggiunto.',
  [T.wfBackToConfigurations]: 'Torna alla modalità di modifica',
  [T.wfDescriptionLabel]: 'Descrizione',
  [T.wfAbortRunTooltip]: "Interrompi l'esecuzione e torna alla modifica",
  [T.wfResetRunTooltip]: "Reimposta l'esecuzione e torna alla modifica",
  [T.wfRename]: 'Rinomina',
  [T.wfDuplicate]: 'Duplica',
  [T.wfDelete]: 'Elimina',
  [T.wfRenamedSuccessfully]: 'Workflow rinominato correttamente',
  [T.wfRenameFailed]: 'Rinomina del workflow non riuscita',
  [T.wfDuplicatedSuccessfully]: 'Workflow duplicato correttamente',
  [T.wfDuplicateFailed]: 'Duplicazione del workflow non riuscita',
  [T.wfDeleteConfirmTitle]: 'Elimina il workflow!',
  [T.wfDeleteConfirmMessage]: 'Sei sicuro di voler eliminare il workflow?',
  [T.wfDeletedSuccessfully]: 'Workflow eliminato correttamente',
  [T.wfDeleteFailed]: 'Eliminazione del workflow non riuscita',
  [T.wfDeleteDisabledActive]: 'Disattiva il workflow prima di eliminarlo',
  [T.wfInvalidWorkflowTitle]: 'Workflow non trovato',
  [T.wfInvalidWorkflowMessage]:
    'Impossibile caricare questo workflow — potrebbe essere stato eliminato o il link non è valido. Puoi procedere con i tuoi workflow esistenti.',
  [T.wfProcessWorkflowGrid]: 'Elabora con i workflow esistenti',
  [T.wfWorkflows]: 'Automazione',
  [T.wfHubSubtitle]:
    'Progetta, automatizza e orchestra i tuoi processi aziendali',
  [T.wfNoWorkflowsMatchSearch]: 'Nessun workflow corrisponde alla tua ricerca.',
  [T.wfNoWorkflowsToShow]: 'Nessun workflow da mostrare.',
  [T.wfNoWorkflowsByStatus]: 'Nessun workflow {{statusFilter}} da mostrare.',
  [T.wfLoadFailed]: 'Impossibile caricare i workflow. Riprova.',
  [T.wfBlocks]: 'blocchi',
  [T.wfCost]: 'costo',
  [T.wfRuns]: 'esecuzioni',
  [T.wfNode]: 'Nodo',
  [T.wfLoopStart]: 'Inizio ciclo',
  [T.wfBlockType]: 'Tipo di blocco',
  [T.wfLoop]: 'Ciclo',
  [T.wfArrayToLoopOver]: 'Array da iterare',
  [T.wfLoopVariable]: 'Variabile del ciclo',
  [T.wfCollectBlockOutputs]: 'Raccogli output dei blocchi',
  [T.wfMaxIterations]: 'Iterazioni massime',
  [T.wfHardcodedProcessorNoEditableFields]:
    'Processore predefinito senza campi modificabili.',
  [T.wfHardcodedNoEditableFields]: 'Predefinito senza campi modificabili.',
  [T.wfCode]: 'Codice',
  [T.wfPythonCodePlaceholder]: 'code',
  [T.wfErrorHandling]: 'Gestione degli errori',
  [T.wfOnError]: 'In caso di errore',
  [T.wfStopWorkflow]: 'Interrompi flusso di lavoro',
  [T.wfContinueUsingErrorOutput]: "Continua usando l'output di errore",
  [T.wfOutputNodeDescription]:
    "Questo nodo memorizza un valore come output dell'esecuzione del flusso di lavoro. Puoi avere più nodi di output, ognuno dei quali memorizza un valore sotto il suo slug univoco.",
  [T.wfOutputValue]: 'Valore di output',
  [T.wfOutputUrlPlaceholder]: "https://... o percorso dell'area di lavoro",
  [T.wfAgent]: 'Agente',
  [T.wfSelectExisting]: 'Seleziona esistente',
  [T.wfModelRequired]: 'Modello*',
  [T.wfPromptRequired]: 'Prompt*',
  [T.wfAddTool]: 'Aggiungi strumento',
  [T.wfTools]: 'Strumenti',
  [T.wfKnowledge]: 'Conoscenza',
  [T.wfAddKnowledge]: 'Aggiungi conoscenza',
  [T.wfSelectFromNodes]: 'Seleziona dai nodi',
  [T.wfStructuredOutput]: 'Output strutturato',
  [T.wfAddStructuredField]: 'Aggiungi campo strutturato',
  [T.wfRemoveField]: 'Rimuovi campo',
  [T.wfMaxSteps]: 'Passi massimi',
  [T.wfMaxStepsLimitExceeded]: 'Il valore massimo consentito è 20',
  [T.wfNoCodeOutputConfigured]: '*Nessun output di codice configurato.*',
  [T.wfCreateNewWorkflow]: 'Crea nuovo flusso di lavoro',
  [T.wfGiveWorkflowDescriptiveName]:
    'Assegna al tuo flusso di lavoro un nome e una descrizione chiari, così sarà più facile identificarlo e riutilizzarlo in seguito.',
  [T.wfEnter]: 'Inserisci',
  [T.wfCreating]: 'Creazione in corso…',
  [T.wfProvideWorkflowName]: 'Fornisci un nome per il flusso di lavoro',
  [T.wfDescriptionOptional]: 'Descrizione (facoltativa)',
  [T.wfDescribeWorkflowPurpose]:
    'Descrivi lo scopo di questo flusso di lavoro.',
  [T.wfChooseFirstNode]: 'Scegli il primo nodo',
  [T.wfTrigger]: 'Trigger',
  [T.wfTriggerSubtitle]: 'Inizia con un trigger modulo / caricamento',
  [T.wfWebhookSubtitle]: 'Inizia con un webhook esterno',
  [T.wfIntegrationTrigger]: 'Trigger di integrazione',
  [T.wfIntegrationTriggerSubtitle]:
    'Inizia con un evento di integrazione esterno',
  [T.wfWebhookBlockDesc]: 'Attiva da app o API esterne',
  [T.wfScheduledBlock]: 'Pianificato',
  [T.wfScheduledBlockDesc]: 'Esegui automaticamente secondo una pianificazione',
  [T.wfSchedule]: 'Pianificazione',
  [T.wfScheduleTypeLabel]: 'Tipo di pianificazione',
  [T.wfScheduleTypeCustom]: 'Personalizzato',
  [T.wfScheduleTypeEvery1Hour]: 'Ogni ora',
  [T.wfScheduleTypeEvery2Hours]: 'Ogni 2 ore',
  [T.wfScheduleTypeEvery6Hours]: 'Ogni 6 ore',
  [T.wfScheduleTypeEvery12Hours]: 'Ogni 12 ore',
  [T.wfScheduleTypeDailyMidnight]: 'Ogni giorno a mezzanotte',
  [T.wfScheduleTypeDaily6Am]: 'Ogni giorno alle 6:00',
  [T.wfScheduleTypeDaily9Am]: 'Ogni giorno alle 9:00',
  [T.wfScheduleTypeEveryMonday]: 'Ogni lunedì',
  [T.wfScheduleTypeEverySunday]: 'Ogni domenica',
  [T.wfScheduleTypeMonthly1st]: 'Mensile il 1°',
  [T.wfRunEvery]: 'Esegui ogni',
  [T.wfInvalidTypedDate]: 'Data non valida. Usa un formato come {{example}}',
  [T.wfIntervalUnitMinute]: 'Minuto/i',
  [T.wfIntervalUnitHour]: 'Ora/e',
  [T.wfIntervalUnitDay]: 'Giorno/i',
  [T.wfIntervalUnitWeek]: 'Settimana/e',
  [T.wfIntervalUnitMonth]: 'Mese/i',
  [T.wfRunEverySummary]: 'Ogni {{interval}} {{unit}}',
  [T.wfTimezone]: 'Fuso orario',
  [T.wfSearchTimezone]: 'Cerca fuso orario',
  [T.wfNoTimezoneMatchSearch]: 'Nessun fuso orario corrisponde alla ricerca.',
  [T.wfStartsAt]: 'Inizia il',
  [T.wfEndsAt]: 'Termina il',
  [T.wfEndsAtNever]: 'Mai',
  [T.wfEndsAtOnDate]: 'Imposta data e ora',
  [T.wfPreview]: 'Anteprima',
  [T.wfPreviewRunNumber]: '#{{number}}',
  [T.wfNoUpcomingRuns]: 'Nessuna esecuzione programmata',
  [T.wfSelectDateTime]: 'Seleziona data e ora',
  [T.wfTest]: 'Test',
  [T.wfManualTrigger]: 'Manuale',
  [T.wfManualTriggerDesc]: 'Avvia il workflow manualmente',
  [T.wfFormBlock]: 'Modulo',
  [T.wfFormBlockDesc]: "Attiva dall'invio di un modulo",
  [T.wfIntegrationBlock]: 'Integrazione',
  [T.wfIntegrationBlockDesc]: 'Connetti ad app esterne',
  [T.wfIfElseBlock]: 'SE/ALTRIMENTI',
  [T.wfIfElseBlockDesc]: 'Instrada il flusso in base a condizioni',
  [T.wfLoopBlockDesc]: 'Ripeti azioni per ogni elemento',
  [T.wfAgentBlockDesc]: "Agente IA per l'esecuzione di attività",
  [T.wfCodeBlockDesc]: 'Esegui logica di codice personalizzata',
  [T.wfOutputBlockDesc]: 'Mostra o esporta i risultati',
  [T.wfPdfProcessorBlockDesc]: 'Estrai ed elabora dati PDF',
  [T.wfCategoryTrigger]: 'Trigger',
  [T.wfCategoryLogic]: 'Logica',
  [T.wfCategoryOthers]: 'Altri',
  [T.wfCategoryProcessors]: 'Processori',
  [T.wfAddBlock]: 'Aggiungi blocco',
  [T.wfNoBlocksMatchSearch]: 'Nessun blocco corrisponde alla tua ricerca.',
  [T.wfNoPastRuns]: 'Ancora nessuna esecuzione precedente.',
  [T.wfNoPastRunSteps]: 'Nessun dato disponibile per questa esecuzione.',
  [T.wfNoDeployVersions]:
    'Ancora nessuna versione di distribuzione precedente.',
  [T.wfLetsStart]: 'Iniziamo',
  [T.wfNewField]: 'Nuovo campo',
  [T.wfRemoveField2]: 'Rimuovi campo',
  [T.wfLabel]: 'Etichetta',
  [T.wfFieldTypeText]: 'Testo',
  [T.wfFieldTypeMultilineText]: 'Testo multilinea',
  [T.wfFieldTypeCheckbox]: 'Casella di controllo',
  [T.wfFieldTypeTextarea]: 'Area di testo',
  [T.wfFieldTypeNumber]: 'Numero',
  [T.wfAllowMultipleFiles]: 'Consenti più file',
  [T.wfDefaultValue]: 'Valore predefinito',
  [T.wfNodeConfig]: 'Configurazione nodo',
  [T.wfNodeLabel]: 'Etichetta nodo',
  [T.wfFields]: 'Campi',
  [T.wfAddField]: 'Aggiungi campo',
  [T.wfPastRuns]: 'Esecuzioni passate',
  [T.wfTotalRuns]: 'Esecuzioni totali',
  [T.wfTotalCost]: 'Credito totale',
  [T.wfRunNumber]: 'Esecuzione n. {{runNumber}}',
  [T.wfPastDeployVersions]: 'Versioni di distribuzione precedenti',
  [T.wfLive]: 'Live',
  [T.wfRestore]: 'Ripristina',
  [T.wfRestoreVersionTitle]: 'Ripristinare questa versione?',
  [T.wfRestoreVersionDesc]:
    'Il ripristino alla versione {{version}} sovrascriverà il workflow corrente. Questa azione non può essere annullata.',
  [T.wfUploadField]: 'Carica {{name}}',
  [T.wfUnsupportedField]: 'Campo non supportato: {{type}}',
  [T.wfRunWorkflow]: 'Esegui workflow',
  [T.wfRunWorkflowInstructions]:
    'Seleziona i file per avviare automaticamente il caricamento, quindi esegui il workflow.',
  [T.wfPreparingUpload]: 'Preparazione caricamento…',
  [T.wfUploadingBatch]:
    'Caricamento batch {{batchIndex}} di {{totalBatches}} — {{percent}}%',
  [T.wfUploadedFilesToWorkspace]:
    "Caricato/i {{count}} file nei percorsi dell'area di lavoro.",
  [T.wfUploadingFiles]: 'Caricamento di {{done}}/{{total}} file…',
  [T.wfUploadedFilesSuccess]: 'Caricato/i {{count}} file con successo.',
  [T.wfFilesFailedToUpload]:
    'Caricamento non riuscito per {{failed}} file su {{total}}.',
  [T.wfUploadFailedRetry]: 'Caricamento non riuscito. Riprova.',
  [T.wfNoFilesUploaded]: 'Nessun file ancora caricato.',
  [T.wfRemoveUnsupportedFilesToRun]:
    'Rimuovi i file non supportati per eseguire il workflow.',
  [T.wfFileAlreadyAdded]: 'Questi file sono già stati aggiunti.',
  [T.wfFileSizeKb]: '{{size}} KB',
  [T.wfRun]: 'Esegui',
  [T.wfDeploy]: 'Distribuisci',
  [T.wfAuthenticationLabel]: 'Autenticazione: {{label}}',
  [T.wfNoAuthentication]: 'Nessuna autenticazione',
  [T.wfBearerToken]: 'Bearer Token',
  [T.wfBasicAuth]: 'Basic',
  [T.wfApiKey]: 'Chiave API',
  [T.wfWebhook]: 'Webhook',
  [T.wfConnectOutlook]: 'Connetti Outlook',
  [T.wfConnectingEllipsis]: 'Connessione…',
  [T.wfCopiedToClipboard]: 'Copiato negli appunti',
  [T.wfDeployWorkflow]: 'Distribuisci workflow',
  [T.wfNewVersion]: 'Nuova versione',
  [T.wfMinor]: 'Minore',
  [T.wfMajor]: 'Maggiore',
  [T.wfDescribeChangesPlaceholder]:
    'Descrivi le modifiche apportate in questa versione.',
  [T.wfChanges]: 'Modifiche',
  [T.wfBriefDetails]: 'Dettagli in breve',
  [T.wfDescribeBriefPlaceholder]: 'Descrivi in breve questa versione.',
  [T.wfNoChangesToDeploy]: 'Nessuna modifica da distribuire.',
  [T.wfGoToBlock]: 'Vai al blocco',
  [T.wfDeleted]: 'Eliminato',
  [T.wfAdded]: 'Aggiunto',
  [T.wfEdgeRemoved]: 'Connessione rimossa',
  [T.wfChangedLabel]: 'Modificato: {{label}}',
  [T.wfResetNodePositions]: 'Reimposta posizioni dei nodi',
  [T.wfUndo]: 'Annulla',
  [T.wfRedo]: 'Ripeti',
  [T.wfZoomIn]: 'Ingrandisci',
  [T.wfZoomOut]: 'Riduci',
  [T.wfFitView]: 'Adatta alla vista',
  [T.wfLock]: 'Blocca',
  [T.wfTestExecute]: 'Esegui test',
  [T.wfStopExecution]: 'Interrompi esecuzione',
  [T.wfRenameWorkflow]: 'Rinomina workflow',
  [T.wfWorkflowResult]: 'Risultato del workflow',
  [T.wfOutputLabel]: 'Output: {{outputField}}',
  [T.wfDownloadOutputFile]: 'Scarica file di output',
  [T.wfTriggerPdfs]: 'PDF di attivazione',
  [T.wfInput]: 'Input',
  [T.wfOutput]: 'Output',
  [T.wfBody]: 'corpo',
  [T.wfCollapse]: 'Comprimi',
  [T.wfQueued]: 'In coda',
  [T.wfSavedInEditorTooltip]:
    "Salvato nell'editor — usa Salva principale per memorizzare sul server",
  [T.wfUnsaved]: 'Non salvato',
  [T.wfBlocksCount]: '{{blocks}} blocchi',
  [T.wfCostLabel]: '$ {{cost}} costo',
  [T.wfFlowRunsCount]: '{{flowRuns}} esecuzioni',
  [T.wfTotalRunsCount]: '{{totalRuns}} esecuzioni',
  [T.wfVersionLabel]: 'versione {{version}}',
  [T.wfVersionShort]: '{{version}} Ver',
  [T.wfClosesLoopVariable]: 'Chiude: {{loopVariable}}',
  [T.wfInnerAgents]: 'Agenti interni',
  [T.wfVariableLabel]: 'Variabile: ',
  [T.wfProvideArrayToIterate]: 'Fornisci un array da iterare',
  [T.error]: 'Errore',
  [T.wfWorkflowFailed]: 'Workflow non riuscito',
  [T.wfWorkflowFailedAtNode]: 'Workflow non riuscito su {{node}}',
  [T.wfNodeExecutionFailed]: 'Esecuzione del nodo non riuscita',
  [T.wfAuthenticationMethod]: 'Metodo di autenticazione',
  [T.wfUsername]: 'Nome utente',
  [T.wfPassword]: 'Password',
  [T.wfWebhookSecret]: 'Segreto webhook',
  [T.wfWebhookCurl]: 'Webhook cURL',
  [T.wfTypeHerePlaceholder]: 'Scrivi qui',
  [T.wfHide]: 'Nascondi',
  [T.wfShow]: 'Mostra',
  [T.wfName]: 'Nome',
  [T.wfNameMaxLengthReached]: 'Limite massimo di caratteri raggiunto',
  [T.wfEditDetails]: 'Modifica dettagli',
  [T.wfEditWorkflowDetails]: 'Modifica dettagli del workflow',
  [T.wfDetailsUpdated]: 'Dettagli del workflow aggiornati',
  [T.wfDetailsUpdateFailed]:
    'Aggiornamento dei dettagli del workflow non riuscito',
  [T.wfFieldTypeFile]: 'File',
  [T.wfClose]: 'Chiudi',
  [T.wfCopyWebhookSecret]: 'Copia segreto webhook',
  [T.wfRevealToCopy]: 'Mostra per copiare',
  [T.wfCopyWebhookUrl]: 'Copia URL webhook',
  [T.wfAcceptedTypesPlaceholder]: '.pdf,.docx',
  [T.wfCompleteRequiredFields]:
    'Completa i campi obbligatori prima di eseguire il workflow: {{fields}}.',
  [T.wfDownload]: 'Scarica',
  [T.wfOutputUrl]: 'URL di output',
  [T.wfLoopToEnd]: 'Fine ciclo',
  [T.wfLoop]: 'Ciclo',
  [T.wfAddOutputField]: 'Aggiungi campo di output',
  [T.wfFieldType]: 'Tipo di campo',
  [T.wfFieldPurposePlaceholder]: 'Descrivi lo scopo di questo campo.',
  [T.wfRequiredFieldHint]:
    "Questo campo deve essere incluso nell'output dell'agente.",
  [T.wfStructuredOutputHint]:
    "L'output verrà generato in formato non strutturato quando l'interruttore è disattivato.",
  [T.wfSelectModel]: 'Seleziona modello',
  [T.wfInsertContext]: 'Inserisci contesto',
  [T.wfInsert]: 'Inserisci',
  [T.wfRunBlock]: 'Esegui blocco',
  [T.wfReRunBlock]: 'Riesegui blocco',
  [T.wfRunBlockToGenerate]:
    "Fai clic su Esegui blocco per generare dati da usare come contesto per l'input.",
  [T.wfNoUpstreamNodes]: 'Nessun nodo precedente disponibile.',
  [T.wfEnterFieldLabel]: 'Inserisci etichetta campo',
  [T.wfStructuredOutputAdded]: 'Output strutturato aggiunto',
  [T.wfAdd]: 'Aggiungi',
  [T.wfAddStructuredOutput]: 'Aggiungi output strutturato',
  [T.wfAllowMultipleUploads]: 'Consenti caricamenti multipli',
  [T.wfArrayProvided]: 'Array fornito',
  [T.wfBlockTypeForm]: 'Modulo',
  [T.wfButtonLabel]: 'Etichetta pulsante',
  [T.wfCloses]: 'Chiude:',
  [T.wfCodeIsWritten]: 'Il codice è scritto.',
  [T.wfConstructingPrompt]: 'Creazione del prompt',
  [T.wfDeactivate]: 'Disattiva',
  [T.wfExtractingTextTables]: 'Estrazione di testo/tabelle',
  [T.wfFieldDescriptionPlaceholder]: 'Descrivi lo scopo di questo campo.',
  [T.wfFormFieldAdded]: 'Campo del modulo aggiunto.',
  [T.wfFormFieldRequired]: 'Campo del modulo obbligatorio.',
  [T.wfFieldNameDuplicate]: 'Esiste già un campo con questo nome.',
  [T.wfFormFields]: 'Campi del modulo',
  [T.wfLoopEnd]: 'Fine ciclo',
  [T.wfNextIteration]: 'Iterazione successiva',
  [T.wfOutputNodeHint]:
    "Questo nodo memorizza un valore come output dell'esecuzione del flusso di lavoro. Puoi avere più nodi di output, ognuno dei quali memorizza un valore sotto il suo slug univoco.",
  [T.wfOutputValueWritten]: 'Il valore di output è scritto.',
  [T.wfPdfProcessor]: 'Processore PDF',
  [T.wfPreviousIteration]: 'Iterazione precedente',
  [T.wfProcessing]: 'Elaborazione',
  [T.wfProcessingItem]: 'Elaborazione elemento {{current}}',
  [T.wfProcessingItemOf]: 'Elaborazione elemento {{current}} di {{total}}',
  [T.wfTemplateFieldPlaceholder]:
    'Scrivi testo o usa {{ }} per fare riferimento a dati di nodi precedenti',
  [T.wfPromptWritten]: 'Il prompt è scritto.',
  [T.wfReplace]: 'Sostituisci',
  [T.wfRequired]: 'Obbligatorio',
  [T.wfRunningScript]: 'Esecuzione dello script',
  [T.wfSpinningUpSandbox]: 'Avvio della sandbox',
  [T.wfSubmit]: 'Invia',
  [T.wfThinking]: 'Pensando…',
  [T.wfUserEndCustomization]: 'Personalizzazione lato utente',
  [T.wfValidatingFields]: 'Convalida dei campi',
  [T.wfWorkflowComplete]: 'Workflow completato',
  [T.wfWriteCode]: 'Scrivi codice',
  [T.wfWriteOutputValue]: 'Scrivi il valore di output.',
  [T.wfWritePrompt]: 'Scrivi prompt',
  [T.wfIfElseLabel]: 'SE/ALTRIMENTI',
  [T.wfNoBranchesConfigured]: 'Nessun ramo configurato',
  [T.wfBranchCount]: '{{count}} ramo/i',
  [T.wfIfOneTitle]: 'SE 1',
  [T.wfElseIfNTitle]: 'ALTRIMENTI SE {{number}}',
  [T.wfElseRowTitle]: 'ALTRIMENTI',
  [T.wfElseSummary]: 'Altrimenti',
  [T.wfErrorPathBadge]: 'Percorso di errore',
  [T.wfDetailsRequiredFor]: 'Dettagli richiesti per {{title}}',
  [T.wfAddIfElse]: 'Aggiungi SE/ALTRIMENTI',
  [T.wfIntegration]: 'Integrazione',
  [T.wfSelectApplication]: "Seleziona un'applicazione.",
  [T.wfApplicationConnected]: 'Applicazione connessa',
  [T.wfApplication]: 'Applicazione',
  [T.wfAction]: 'Azione',
  [T.wfConnectedAs]: 'Connesso: {{email}}',
  [T.wfDisconnect]: 'Disconnetti',
  [T.wfDisconnectConfirmDescription]:
    'La disconnessione di questa applicazione rimuoverà il suo trigger dal workflow',
  [T.wfYesDisconnect]: 'Sì, disconnetti',
  [T.wfRemoveAll]: 'Rimuovi tutto',
  [T.wfRemoveTrigger]: 'Rimuovi trigger',
  [T.wfYesRemoveTrigger]: 'Sì, rimuovi trigger',
  [T.wfRemoveTriggerConfirmDescription]:
    "La rimozione di questo trigger disconnetterà l'applicazione da questo workflow",
  [T.wfCopyFailed]: 'Copia negli appunti non riuscita',
  [T.wfSaveWorkflowBeforeCopy]:
    'Salva il workflow prima di copiare l’URL del modulo.',
  [T.wfDeployBeforeCopyUrl]:
    'Devi distribuire il workflow per abilitare «Copia URL».',
  [T.wfAddBlockToRun]: 'Aggiungi un blocco per eseguire',
  [T.wfConnectOutlookFailed]: 'Connessione a Outlook non riuscita',
  [T.wfConnectAccountFirst]: 'Collega prima un account da Connettori.',
  [T.wfTriggerTypeNotSupported]: 'Questo tipo di trigger non è supportato.',
  [T.wfTeamsChannelIdsRequired]:
    'ID team e ID canale sono obbligatori per un trigger di canale Teams.',
  [T.wfTeamsTeamIdIsConversationId]:
    "L'ID team è un ID conversazione. Inserisci l'ID gruppo (GUID) del team o incolla il link del canale da Teams.",
  [T.wfTeamsInvalidTeamId]:
    "L'ID team non è valido. Inserisci l'ID gruppo (GUID) del team o incolla il link del canale da Teams.",
  [T.wfTeamsInvalidChannelId]:
    "L'ID canale non è valido. Inserisci un ID come 19:…@thread.tacv2 o incolla il link del canale da Teams.",
  [T.wfTeamsChatIdRequired]:
    "L'ID chat è obbligatorio per un trigger di chat Teams.",
  [T.wfTeamsInvalidChatId]:
    "L'ID chat non è valido. Inserisci un ID come 19:…@thread.v2.",
  [T.wfTeamsChannelNotFound]:
    'Canale Teams non trovato. Controlla ID team e ID canale.',
  [T.wfTeamsChannelAccessDenied]:
    "L'account Microsoft collegato non ha accesso a questo canale Teams.",
  [T.wfTeamsChatNotFound]: "Chat Teams non trovata. Controlla l'ID chat.",
  [T.wfTeamsChatAccessDenied]:
    "L'account Microsoft collegato non ha accesso a questa chat Teams.",
  [T.wfConnectApplication]: "Collega l'applicazione.",
  [T.wfIntegrationConnectFailed]:
    'Connessione del trigger di integrazione non riuscita per il provider "{{provider}}", trigger "{{trigger}}"',
  [T.wfWebhookRegenerateFailed]:
    'Impossibile rigenerare le credenziali del webhook',
  [T.wfWebhookAuthUpdateFailed]:
    'Impossibile aggiornare il metodo di autenticazione',
  [T.wfMaxFilesPerRun]: 'Puoi caricare al massimo {{max}} file per esecuzione.',
  [T.wfFileExceedsLimit]:
    '"{{name}}" supera il limite di {{maxMb}} MB per file.',
  [T.wfUploadLimitsCaption]:
    'Fino a {{maxFiles}} file. I limiti di dimensione variano in base al tipo di file.',
  [T.deleteDisabledDuringUpload]:
    'Impossibile eliminare mentre i file sono in caricamento in questa cartella',

  // Skills
  //skills
  [T.skills]: 'Competenze',
  [T.skillsToolDescription]: 'Chiama una delle tue competenze e chatta',
  [T.skillHeaderDescription]:
    'Amplia le tue possibilità grazie alle funzionalità riutilizzabili offerte dalle competenze di EmpowerGPT.',
  [T.manageSkills]: 'Gestisci le competenze',
  [T.loadMore]: 'Carica altri',
  [T.noSkillsCreatedYet]: 'Non hai ancora creato nessuna skill',
  [T.noSkillsFound]: 'Nessuna skill trovata',
  [T.noSharedSkillsTitle]: 'Nessuna skill condivisa',
  [T.noSharedSkillsDescription]:
    'Le skill condivise con te da altri utenti appariranno qui.',
  [T.noDefaultSkillsTitle]: 'Nessuna skill predefinita disponibile',
  [T.noDefaultSkillsDescription]:
    'Le skill di sistema appariranno qui quando saranno disponibili.',
  [T.install]: 'Installa',
  [T.createSkill]: 'Crea skill',
  [T.createWithChat]: 'Crea con la chat',
  [T.createWithChatDescription]: 'Crea una skill con Empower GPT',
  [T.writeSkillInstructions]: 'Scrivi le istruzioni della skill',
  [T.writeSkillInstructionsDescription]: 'Personalizzato e semplice',
  [T.uploadSkill]: 'Carica una skill',
  [T.uploadSkillMenuDescription]: 'Carica file .zip o .md',
  [T.writeSkillInstructionsModalDescription]:
    'Scrivi la descrizione e le istruzioni della skill per ottenere i migliori risultati.',
  [T.skillName]: 'Nome della skill',
  [T.skillNamePlaceholder]: 'ui-ux-assurance',
  [T.skillDescriptionPlaceholder]:
    "Crea una breve descrizione per una skill come 'UI-UX Assurance' che aiuti a condurre audit UX dal design allo sviluppo...",
  [T.charactersCount]: '{{current}} / {{max}} caratteri',
  [T.skillActions]: 'Azioni skill',
  [T.uploadSkillTitle]: 'Carica skill',
  [T.uploadSkillModalDescription]:
    'Carica un file SKILL.md o importa un archivio .zip/.skill. Assicurati che SKILL.md contenga un frontmatter YAML con nome e descrizione.',
  [T.dragAndDropToUpload]: 'Trascina e rilascia o fai clic per caricare',
  [T.uploadSkillDropzoneHint]:
    'Puoi caricare un singolo file SKILL.md o un archivio .zip/.skill.',
  [T.skillZipStructureTitle]: 'Struttura dello zip',
  [T.skillZipStructureDescription]:
    'Segui il formato Agent Skills: un singolo SKILL.md in cima e cartelle opzionali. Metti i file direttamente in una cartella (niente sottocartelle). Solo file di testo, come .md, .py, .json o .yaml.',
  [T.skillZipStructureSkillMd]: 'Obbligatorio: nome, descrizione e istruzioni',
  [T.skillZipStructureScripts]: "Opzionale: codice che l'agente può eseguire, es. .py",
  [T.skillZipStructureReferences]: 'Opzionale: documentazione',
  [T.skillZipStructureAssets]: 'Opzionale: modelli e altre risorse',
  [T.skillZipStructureLearnMore]: 'Scopri di più su Agent Skills',
  [T.uploadingSkill]: 'Caricamento skill in corso',
  [T.uploadingSkillDescription]:
    'La tua skill è in fase di caricamento. Ci vorrà solo un momento.',
  [T.skillDescription]: 'Descrizione della skill',
  [T.noDescriptionProvided]: 'Nessuna descrizione fornita.',
  [T.moreOptions]: 'Altre opzioni',
  [T.rawView]: 'Non elaborato',
  [T.unsupportedSkillFile]:
    'Tipo di file non supportato. Carica un file SKILL.md o un archivio .zip/.skill.',
  [T.skillArchiveEmpty]:
    "L'archivio è vuoto. Aggiungi un file SKILL.md e riprova.",
  [T.skillArchiveOnlyMd]:
    "Metti SKILL.md in cima e gli altri file direttamente in cartelle come scripts/ o references/. Sposta o rimuovi: {{files}}",
  [T.skillArchiveReadError]:
    "Impossibile leggere l'archivio. Carica un file .zip/.skill valido.",
  [T.you]: 'Tu',
  [T.enterMdFormat]: 'Inserisci in formato md',
  [T.skillCreatedSuccessfully]: 'Skill creato con successo.',
  [T.skillCreateFailed]: 'Creazione dello skill non riuscita. Riprova.',
  [T.deleteTheSkill]: 'Elimina lo skill',
  [T.deleteSkillConfirmation]: 'Sei sicuro di voler eliminare lo skill?',
  [T.yesDeleteIt]: 'Sì, eliminalo',
  [T.skillDeletedSuccessfully]: 'Skill eliminato con successo.',
  [T.skillDeleteFailed]: 'Eliminazione dello skill non riuscita. Riprova.',
  [T.skillFetchFailed]:
    'Caricamento dei dettagli dello skill non riuscito. Riprova.',
  [T.editSkillInstructions]: 'Modifica le istruzioni dello skill',
  [T.skillUpdatedSuccessfully]: 'Skill aggiornato con successo.',
  [T.skillUpdateFailed]: 'Aggiornamento dello skill non riuscito. Riprova.',
  [T.skillEnabledSuccessfully]: 'Skill abilitato con successo.',
  [T.skillDisabledSuccessfully]: 'Skill disabilitato con successo.',
  [T.skillInstalledSuccessfully]: 'Skill installata con successo.',
  [T.skillInstallFailed]: 'Installazione della skill non riuscita. Riprova.',
  [T.skillDisabledByOwnerError]:
    'Questa skill è stata disabilitata dal proprietario e non può essere installata.',
  [T.skillNotInstalledByOwnerError]:
    'Questa skill non è ancora stata installata dal proprietario. Chiedi al proprietario di installarla prima.',
  [T.skillUninstalledSuccessfully]: 'Skill disinstallata con successo.',
  [T.skillUninstallFailed]:
    'Disinstallazione della skill non riuscita. Riprova.',
  [T.uninstall]: 'Disinstalla',
  [T.installed]: 'Installata',
  [T.uninstalled]: 'Disinstallata',
  [T.copyFailed]: 'Copia negli appunti non riuscita',
  [T.filterBy]: 'Filtra per',
  [T.skillNameFormatError]:
    'Il nome della skill può contenere solo lettere minuscole (a–z), numeri (0–9) e trattini (-).',
  [T.skillNameStartEndHyphenError]:
    'Il nome della skill non deve iniziare o terminare con un trattino.',
  [T.skillNameConsecutiveHyphensError]:
    'Il nome della skill non deve contenere trattini consecutivi (--).',
  [T.skillNameAlreadyExistsError]: 'Esiste già unabilità con questo nome.',
  [T.skillNameExistsAsDeprecatedError]:
    'Esiste già una skill eliminata con questo nome. Scegli un nome diverso.',
  [T.skillZipRequired]:
    'Per creare una skill è necessario un file zip contenente SKILL.md.',
  [T.skillZipValidationError]:
    'La convalida del pacchetto di competenze non è andata a buon fine. Controlla il formato del file SKILL.md (nome, descrizione e corpo del testo in Markdown valido) e riprova.',
  [T.skillPublicationError]:
    'Aggiornamento dello stato della skill in DocLM non riuscito. Riprova.',
  [T.skillPublicationJudgeFailedError]:
    'La pubblicazione della skill è stata rifiutata dal processo di revisione. Rivedi le istruzioni della skill e riprova.',
  [T.skillNotRegisteredInDocLMError]:
    'Questa skill non è registrata in DocLM e non può essere abilitata o disabilitata.',
  [T.skillZipMissingSkillFileError]:
    "Nessun file SKILL.md trovato nell'archivio caricato. Inserisci SKILL.md nella radice del file zip oppure in una cartella il cui nome corrisponda al nome della skill.",
  [T.skillZipMultipleSkillsError]:
    "L'archivio contiene più skill. Ogni skill deve essere caricata come file zip separato — comprimi ogni cartella skill singolarmente.",
  [T.skillZipUnsafeError]:
    'Il file zip caricato non ha superato i controlli di sicurezza e non può essere elaborato. Assicurati che sia un archivio zip semplice, privo di link simbolici o voci cifrate.',
  [T.skillZipInvalidPackageError]:
    'Il pacchetto della skill non è valido. Verifica che SKILL.md contenga un blocco frontmatter valido con un campo name in minuscolo (solo lettere, cifre e trattini) e una descrizione, seguito da un corpo Markdown non vuoto.',
  [T.skillInstructionsFrontmatterError]:
    'Le istruzioni non devono includere il frontmatter YAML (---). Utilizza invece i campi “Nome” e “Descrizione” riportati sopra.',
  [T.skillSharedSuccessfully]: 'Abilità condivisa con successo.',
  [T.skillShareFailed]: 'Impossibile condividere labilità. Riprova.',
  [T.skillDownloadFailed]: 'Download della skill non riuscito. Riprova.',
  [T.skillDownloadedSuccessfully]: 'Labilità è stata scaricata con successo.',
  [T.replaceSkillTitle]: 'Sostituire la skill "{{name}}"?',
  [T.replaceSkillConfirmation]:
    'Esiste già una skill con lo stesso nome. Caricando questa skill, quella esistente verrà sostituita e non potrà essere ripristinata.',
  [T.uploadAndReplace]: 'Carica e sostituisci',
  [T.removePremissionsSuccess]:
    '{{username}} è stato rimosso correttamente dalle autorizzazioni della skill.',
  [T.removePremissionsFailed]:
    'Impossibile rimuovere l’utente {{username}} dalle autorizzazioni della skill.',
  [T.wfLogUpdateNameFailed]: 'updateWorkflowName non riuscito:',
  [T.wfLogToggleActiveFailed]: 'handleToggleWorkflowActive non riuscito:',
  [T.wfLogRenameFailed]: 'renameWorkflow non riuscito:',
  [T.wfLogDeleteFailed]: 'deleteWorkflow non riuscito:',
  [T.wfLogDuplicateFailed]: 'duplicateWorkflow non riuscito:',
  [T.wfLogCreateFailed]: 'createWorkflow non riuscito:',
  [T.wfLogSaveFailed]: 'saveWorkflow non riuscito:',
  [T.wfLogWebhookRegenerateFailed]: 'rigenerazione webhook non riuscita:',
  [T.wfLogWebhookAuthUpdateFailed]:
    'aggiornamento autenticazione webhook non riuscito:',
  [T.wfLogWebhookAuthTaskFailed]:
    'attività di aggiornamento autenticazione webhook non riuscita:',
  [T.wfLogKnowledgeUploadFailed]: 'caricamento conoscenza non riuscito:',
  [T.wfLogRunFailed]: 'runWorkflow non riuscito:',
  [T.wfLogRunUploadFailed]: 'caricamento file di esecuzione non riuscito:',
  [T.wfLogGraphParseFailed]: 'parseGraphField: JSON del grafo non valido',
  [T.wfLogHydrationFailed]: 'idratazione del workflow non riuscita:',
  [T.wfMcpConnected]: '{{name}} collegato correttamente',
  [T.wfMcpConnectFailed]:
    'Impossibile collegare {{name}}. La connessione non è stata completata: riprova.',
  [T.wfMcpDisconnected]:
    '{{name}} è stato scollegato. I suoi strumenti restano nel workflow ma non verranno eseguiti fino al nuovo collegamento.',
  [T.wfLogMcpConnectStarted]: 'connessione MCP avviata:',
  [T.wfLogMcpConnected]: 'connettore MCP collegato:',
  [T.wfLogMcpConnectFailed]: 'connessione MCP non completata:',
  [T.wfLogMcpVerifyFailed]: 'verifica della connessione MCP non riuscita:',
  [T.wfLogMcpDisconnected]: 'categoria MCP scollegata:',
  [T.wfLogDownloadFallback]:
    'download blob non riuscito; ripiego su window.open',
  [T.wfAiActionAriaLabel]: 'IA',
  [T.wfMoreActionsAriaLabel]: 'Altro',
  [T.wfSkippedStatus]: 'Ignorato',
  [T.wfCollapseAriaLabel]: 'Comprimi',
  [T.wfOperatorContains]: 'contiene',
  [T.wfMaxIterationsShort]: 'max',
  [T.wfWorkflowActionsAriaLabel]: 'Azioni workflow',
  [T.wfShareWorkflowAriaLabel]: 'Condividi workflow',
  [T.wfFavoriteWorkflowAriaLabel]: 'Aggiungi workflow ai preferiti',
  [T.wfFieldTypeString]: 'Stringa',
  [T.wfFieldTypeBoolean]: 'Booleano',
  [T.wfFieldTypeObject]: 'Oggetto',
  [T.wfFieldTypeArray]: 'Array',
  [T.wfEditField]: 'Modifica campo',
  [T.wfAcceptedFileTypes]: 'Tipi di file accettati',
  [T.wfEnterNamePlaceholder]: 'Inserisci nome',
  [T.wfNewEmailAction]: 'Nuova email corrispondente alla ricerca',
  [T.wfSearchQuery]: 'Query di ricerca',
  [T.wfSearchQueryPlaceholder]: 'Scrivi la query di ricerca',
  [T.wfSearchQueryTooltip]:
    "Query di ricerca Outlook a cui l'email deve corrispondere. Esempi",
  [T.wfSearchQueryTooltipExample]: 'from:johndoe@example.com',
  [T.wfSearchQueryTooltipDetails]:
    ', subject:invoice, body:"due date", NOT from:noreply. Combina i filtri con AND, OR, NOT e parentesi. Operatori supportati: from:, to:, cc:, bcc:, subject:, body:, participants:, recipients:. Maggiori informazioni qui:',
  [T.wfGmailSearchQueryTooltip]:
    "Query di ricerca Gmail a cui l'email deve corrispondere. Esempi",
  [T.wfGmailSearchQueryTooltipExample]: 'from:johndoe@example.com',
  [T.wfGmailSearchQueryTooltipDetails]:
    ', subject:invoice, {from:amy from:david}, -from:noreply. Combina i filtri con AND, OR, - (escludi) e parentesi. Operatori supportati: from:, to:, cc:, bcc:, subject:. Maggiori informazioni qui:',
  [T.wfTeamsNewChannelMessage]: 'Nuovo messaggio nel canale',
  [T.wfTeamsNewChatMessage]: 'Nuovo messaggio in chat',
  [T.wfTeamsNewMeetingTranscript]: 'Nuova trascrizione della riunione',
  [T.wfTeamsChannelId]: 'ID canale',
  [T.wfTeamsChatId]: 'ID chat',
  [T.wfTeamsChannelIdTooltipDetails]:
    "Per trovare l'ID canale, apri il canale desiderato in Microsoft Teams e copia il link del canale. L'ID canale è la parte dell'URL tra channel e la barra successiva. Copia questo valore e incollalo nel campo.",
  [T.wfTeamsChatIdTooltipDetails]:
    "Per trovare l'ID chat, apri la chat desiderata in Microsoft Teams e copia il link della chat. L'ID chat è la parte dell'URL tra chat e conversations. Copia questo valore e incollalo nel campo.",
  [T.wfTeamsTeamId]: 'ID team',
  [T.wfTeamsFilterKeyword]: 'Parola chiave di filtro',
  [T.wfNoFilesAttachedYet]: 'Nessun file allegato finora.',
  [T.wfToggleAriaLabel]: 'Attiva/disattiva',
  [T.wfFormTriggerLabel]: 'Trigger modulo',
  [T.wfUploadDocumentLabel]: 'Carica documento',
  [T.wfSaveBeforeRunning]: 'Salva il workflow prima di eseguirlo.',
  [T.wfNoInputProvided]:
    'Non è stato fornito alcun input. Compila i campi del modulo o carica dei file, quindi riprova.',
  [T.wfRunWorkflowFailedGeneric]: 'Esecuzione del workflow non riuscita',
  [T.wfRunScheduledWorkflowNoInput]:
    'Questo workflow viene eseguito in base a una pianificazione e non richiede input. Eseguilo ora per testarlo.',
  [T.wfUnknownTime]: 'Ora sconosciuta',
  [T.wfPendingStatus]: 'In attesa',
  [T.wfSuccessStatus]: 'Riuscito',
  [T.wfWorkflowSavedSuccessfully]: 'Workflow salvato con successo',
  [T.wfWorkflowDeployedSuccessfully]: 'Workflow distribuito con successo',
  [T.wfNotAvailable]: 'N/A',
  [T.wfNoDescriptionAvailable]: 'Nessuna descrizione disponibile.',
  [T.wfPromptFieldLabel]: 'Prompt',
  [T.wfStructuredOutputFieldLabel]: 'Campo di output strutturato',
  [T.wfBranchConditionsLabel]: 'Condizioni del ramo',
  [T.wfConnectedApplicationLabel]: 'Applicazione connessa',
  [T.wfFormFieldLabel]: 'Campo del modulo',
  [T.wfChangeCount]: '{{count}} modifica/he',
  [T.wfViewingRunNumber]: 'Visualizzazione esecuzione #{{number}}',
  [T.disableSSOConfirmTitle]: 'Disabilitare il Single Sign-On (SSO)?',
  [T.disableSSOConfirmDescription]:
    "Gli utenti che hanno effettuato l'accesso tramite Active Directory o SSO verranno disconnessi e non potranno accedere nuovamente fino alla riattivazione di SSO.",
  [T.disableSSOConfirmButton]: 'Disabilita SSO',

  // Upload Sessions
  [T.sessionHistory]: 'Cronologia sessioni',
  [T.pinned]: 'In evidenza',
  [T.completed]: 'Completata',
  [T.paused]: 'In pausa',
  [T.pinThisSession]: 'Fissa questa sessione',
  [T.unpinSession]: 'Rimuovi la sessione dai preferiti',
  [T.retryFailedItems]: 'Riprova gli elementi non riusciti',
  [T.cancelSession]: 'Annulla sessione',
  [T.deleteThisSession]: 'Eliminare questa sessione?',
  [T.deleteConfirmationMessage]:
    'Questa azione eliminerà definitivamente la sessione. Non può essere annullata.',
  [T.others]: 'Altro',
  [T.xOfYFiles]: '{{uploaded}}/{{total}} file',
  [T.xPercentYOfZFilesUploaded]:
    '{{percent}}% - {{uploaded}} di {{total}} file caricati',
  [T.noTimeEstimation]: '~ Nessuna stima del tempo',
  [T.viewInFolder]: 'Visualizza nella cartella',
  [T.noSession]: 'Non hai alcuna sessione!',
  [T.noSessionDescription]:
    'Carica cartelle o file in qualsiasi workspace. La tua sessione verrà salvata temporaneamente qui e potrai anche salvarla in modo permanente.',
  [T.noActiveSession]: 'Non hai alcuna sessione attiva!',
  [T.noActiveSessionDescription]:
    'La tua sessione in corso verrà mostrata qui e in cima all’elenco di tutte le sessioni.',
  [T.noPinnedSession]: 'Non hai alcuna sessione fissata!',
  [T.noPinnedSessionDescription]:
    'Le sessioni fissate vengono visualizzate qui e rimangono in cima all’elenco. Fissa una sessione dalla scheda "Tutte" per averla sempre a portata di mano.',
  [T.noCompletedSession]: 'Non hai alcuna sessione completata!',
  [T.noCompletedSessionDescription]:
    'Le sessioni completate verranno visualizzate qui.',
  [T.noFailedOrPausedSession]:
    'Non hai alcuna sessione non riuscita o in pausa!',
  [T.noFailedOrPausedSessionDescription]:
    'Le sessioni non riuscite e quelle in pausa verranno visualizzate qui.',
  [T.backToAllSessions]: 'Torna a tutte le sessioni',
  [T.backToWorkspaces]: 'Torna ai workspace',
  [T.sessionsInProgress]: '{{count}} Sessioni in corso',
  [T.etaSeconds]: '{{count}}s rimanenti',
  [T.etaMinutes]: '{{count}} min rimanenti',
  [T.etaHours]: '{{count}}h rimanenti',
  [T.etaHoursMinutes]: '{{hours}}h {{minutes}}m rimanenti',
  [T.lockedFolderTitle]:
    'Non puoi modificare, spostare o eliminare "{{folderName}}"',
  [T.lockedFolderDescription]:
    '{{userName}} sta caricando file in questa cartella nella sessione "{{sessionName}}". Attendi il completamento del caricamento o visualizza la sessione per i dettagli.',
  [T.lockedFolderDescriptionGeneric]:
    'Qualcuno sta caricando file in questa cartella. Attendi il completamento del caricamento o visualizza la sessione per i dettagli.',
  [T.lockedTooltipGeneric]:
    'Questa cartella è bloccata perché qualcuno la sta caricando in questo spazio di lavoro.',
  [T.loadingSession]: 'Caricamento sessione...',
  [T.sessionNotFound]: 'Sessione non trovata',
  [T.loadingFiles]: 'Caricamento file...',
  [T.noFilesInSession]: 'Nessun file in questa sessione',
  [T.filesCount]: 'File ({{count}})',
  [T.columnName]: 'Nome',
  [T.columnSize]: 'Dimensione',
  [T.columnStatus]: 'Stato',
  [T.columnFormat]: 'Formato',
  [T.fileStatusWaiting]: 'In attesa',
  [T.fileStatusUploading]: 'Caricamento',
  [T.fileStatusUploaded]: 'Caricato',
  [T.fileStatusFailed]: 'Fallito',
  [T.fileStatusMissing]: 'Mancante',
  [T.fileStatusCancelled]: 'Annullato',
  [T.uploadDetail]: 'Dettaglio caricamento',
  [T.syncingFilesTo]: 'Sincronizzazione file su {{path}}',
  [T.totalFiles]: 'File totali',
  [T.existingFiles]: 'File esistenti',
  [T.newFiles]: 'Nuovi file',
  [T.downloadFilesDetail]: 'Dettagli sui file da scaricare',
  [T.csvFileName]: 'Nome file',
  [T.csvFullPath]: 'Percorso completo',
  [T.csvSizeBytes]: 'Dimensione (byte)',
  [T.csvLocalModified]: 'Modificato localmente',
  [T.csvServerModified]: 'Modificato sul server',
  [T.csvStatus]: 'Stato',
  [T.csvType]: 'Tipo',
  [T.csvTypeFile]: 'File',
  [T.csvTypeFolder]: 'Cartella',
  [T.filesAlreadyExist]:
    '{{count}} file esistono già in questa posizione. Vuoi sostituire i file esistenti con quelli nuovi o saltarli?',
  [T.replaceExistingFiles]: 'Sostituisci i file esistenti',
  [T.filesBeingUploadedConflict]:
    '{{count}} file sono in fase di caricamento in questa posizione da {{owner}}. Non puoi caricare adesso!',
  [T.sameFilesUploadingTitle]:
    "Gli stessi file sono in fase di caricamento in un'altra sessione.",
  [T.sameFilesUploadingDescription]:
    "Attendi che i file più recenti terminino l'elaborazione prima di avviare una nuova sessione di caricamento.",
  [T.syncFolderToServer]: 'Sincronizza cartella con il server',
  [T.syncDescription]:
    "I nuovi file nella cartella locale verranno caricati sul server. I file esistenti sul server non verranno modificati, che tu li abbia modificati o meno. Questa è l'impostazione predefinita.",
  [T.openAdvancedOptions]: 'Apri opzioni avanzate',
  [T.thisSyncWill]: 'Questa sincronizzazione',
  [T.addNewFilesOnly]: 'Aggiungi solo nuovi file',
  [T.addAndUpdate]: 'Aggiungi e aggiorna',
  [T.mirror]: 'Specchia',
  [T.deleteAndAdd]: 'Elimina e aggiungi',
  [T.alreadyIdentical]: 'Già identici',
  [T.newWillUpload]: 'Nuovi - verranno caricati',
  [T.editedWillSkip]: 'Modificati - verranno saltati',
  [T.editedWillReplace]: 'Modificati - verranno sostituiti',
  [T.onlyOnServerKept]: 'Solo sul server - mantenuti',
  [T.onlyOnServerDelete]: 'Solo sul server - eliminati',
  [T.advancedOptions]: 'Opzioni avanzate',
  [T.mirrorLocalFolderExactly]: 'specchia esattamente la cartella locale',
  [T.advancedOptionsDescription]:
    'Queste opzioni modificano i file già presenti sul server. Entrambe sono disattivate per impostazione predefinita.',
  [T.replaceEditedFilesOnServer]: 'Sostituisci i file modificati sul server',
  [T.replaceEditedFilesDescription]:
    '{{count}} file. La copia sul server viene sovrascritta con la tua versione locale.',
  [T.deleteServerFilesMissingLocally]:
    'Elimina i file del server mancanti localmente',
  [T.deleteServerFilesDescription]:
    '{{count}} file. Attiva entrambe le opzioni per specchiare esattamente la cartella locale.',
  [T.filesWillBeRemoved]:
    '{{count}} file verranno rimossi permanentemente dal server. Ti verrà chiesto di confermare nel passaggio successivo.',
  [T.uploadXFiles]: 'Carica {{count}} file',
  [T.syncXFiles]: 'Sincronizza {{count}} file',
  [T.mirrorXFiles]: 'Specchia {{count}} file',
  [T.exportFileList]: 'Esporta elenco file',
  [T.deleteFilesFromServer]: 'Eliminare {{count}} file dal server?',
  [T.deleteFilesFromServerDescription]:
    'Lo specchiamento rimuoverà questi file perché non esistono più nella cartella locale. Non possono essere recuperati dal server in seguito.',
  [T.yesDeleteFiles]: 'Sì, elimina i file',
  [T.noKeepFiles]: 'No, mantieni i file',
  [T.startedOn]: 'Iniziato il',
  [T.expiredOn]: 'Scaduto il',
  [T.trialUsage]: 'Utilizzo di prova',
  [T.trialUsageTooltip]:
    'Crediti utilizzati rispetto ai crediti totali inclusi nel periodo di prova.',
  [T.chatStopGenerating]: 'Interrompi generazione',
  [T.chatStopping]: 'Interruzione della risposta',
  [T.chatResponseTerminated]: 'Questa risposta è stata interrotta dall’utente.',
  [T.chatBranchedFrom]: 'Derivato da',
  [T.chatBranchedFromFallback]: 'una chat precedente',
  [T.yesterday]: 'Ieri',
  [T.projectChatViewerReadOnly]:
    'Questa chat è di sola lettura: hai accesso in visualizzazione a questo progetto.',
  [T.regeneratingResponse]: 'Rigenerazione della risposta',
  [T.fileDeletedOrInaccessibleLabel]: 'Non accessibile',
  [T.noAnalysisFound]: 'Nessuna analisi trovata',
  [T.questionnaireUpdatedSuccess]: 'Questionario aggiornato con successo.',
  [T.wfSettingsDescription]:
    'Personalizza i workflow per la tua organizzazione',
  [T.wfSettingsPlan]: 'Piano',
  [T.wfSettingsResetsOn]: 'Reimpostazione il {{date}}',
  [T.wfSettingsRuns]: 'Esecuzioni: {{used}} / {{total}}',
  [T.wfSettingsLimits]: 'Limiti',
  [T.wfSettingsUsageCap]: 'Limite di utilizzo',
  [T.wfSettingsUsageCapDescription]:
    'Utilizzo massimo di crediti AI consentito su tutti i workflow.',
  [T.wfSettingsSetCap]: 'Imposta limite',
  [T.wfSelectedFiles]: 'File selezionati',
  [T.wfFormSubmitting]: 'Invio in corso',
  [T.wfFormSubmitFailed]: 'Invio del modulo non riuscito.',
  [T.wfFormSubmitted]: 'Modulo inviato!',
  [T.wfFormSubmittedDescription]:
    'Modulo inviato! La tua risposta è stata registrata.',
  [T.professionalPlanHeadline]: 'Cloud enterprise gestito',
  [T.professionalPlanSubheading]: 'IA enterprise senza infrastruttura dedicata',
  [T.professionalPlanDescription]:
    'Distribuisci l’IA rapidamente tra reparti e unità di business con una piattaforma enterprise completamente gestita.',
  [T.professionalPlanFootnote]:
    'Include 5 € di crediti IA enterprise • Nessuna carta di credito richiesta',
  [T.professionalPlanCta]: 'Passa',
  [T.professionalFeature1]: 'Abbonamento mensile o annuale flessibile',
  [T.professionalFeature2]: '15 € di crediti IA inclusi per utente',
  [T.professionalFeature3]:
    'Prosegui senza interruzioni con tariffe Pay As You Go trasparenti',
  [T.professionalFeature4]: 'Pool condiviso di crediti IA enterprise',
  [T.professionalFeature5]: 'Customer Success incluso',
  [T.professionalFeature6]:
    'Un’unica piattaforma. Tutte le funzionalità incluse.',
  [T.enterprisePlanHeadline]: 'Distribuzione enterprise dedicata',
  [T.enterprisePlanSubheading]:
    'IA enterprise progettata attorno alla tua organizzazione',
  [T.enterprisePlanDescription]:
    'Distribuisci EmpowerGPT nell’ambiente, nel modello operativo e nella scala più adatti alla tua azienda.',
  [T.enterprisePlanFootnote]:
    'Su misura per le tue esigenze di distribuzione e di business',
  [T.enterprisePlanCta]: 'Parla con le vendite',
  [T.enterpriseFeature1]: 'Distribuzione public, dedicata, ibrida o on-premise',
  [T.enterpriseFeature2]: 'Pianificazione della capacità enterprise',
  [T.enterpriseFeature3]: 'Customer Success dedicato',
  [T.enterpriseFeature4]: 'Integrazioni personalizzate e supporto enterprise',
  [T.enterpriseFeature5]: 'Accordo enterprise annuale',
  [T.perUserPerMonthExclVat]: '/per utente / mese (IVA escl.)',
  [T.workflowAddOnTitle]: 'Workflow',
  [T.workflowAddOnBadge]: 'Add-on',
  [T.workflowAddOnBasic]: 'Base',
  [T.workflowAddOnAdvanced]: 'Avanzato',
  [T.workflowAddOnIncludedInProfessional]: 'Incluso in Professional',
  [T.workflowAddOnPerMonth]: '/mese',
  [T.workflowAddOnPerYear]: '/anno',
  [T.workflowAddOnProfessionalRuns]: '6.000 esecuzioni di Workflow al mese',
  [T.workflowAddOnEnterpriseRuns]: '50.000 esecuzioni di Workflow al mese',
  [T.workflowAddOnFeatureUsers]: 'Utenti illimitati',
  [T.workflowAddOnFeatureBlocks]: 'Blocchi illimitati per Workflow',
  [T.workflowAddOnFeatureHistory]:
    'Tutte le funzionalità Workflow incluse, come le esecuzioni storiche',
  [T.workflowAddOnFeaturePayg]:
    'I crediti vengono addebitati con il modello Pay-as-you-go',
  [T.workflowAddOnCta]: 'Inizia ora',
  [T.addOnCancel]: 'Annulla abbonamento',
  [T.addOnReactivate]: 'Riattiva',
  [T.addOnPurchaseConfirmTitle]: 'Acquistare l’add-on Workflow?',
  [T.addOnPurchaseConfirmDescription]:
    'La carta salvata verrà addebitata subito dell’importo proporzionale.',
  [T.addOnCancelConfirmTitle]: 'Annullare l’add-on Workflow?',
  [T.addOnCancelConfirmDescription]:
    'L’add-on resta attivo fino alla fine del periodo di fatturazione corrente e non verrà più addebitato.',
  [T.addOnPurchaseSuccess]: 'Add-on Workflow attivato',
  [T.addOnReactivateSuccess]: 'Add-on Workflow riattivato',
  [T.addOnCancelSuccess]:
    'L’add-on Workflow verrà annullato alla fine del periodo corrente',
  [T.addOnNotEligibleError]:
    'Gli add-on richiedono un piano Essential o Professional attivo',
  [T.addOnAlreadyActiveError]: 'Questo add-on è già attivo',
  [T.addOnNotFoundError]: 'Nessun add-on attivo da annullare',
  [T.addOnPurchaseError]: 'Impossibile acquistare l’add-on. Riprova.',
  [T.addOnCancelError]: 'Impossibile annullare l’add-on. Riprova.',
  // ── ChatV2 ────────────────────────────────────────────────────────────────
  [T.assistantNotFound]: 'Assistente non trovato',
  [T.noPermissionToEditAssistant]:
    'Non hai il permesso di modificare questo assistente',
  [T.projectNotFound]: 'Progetto non trovato',
  [T.attachmentsNotAvailableInPreview]:
    "Gli allegati non sono disponibili nell'anteprima",
  [T.sendMessage]: 'Invia messaggio',
  [T.addToThisMessage]: 'Aggiungi a questo messaggio',
  [T.skills]: 'Competenze',
  [T.startVoiceInput]: 'Avvia input vocale',
  [T.voiceInputUnavailable]: 'Input vocale non disponibile',
  [T.stopVoiceInput]: 'Interrompi input vocale',
  [T.world]: 'Mondo',
  [T.featureComingSoon]: '{{feature}} saranno presto disponibili',
  [T.removeItem]: 'Rimuovi {{name}}',
  [T.shareChat]: 'Condividi chat',
  [T.continueWithThisModel]: 'Continua con questo modello',
  [T.resizeChatAndDocumentPanes]:
    'Ridimensiona i riquadri della chat e del documento',
  [T.jumpToLatestMessage]: "Vai all'ultimo messaggio",
  [T.conversationMessages]: 'Messaggi della conversazione',
  [T.sharedConversationMessages]: 'Messaggi della conversazione condivisa',
  [T.shareProject]: 'Condividi progetto',
  [T.startNewChatInThisProject]: 'Avvia una nuova chat in questo progetto',
  [T.shareProjectDescription]:
    'Chiunque venga aggiunto avrà accesso a questo progetto e a tutte le sue chat, inclusa questa.',
  [T.mcpOAuthOwnerManaged]:
    "Questa connessione è gestita dal proprietario dell'assistente. Chiedigli di connetterla prima di eseguire questa azione.",
  [T.confirmActionHeading]: 'Vuoi confermare questa azione?',
  [T.connectAccountHeading]: 'Connetti il tuo account per continuare',
  [T.connectAccountDescription]:
    "Questa azione richiede l'accesso al tuo account. Connettilo e l'agente proseguirà da qui.",
  [T.editMessage]: 'Modifica messaggio',
  [T.otherEllipsis]: 'Altro...',
  [T.addSpecificDetailsHere]: 'Aggiungi qui dettagli specifici',
  [T.likedResponse]: 'Risposta valutata positivamente',
  [T.dislikedResponse]: 'Risposta valutata negativamente',
  [T.likeResponse]: 'Valuta positivamente la risposta',
  [T.dislikeResponse]: 'Valuta negativamente la risposta',
  [T.stopReading]: 'Interrompi la lettura',
  [T.readAloud]: 'Leggi ad alta voce',
  [T.feedbackReportDisclaimer]:
    'Inviando questa segnalazione, la conversazione corrente verrà trasmessa a Empower GPT per migliorare i nostri modelli in futuro.',
  [T.minimizeImage]: 'Riduci a icona',
  [T.toggleSidebar]: 'Mostra/nascondi barra laterale',
  [T.rotateClockwise]: 'Ruota in senso orario',
  [T.fitToWidth]: 'Adatta alla larghezza',
  [T.print]: 'Stampa',
  [T.fileSize]: 'Dimensione del file',
  [T.keywords]: 'Parole chiave',
  [T.pdfProducer]: 'Produttore PDF',
  [T.pdfVersion]: 'Versione PDF',
  [T.pageCount]: 'Numero di pagine',
  [T.pageSize]: 'Dimensione della pagina',
  [T.fastWebView]: 'Visualizzazione web veloce',
  [T.yes]: 'Sì',
  [T.no]: 'No',
  [T.documentProperties]: 'Proprietà del documento',
  [T.pageNumber]: 'Numero di pagina',
  [T.previousPage]: 'Pagina precedente',
  [T.nextPage]: 'Pagina successiva',
  [T.documentNavigation]: 'Navigazione del documento',
  [T.thumbnails]: 'Miniature',
  [T.outline]: 'Struttura',
  [T.currentZoom]: 'Zoom corrente',
  [T.twoPageView]: 'Visualizzazione a due pagine',
  [T.noFileOpen]: 'Nessun file aperto',
  [T.closeTab]: 'Chiudi {{name}}',
  [T.pageWithNumber]: 'Pagina {{page}}',
  [T.creatingLink]: 'Creazione del link in corso',
  [T.shareChatLinkDisclaimer]:
    'Chiunque disponga di questo link può visualizzare la conversazione. I nuovi messaggi non saranno visibili. Evita di condividere informazioni private o sensibili se non ti fidi della persona.',
  [T.shareUsingCopyLink]: 'Condividi copiando il link',
  [T.onlyMessagesUpToThisPoint]:
    'Verranno condivisi solo i messaggi fino a questo punto.',
  [T.sessionIsPrivate]: 'Questa sessione è privata',
  [T.sharedSessionReadOnlyNotice]:
    'Stai visualizzando un’istantanea in sola lettura condivisa con te. La modifica, la rigenerazione e la valutazione dei messaggi sono disattivate.',
  [T.viewMoreFilesCount]: 'Mostra altri file ({{count}})',
  [T.openSource]: 'Apri {{name}}',
  [T.performedOneStep]: 'Eseguito 1 passaggio',
  [T.performedStepsCount]: 'Eseguiti {{count}} passaggi',
  [T.script]: 'Script',
  [T.searchingTheWorkspaces]: 'Ricerca negli spazi di lavoro',
  [T.searchingTheWeb]: 'Ricerca sul web',
  [T.runningAScript]: 'Esecuzione di uno script',
  [T.executingTheCode]: 'Esecuzione del codice',
  [T.deepResearch]: 'Ricerca approfondita',
  [T.callingASubAgent]: 'Chiamata a un sub-agente',
  [T.checkingFiles]: 'Controllo dei file',
  [T.toolSearch]: 'Ricerca di strumenti',
  [T.waitingForConfirmation]: 'In attesa di conferma',
  [T.failedDoingAction]: 'Azione non riuscita',
  [T.working]: 'Elaborazione in corso',
  [T.suggestedQuestions]: 'Domande suggerite',
  [T.hiHowCanIAssistYouToday]: 'Ciao, come posso aiutarti oggi?',
  [T.howCanIAssistYouToday]: 'Come posso aiutarti oggi?',
  [T.askAnythingAboutProject]:
    'Chiedi qualsiasi cosa su {{projectName}} e sulla sua base di conoscenza.',
  [T.assistantUpdatedByController]:
    "Il controller ha aggiornato l'assistente, quindi la tua esperienza potrebbe variare.",
  [T.assistantModelDisabledMessage]:
    "L'amministratore ha disattivato il modello di IA dell'assistente. Gli utenti controller possono assegnare un nuovo modello, ma per ora ti passiamo a {{model}}.",
  [T.latestAndMostUsedModelNamed]:
    'il nostro modello di IA più recente e più utilizzato, {{model}}',
  [T.latestAndMostUsedModel]:
    'il nostro modello di IA più recente e più utilizzato',
  [T.assistantFilesNoPermission]:
    "Non hai l'autorizzazione per chattare con alcuni file della base di conoscenza di questo assistente.",
  [T.assistantFilesLimitedAccess]:
    'Il tuo accesso alla sua base di conoscenza è limitato, quindi le risposte potrebbero essere ridotte.',
  [T.assistantFilesLimitedAccessLong]:
    "Il tuo accesso alla base di conoscenza dell'assistente è limitato, quindi le risposte potrebbero essere ridotte di conseguenza!",
  [T.assistantUpdatedByCreator]:
    "L'assistente è stato aggiornato dal suo creatore, forse a causa di file eliminati o di nuovi file aggiunti. Le risposte rifletteranno queste modifiche.",
  [T.assistantUpdatedByCreatorShort]:
    'È stato aggiornato dal suo creatore – potrebbero essere stati aggiunti o rimossi dei file – quindi le risposte rifletteranno tali modifiche.',
  [T.reconnectingToChatService]:
    'Riconnessione al servizio di chat in corso (tentativo {{attempt}})…',
  [T.chatConnectionLost]:
    'Connessione al servizio di chat persa. Il tuo prossimo messaggio ristabilirà la connessione: fino ad allora le risposte potrebbero non essere trasmesse in streaming.',
  [T.attachmentUploadFailed]: 'Caricamento non riuscito',
  [T.skippedFilesWarning]:
    'Alcuni file sono stati ignorati perché non supportati, troppo grandi, oltre il limite di allegati o non è stato possibile caricarli.',
  [T.openingEllipsis]: 'Apertura in corso…',
  [T.citationSourcePending]:
    'Le fonti saranno disponibili al termine della risposta.',
  [T.citationSourceUnresolved]:
    'La fonte di questa citazione non è indicata in questa risposta.',
  [T.citationSourceReadOnly]: 'Le fonti non possono essere aperte qui.',
  [T.openCitation]: 'Apri la citazione {{label}}: {{name}}',
  [T.citationWithTitle]: 'Citazione {{label}} – {{title}}',
  [T.viewSource]: 'Visualizza il sorgente',
  [T.viewDiagram]: 'Visualizza il diagramma',
  [T.downloadDiagram]: 'Scarica il diagramma',
  [T.copyCode]: 'Copia il codice',
  [T.waitForResponseToFinish]: 'Attendi il completamento della risposta',
  [T.filesAreStillUploading]: 'I file sono ancora in fase di caricamento',
  [T.filesAreStillBeingProcessed]: 'I file sono ancora in fase di elaborazione',
  [T.waitForBothAnswersToFinish]:
    'Attendi il completamento di entrambe le risposte',
  [T.pickModelForEachColumn]:
    'Scegli un modello per ogni colonna da confrontare',
  [T.nameYourAssistantToTryItOut]:
    'Assegna un nome al tuo assistente per provarlo',
  [T.pickAModelToTryItOut]: 'Scegli un modello per provarlo',
  [T.assistantModelDisabledClause]:
    'Il suo modello di IA è stato disattivato, quindi ti abbiamo passato a {{model}}.',
  [T.hiComma]: 'Ciao,',
  [T.assistantActionsAriaLabel]: '{{name}} – azioni dell’assistente',
  [T.shareChatTrustTitle]: 'Ti fidi della persona con cui stai condividendo?',
  [T.shareProjectTitle]: "Stai condividendo l'intero progetto",
  [T.feedbackDislikeTitle]:
    'Cosa non ti \u00e8 piaciuto di questa risposta? (facoltativo)',
  [T.developerRelease]: 'versione per sviluppatori',
  [T.totalDocumentsProcessed]: 'Documenti totali · {{percent}}% elaborati',
  [T.moreCount]: 'altri {{count}}+',
  [T.aiModelsInfo]:
    'Ogni chat di questo periodo, suddivisa in base al modello di IA che ha risposto.',
  [T.chatTabLabel]: 'Chat',
  [T.chatsPerDayAvg]: 'Chat al giorno (media)',
  [T.activeMembersWithChat]: 'Membri attivi (1+ chat)',
  [T.chatKnowledge]: 'Conoscenza chat',
  [T.chatKnowledgeInfo]:
    'Le chat sono le conversazioni avviate; i messaggi sono le singole domande al loro interno. Un giorno intenso può avere poche chat ma molti messaggi.',
  [T.dailyActivity]: 'Attività giornaliera',
  [T.lessLabel]: 'Meno',
  [T.moreLabel]: 'Più',
  [T.chatsByModules]: 'Chat per moduli',
  [T.chatsByModulesInfo]:
    'Numero di volte in cui la chat è stata utilizzata in ciascun modulo. Ad esempio in Chat, all’interno di Progetti, tramite Assistenti, oppure da Smart Meet e Workflow.',
  [T.moduleColumn]: 'Modulo',
  [T.toolUsage]: 'Utilizzo strumenti',
  [T.toolUsageInfo]:
    'Strumenti utilizzati nelle chat del tuo team. Gli strumenti a cui l’assistente ha fatto ricorso durante la generazione delle risposte, giorno per giorno. Riflette ciò che ha generato la risposta, non ciò che l’utente ha digitato.',
  [T.enterpriseSearch]: 'Ricerca aziendale',
  [T.moreOthers]: 'Altri',
  [T.documentsInfo]:
    'Quanti documenti sono stati elaborati nel tuo workspace. I documenti elaborati sono pronti per la ricerca e la citazione; quelli non elaborati sono ancora in fase di lettura.',
  [T.appsInfo]:
    'Utilizzo delle app integrate in questo periodo, con la variazione rispetto al periodo precedente.'
};

export default itJson;
